// Code generated by balancegen from data/presentation/presentation.toml,
// sfx.toml, chart.toml, themes.toml, keybindings.toml, effects.toml,
// achievements.toml, combat.toml, gather.toml, anchor.toml,
// holdfire.toml, reload.toml, factionmarks.toml and detonation.toml.
// DO NOT EDIT.
// Regenerate with scripts/gen-data.sh.
//
// The client-only lane (R312): render tuning that
// ui-map-interface.md cites, the cue table of audio.md §4.6, and
// every key the client answers (ui-map-interface.md §9, R853).
// The server does not know these values; a change here changes the
// look and answers to the visual-parity rule.

// The bioluminescent wake (R101, ui-map-interface.md §7).
export const WAKE_LIFE_SEC = 2;
export const WAKE_SPAWN_PX = 9;
export const WAKE_MIN_SPEED = 4;
export const WAKE_MAX = 220;
export const WAKE_JITTER_PX = 3.5;
export const WAKE_ALPHA = 0.5;
export const WAKE_COLOR = 0x86f7d0;
export const WAKE_SIZE_PX = 11;

// The pressure haze (R101, ui-map-interface.md §7).
export const HAZE_DEPTH_FRAC = 0.16;
export const HAZE_FAR_FRAC = 0.55;
export const HAZE_OVERHANG_FRAC = 0.06;
export const HAZE_NEAR_ALPHA = 0.18;
export const HAZE_FAR_ALPHA = 0.09;
export const HAZE_BANDS = 4;
export const HAZE_DRIFT_PX = 16;
export const HAZE_DRIFT_PERIOD_SEC = [47, 61];
/** The haze colour, as the rgba() prefix the layer builds a ramp on. */
export const HAZE_COLOR = 'rgba(46,86,112,';

// The casino's animation figures (casino.md §9). The wheel is drawn
// once and turned by one transform write; the reels stop one after
// another; the turn timer is one style write per table frame.
export const CASINO_WHEEL_MS = 4000;
export const CASINO_BALL_MS = 4000;
/** When the ball cue sounds after the spin starts, so the clip ends
 * with the drop (audio.md §4.9). */
export const CASINO_BALL_CUE_MS = 2000;
export const CASINO_REEL_MS = 900;
export const CASINO_REEL_STAGGER_MS = 300;
export const CASINO_TIMER_WARN_FRAC = 0.25;
export const CASINO_TIMER_FADE_MS = 200;
export const CASINO_BALL_SPINS = 4;
export const CASINO_CHIP_STEPS: readonly number[] = [1, 2, 5, 10];
/** The big payout cue: a move of at least this many stakes plays
 * `sfx-casino-payout` in place of the win cue (audio.md §4.9, R3143). */
export const CASINO_PAYOUT_STAKE_MULT = 5;
/** The symbol, as its index in CASINO_SYMBOLS, whose three of a kind
 * make the jackpot line `kraken_three`: it plays `sfx-casino-jackpot` (R3143). */
export const CASINO_JACKPOT_SYMBOL = 0;
/** The win flash on what won and on the result tag (R2115). */
export const CASINO_FLASH_MS = 600;
/** How long before the turn deadline a fold the reader did not send
 * still reads as the timeout fold of the table (R2142). */
export const CASINO_TIMEOUT_SLACK_MS = 2000;
/** The faction club (R2165): the badge of the club head, of the wheel
 * hub and of a casino seat, in px, and the share of the cells under
 * which a roster segment states no percent. */
export const CASINO_CLUB_BADGE_PX = 30;
export const CASINO_HUB_BADGE_PX = 26;
export const CASINO_SEAT_BADGE_PX = 12;
export const CASINO_ROSTER_LABEL_PCT = 12;

/** The core dock's queue strip (R1202): the open strip takes at most
 * this share of the dock, and folds to one line when its room cannot
 * show this number of jobs (R1221). */
export const QUEUE_OPEN_SHARE = 0.5;
export const QUEUE_SMALL_SHARE = 0.25;
export const QUEUE_MIN_OPEN_JOBS = 2;

/** The closing line of the sea trials stands this long, then the card
 * goes (player-reach.md §8.1, R1572). */
export const TRIALS_CLOSING_MS = 6000;

/** The release of the first frame when the welcome card closes: the gap
 * between two held items, and how many toasts the hold keeps (R2127). */
export const WELCOME_RELEASE_GAP_MS = 700;
export const WELCOME_HELD_NOTICES = 3;

/** The Data Core card warns when more than this share of one core is
 * lost on the active node (R1458, tech-tree.md §1). */
export const DATA_CORE_WASTE_WARN_SHARE = 0.5;

/** The AUTO look of the notices keeps at most this many lines at the
 * right under the readout line (R1753, card 16 of round 082). */
export const ALARM_NOTICE_LINES = 2;

/** The siege window on the game screen: the lead in world seconds at which
 * a window that concerns the reader takes the time cell, the reach of "near
 * the target" in world px, and the rest of RALLY in wall ms. */
export const SIEGE_WINDOW = { slotSec: 10800, nearPx: 160, rallyRestMs: 8000 } as const;

/** Every order the fleet card knows (ui-map-interface.md §8). */
export const ORDER_IDS = ['fire', 'scan', 'gather', 'share', 'anchor', 'deep_run', 'patrol', 'hunt', 'defend', 'return', 'move', 'escort', 'hold_fire', 'decoy', 'auto_field', 'plot', 'lay', 'collect', 'search'] as const;
export type OrderId = typeof ORDER_IDS[number];

/** The order row of a fleet card (`[presentation.orders]`): the action
 * press of each class, the fallback chain, the quiet orders, the order
 * that takes the first quiet slot on a hull with no gun, and the ⋯ order. */
export const ORDERS: {
  readonly action: Readonly<Record<string, OrderId>>;
  readonly fallback: readonly OrderId[];
  readonly quiet: readonly OrderId[];
  readonly noGun: OrderId;
  readonly more: readonly OrderId[];
} = {
  action: {
    basilisk: 'fire',
    beacon: 'anchor',
    bombard: 'deep_run',
    commodore: 'hold_fire',
    corsair: 'deep_run',
    cutlass: 'deep_run',
    dredger: 'gather',
    falconet: 'fire',
    gulper: 'hold_fire',
    lancer: 'fire',
    murkhide: 'hold_fire',
    myriad: 'hold_fire',
    oracle: 'share',
    quillback: 'hold_fire',
    sapper: 'lay',
    sentinel: 'anchor',
    tender: 'anchor',
    thrummer: 'hold_fire',
    vedette: 'scan',
  },
  fallback: ['deep_run', 'plot', 'patrol'],
  quiet: ['hunt'],
  noGun: 'return',
  more: ['move', 'plot', 'patrol', 'escort', 'return', 'hold_fire', 'deep_run', 'decoy', 'auto_field', 'gather', 'search', 'lay', 'collect', 'scan', 'share', 'anchor', 'fire', 'hunt', 'defend'],
};

/** The chip of each condition key of the wire (`[presentation.conditions]`,
 * v2-the-deep.md §18.2): its glyph, its tone, whether it costs hull and how
 * it writes its figure (R2616), keyed by the number of `ConditionKey`.
 * The words are `cond_<key>`. */
export const CONDITIONS: Readonly<Record<number, { readonly key: string; readonly icon: string; readonly tone: 'bad' | 'good' | 'neutral'; readonly hull: boolean; readonly figure: 'factor' | 'share' | 'wear' | 'aura' }>> = {
  1: { key: 'ghost', icon: "○", tone: 'good', hull: false, figure: 'factor' },
  2: { key: 'anchor', icon: "■", tone: 'neutral', hull: false, figure: 'factor' },
  3: { key: 'slow', icon: "▼", tone: 'bad', hull: false, figure: 'factor' },
  4: { key: 'echo', icon: "◎", tone: 'bad', hull: false, figure: 'factor' },
  5: { key: 'deep_run', icon: "▽", tone: 'neutral', hull: false, figure: 'factor' },
  6: { key: 'terrain', icon: "≈", tone: 'neutral', hull: false, figure: 'factor' },
  7: { key: 'signature', icon: "◆", tone: 'neutral', hull: false, figure: 'factor' },
  8: { key: 'harbour', icon: "□", tone: 'good', hull: false, figure: 'factor' },
  9: { key: 'lane', icon: "▲", tone: 'good', hull: false, figure: 'factor' },
  10: { key: 'net', icon: "#", tone: 'bad', hull: false, figure: 'factor' },
  11: { key: 'wire', icon: "×", tone: 'bad', hull: false, figure: 'factor' },
  12: { key: 'pressure', icon: "↓", tone: 'bad', hull: true, figure: 'wear' },
  13: { key: 'drift', icon: "→", tone: 'neutral', hull: false, figure: 'share' },
  14: { key: 'command', icon: "★", tone: 'good', hull: false, figure: 'aura' },
  15: { key: 'screen', icon: "◌", tone: 'good', hull: false, figure: 'factor' },
  16: { key: 'surge', icon: "»", tone: 'good', hull: false, figure: 'factor' },
};

/** The six group slots (round 085 cards 10, 12 A, 13, 14): the letters of
 * a short name, the seconds of UNDO, the row of a telephone, and the bar of
 * a desktop with the screen width that shows the whole name, and the extra
 * hold of a long press that replaces another fleet on the row (R2415). */
export const GROUP_SLOTS_UI = { shortNameLen: 5, undoSec: 4, rowHPx: 44, barHPx: 32, barSlotPx: 112, barSlotWidePx: 168, barWideMinPx: 1600, overrideHoldMs: 1000 } as const;

/** The captain row (round 091 card 05, R1889): the row height of a desktop
 * and of a telephone, the portrait and one cell of the ability strip, in
 * chrome px. */
export const CAPTAIN_ROW = { rowPx: 56, rowSheetPx: 64, portraitPx: 28, cellPx: 20 } as const;

/** The anchored peek (round 084 card 02): its offset off the object on a
 * desktop, its gap clear of a finger, the hysteresis of a change of side
 * and the gutter it keeps inside the clear map, in chrome px. */
export const SCAN = { fadeShare: 0.25 } as const;

/** The route profile of an own fleet card (round 088 card 05, R2616): the
 * section in chrome px, and the band read every sample_px world px, at
 * most samples_max times. */
export const ROUTE_PROFILE = { wPx: 276, hPx: 64, samplePx: 12, samplesMax: 240 } as const;

/** The commission mark on the map (v2-the-deep.md §14.6, round 088 card 15,
 * R2645): a pennant on a staff in the own faction ink, `hPx` world px high;
 * an open offer of the board at `openAlpha`, a taken one solid. */
export const COMMISSION_MARK = { hPx: 18, flagWPx: 12, flagHPx: 8, staffPx: 1.7, openAlpha: 0.6, maxMarks: 16 } as const;

/** The hatch of unsurveyed water (v2-the-deep.md §4.1, chart card 20, round
 * 088 card 06, R2626): a veil in the deep ink and diagonal lines in the text
 * ink, `spacingPx` world px apart and `linePx` CSS px wide, which fade out
 * while two lines stand under `fadePx` CSS px apart. */
export const SURVEY_HATCH = { veilInk: 0x020b12, veilAlpha: 0.38, lineInk: 0xa3cfe6, lineAlpha: 0.1, lineAlphaHistorical: 0.12, spacingPx: 9, linePx: 1, fadePx: 4 } as const;

/** The guard look (R2080, ui-map-interface.md §6.3.6): the round kill
 *  and the cooldown marks of mockup round 099 card 04 with the snap of
 *  card 01. Times are wall seconds, lengths world px at zoom 1. */
export const GUARD = {
  snapSec: 0.14,
  snapAlpha: 0.75,
  snapWidthPx: 1,
  closeSec: 0.18,
  closeFromPx: 6,
  closeToPx: 2,
  closeAlpha: 0.95,
  flashSec: 0.07,
  flashPx: 3,
  flashAlpha: 0.7,
  crossSec: 0.42,
  crossPx: 3,
  crossAlpha: 0.9,
  strokePx: 1.2,
  minScreenPx: 1,
  ghostNosePx: 4.5,
  ghostTailPx: 3.5,
  ghostWingPx: 1.8,
  ghostCorePx: 1.1,
  ghostAlpha: 0.95,
  legShare: 0.45,
  legMinPx: 2,
  structureSizePx: 16,
  pipGapPx: 3,
  pipPx: 4.5,
  pipGroundAlpha: 0.6,
  pipRimAlpha: 0.5,
  pipFillAlpha: 0.85,
  pipReadyAlpha: 0.9,
  pipIdleAlpha: 0.5,
  watchReaches: 2,
  trackPx: 5,
  trackGrowPx: 6,
  trackAlpha: 0.85,
  blockedPx: 7,
  blockedAlpha: 0.8,
  blockedDashPx: 2,
} as const;

/** The signature order looks (R2408, ui-map-interface.md §6.1.12): the
 *  snap ring of mockup round 105 card 01, the six order looks and the
 *  deep run shroud (R2409). Times are wall seconds, lengths world px at
 *  zoom 1, angles degrees. */
export const SIGNATURE = {
  spendSec: 0.9,
  endSec: 0.5,
  cullPadPx: 48,
  snapFromPx: 11,
  snapToPx: 41,
  snapGrowShare: 0.5,
  snapAlpha: 0.95,
  snapWidthPx: 3.4,
  snapThinPx: 0.6,
  echoAfterShare: 0.12,
  echoToPx: 30,
  echoGrowShare: 0.6,
  echoAlpha: 0.45,
  echoWidthPx: 1,
  flashPx: 13,
  flashShare: 0.3,
  flashAlpha: 0.26,
  holdPx: 17,
  holdWidthPx: 1.6,
  holdTrackAlpha: 0.14,
  holdArcAlpha: 0.85,
  holdDashCount: 12,
  holdDashFill: 0.56,
  holdDashAlpha: 0.6,
  holdDashWidthPx: 1.4,
  holdDashTurnPxPerSec: 6,
  endToPx: 8,
  endAlpha: 0.8,
  endFlashPx: 6,
  endFlashShare: 0.3,
  endFlashAlpha: 0.4,
  laneWidthPx: 5,
  laneAlpha: 0.16,
  lanePoints: 28,
  laneGrowSec: 0.4,
  laneFadeSec: 0.2,
  laneArrivePx: 4,
  sternMarkPx: 4,
  sternMarkAlpha: 0.8,
  sternMarkWidthPx: 1.2,
  sternMarkClearPx: 1.5,
  ghostGapPx: 7,
  ghostSamplePx: 0.5,
  ghostStillSec: 2.5,
  ghostFadeSec: 0.3,
  ghostAlphaNear: 0.5,
  ghostAlphaMid: 0.3,
  ghostAlphaFar: 0.15,
  tracePx: 25,
  traceSec: 0.6,
  traceAlpha: 0.75,
  traceWidthPx: 1.4,
  traceHeadPx: 5,
  clampBearingDeg: 46,
  clampHalfDeg: 22,
  clampFromPx: 27,
  clampToPx: 13,
  clampCloseSec: 0.3,
  clampOpenPx: 5,
  clampAlpha: 0.92,
  clampWidthPx: 1.8,
  clampTickPx: 3.5,
  glanceFromPx: 13,
  glanceLenPx: 4,
  glanceGrowPx: 14,
  glanceTurnDeg: 63,
  glanceSec: 0.3,
  glanceAlpha: 0.9,
  glanceWidthPx: 1.2,
  irisHalfDeg: 36,
  irisOpenSec: 0.35,
  irisCloseSec: 0.3,
  irisRimAlpha: 0.85,
  irisRimWidthPx: 1.5,
  irisEdgeAlpha: 0.5,
  irisEdgeWidthPx: 1,
  pelletCount: 7,
  pelletSpreadDeg: 4.3,
  pelletFromPx: 6,
  pelletReachPx: 30,
  pelletSec: 0.35,
  pelletPx: 1.15,
  pelletAlpha: 0.95,
  pelletHaloPx: 2.2,
  pelletHaloAlpha: 0.35,
  muzzleAtPx: 12,
  muzzlePx: 4,
  muzzleShare: 0.4,
  muzzleAlpha: 0.8,
  shotMatchPx: 12,
  chevronTipPx: 21,
  chevronBackPx: 17,
  chevronHalfPx: 3.6,
  chevronWidthPx: 1.6,
  chevronAlpha: 0.9,
  chevronStepSec: 0.15,
  chevronTurnSec: 0.35,
  chevronFoldSec: 0.4,
  rearCloseSec: 0.5,
  portCount: 4,
  portAftPx: 5,
  portStepPx: 3.5,
  portSidePx: 4.8,
  portPx: 1.1,
  portAlpha: 0.95,
  portHaloPx: 2.4,
  portHaloAlpha: 0.25,
  portGlowSec: 0.8,
  portFlashSec: 0.3,
  portFlashFromPx: 2,
  portFlashGrowPx: 5,
  portFlashSpreadDeg: 23,
  portFlashAlpha: 0.85,
  portFlashWidthPx: 1,
  foeReachPx: 150,
  diveFadeSec: 0.5,
  diveHullAlpha: 0.32,
  diveDotOnPx: 1,
  diveDotOffPx: 2.5,
  footShrinkSec: 0.8,
  footGrowSec: 0.6,
  footAlpha: 0.5,
  footWidthPx: 1.2,
  footDotOnPx: 1.5,
  footDotOffPx: 3,
  footEchoNear: 1.25,
  footEchoFar: 1.55,
  footEchoAlpha: 0.18,
  footEchoWidthPx: 1,
  footEndSec: 0.6,
  getawayCrateCount: 6,
  getawayCrateSec: 1.2,
  getawayCratePx: 2.2,
  getawayCrateFromPx: 6,
  getawayCrateDriftPx: 12,
  getawayCrateSpreadDeg: 28,
  getawayCrateSpinDeg: 90,
  getawayCrateSinkShare: 0.4,
  getawayCrateAlpha: 0.9,
  getawayWakeFromPx: 7,
  getawayWakeLenPx: 22,
  getawayWakeSpreadDeg: 9,
  getawayWakeWidthPx: 1.4,
  getawayWakeAlpha: 0.6,
  getawayWakeInSec: 0.4,
  getawayWakeOutSec: 0.5,
  shroudPx: 24,
  shroudAlpha: 0.72,
  shroudInSec: 0.4,
  shroudOutSec: 0.5,
  bubbleCount: 5,
  bubbleSec: 0.7,
  bubbleAlpha: 0.8,
  bubbleAftPx: 4,
  bubbleStepPx: 2.2,
  bubbleUpPx: 3,
  bubbleRisePx: 6,
  bubbleRiseStepPx: 3,
  bubblePx: 0.9,
  bubbleOddPx: 1.4,
  bubbleWidthPx: 0.8,
} as const;

export const PEEK = { offsetPx: 80, fingerGapPx: 56, hysteresisPx: 40, gutterPx: 12 } as const;

/** The dashed outline of the hovered cell while a peek stands (R1875,
 * §8 "The peek"): its screen width in px, its alpha, its dash and gap in
 * screen px and the text ink, the ink of the peek's leader. */
export const PEEK_CELL = { width: 1, alpha: 0.55, dashPx: 4, gapPx: 3, color: 0xa3cfe6 } as const;

/** The ECONOMY · PRODUCTION income graphs (R1489): the moving average
 * in samples, the gap in sample intervals that breaks a line (R251),
 * the viewBox of one graph, and the band over the plot that holds the
 * axis figure (R1570). */
export const PRODUCTION_SMOOTH_SAMPLES = 5;
export const PRODUCTION_GAP_INTERVALS = 1.8;
export const PRODUCTION_CHART_W = 320;
export const PRODUCTION_CHART_H = 72;
export const PRODUCTION_LABEL_BAND = 14;

/** SINCE YOU LEFT and the DIGEST (inbox.md §7, R1851): the viewBox of the
 * spark of a figure cell and of one chart, the hours of one slot of a
 * chart of hour rows, and the most slots one chart draws. */
export const DIGEST = { sparkW: 54, sparkH: 15, chartW: 260, chartH: 64, slotHours: 3, maxSlots: 14 } as const;

/** The season summary card (R1518, ui-map-interface.md §3.4): how many
 * rows of the locked table it states before the reader's own row. */
export const SEASON_SUMMARY_RANK_ROWS = 5;
/** How many achievement lines the card states before the line that
 * counts the rest (R1519). */
export const SEASON_SUMMARY_ACH_ROWS = 10;
/** How long the game chrome fades out when a summary arrives in a
 * running session, in ms (R1519). */
export const SEASON_SUMMARY_CHROME_FADE_MS = 600;
/** How long the chrome stays hidden after a hello of the same world and
 * season, while the summary comes again, in ms (R1519). */
export const SEASON_SUMMARY_VEIL_HOLD_MS = 3000;
/** The height of the hex mark of the top three in a ranking row, in
 * px (R1519). */
export const SEASON_SUMMARY_MEDAL_PX = 12;
export const SEASON_SUMMARY_MEDAL_FIGURE_PX = 9;
/** How many captains YOU CARRY names before a line "+n MORE" counts
 * the rest (R2089). */
export const SEASON_SUMMARY_CARRY_ROWS = 8;

/** The welcome card (R2120, player-reach.md §8.5): how many of the
 * nearest other holds its NEIGHBOURS list names. */
export const WELCOME_NEIGHBOURS = 3;

/** The season timelapse players (R1620, ui-map-interface.md §3.6): the
 * owner frames a second at ×1, the speeds the speed button steps
 * through, and the longest clock step one animation frame pays, in ms. */
export const TIMELAPSE_FPS = 4;
export const TIMELAPSE_SPEEDS: readonly number[] = [1, 2, 4];
export const TIMELAPSE_MAX_STEP_MS = 250;
/** The small map of the summary card and of the public reader, in CSS px. */
export const TIMELAPSE_SUMMARY_MAP_PX = 210;
export const TIMELAPSE_READER_MAP_PX = 230;
/** The marks under a scrubber: the card and the reader, and WAR. */
export const TIMELAPSE_TICKS = 5;
export const TIMELAPSE_WAR_TICKS = 4;
/** The ink of the small map: the faction wash, the owner line, the ridge. */
export const TIMELAPSE_CELL_ALPHA = 0.24;
export const TIMELAPSE_EDGE_ALPHA = 0.95;
export const TIMELAPSE_RIDGE_INK = 0x0d1d29;

/** The section shell of the hub (ui-map-interface.md §16.16): the
 * figures of `[presentation.hub_sections]`. `hub.css` takes the column
 * and the grid figures at generation time; a test reads them here. */
export const HUB_SECTIONS = {
  boxMinPx: 840,
  gapPx: 20,
  columnPx: 280,
  columnLargePx: 300,
  cardMinPx: 330,
  roomPx: 1140,
  roomLargePx: 1160,
  hubMaxPx: 1280,
  roomMarginPx: 24,
  recordReachRows: 3,
  recordNewestBadges: 4,
  recordVolumeRows: 6,
  ranksNearRows: 2,
  wardroomDossierPx: 120,
  wardroomStripPortraits: 5,
  liveryColsWide: 5,
  liveryColsNarrow: 3,
  liveryWidePx: 520,
  liveryTileScale: 2,
  liverySideScale: 4,
} as const;

/** How long one meta API call waits for an answer, in ms (R1203). */
export const API_TIMEOUT_MS = 12000;
/** The request retry of a safe request (R1706, ui-map-interface.md §16.12). */
export const REQUEST_FIRST_TIMEOUT_MS = 4500;
export const REQUEST_BACKOFF_MS = 500;
export const REQUEST_BACKOFF_MAX_MS = 4000;
export const REQUEST_BUDGET_MS = 24000;
export const REQUEST_MIN_ATTEMPT_MS = 1000;
/** The keep-alive read of a visible page, in ms. */
export const KEEPALIVE_MS = 20000;
/** How long a navigation may stand before the client navigates again. */
export const NAV_RETRY_MS = 5000;
/** The latency Ping of the world socket, in ms, and the Pings in a row
 * with no Pong that close a half-dead socket (R2829). */
export const PING_EVERY_MS = 2000;
export const PONG_MISS_MAX = 7;
/** The first wait and the ceiling of the reconnect backoff of the world socket, in ms (R2829). */
export const SOCKET_BACKOFF_MS = 500;
export const SOCKET_BACKOFF_MAX_MS = 10000;
/** The first wait and the ceiling of the reconnect backoff of the clan chat socket, in ms (R3016). */
export const CLAN_CHAT_BACKOFF_MS = 500;
export const CLAN_CHAT_BACKOFF_MAX_MS = 10000;

/** Photo mode (R1623, ui-map-interface.md §13.1): the zoom range while it
 * is on, past the camera's own range at both ends (R1624). */
export const PHOTO_MIN_ZOOM = 0.12;
export const PHOTO_MAX_ZOOM = 4;
/** The mark of a saved picture, in px of a picture whose long side is
 * PHOTO_MARK.basePx; the mark scales by the long side (R1625). */
export const PHOTO_MARK = {
  basePx: 900, padPx: 16, blockPx: 30, signPx: 28, textPx: 36,
  titlePx: 12, titleTrack: 3.5, titleY: 9, titleAlpha: 0.95,
  linePx: 9, lineTrack: 1.6, lineY: 24, lineAlpha: 0.8,
  shadePx: 300, shadeAlpha: 0.62,
} as const;
/** How long the line SAVED stands after a download, in ms. */
export const PHOTO_SAVED_MS = 4000;

/** The REPORT sheet (R1626, fault-reports.md §4.4): the client log
 * (R1627), the screenshot, the thumbnail, the device gap and the outbox
 * (R1628). */
export const REPORT_SHEET = {
  logLines: 200, logLineRunes: 300, chatFilterMinRunes: 4,
  shotMaxEdgePx: 1280, shotMinEdgePx: 320, shotStep: 0.75,
  thumbWPx: 52, thumbHPx: 34, deviceGapSec: 60, outboxRetrySec: 30, outboxMax: 3,
} as const;

/** The captain portrait (R1180, ui-map-interface.md §12): card 05 Thermal of
 * mockup round 058. `tilePx` is the hub tile, `rowPx` the game row; the
 * brackets, the reading and the faction dot draw from `gearMinPx` up.
 * `candidates` is the face count of the Captain Designer's grid. */
export const PORTRAIT = {
  tilePx: 26, rowPx: 40, gearMinPx: 33, maxDpr: 3, candidates: 12,
  rampAt: [0, 0.1, 0.24, 0.36, 0.52, 0.68, 0.83, 0.93, 1] as readonly number[],
  ramp: [0x030b12, 0x040f1a, 0x735ba6, 0xb18cff, 0xff5c8a, 0xffb454, 0xd8c66a, 0xefe8c3, 0xffffff] as readonly number[],
  gear: 0xffffff, gearAlpha: 0.6, textAlpha: 0.85,
  bands: 30, noise: 0.045, rowNoise: 0.03, scanDim: 0.88, vignette: 0.35,
  tempBase: 36.1, tempSteps: 17, tempDecline: 0.6,
  font: ["ui-monospace", "SFMono-Regular", "Menlo", "monospace"] as readonly string[],
} as const;

/** The shared cull rect margin (R192, ui-map-interface.md §10.7). */
export const CULL_MARGIN_PX = 80;

// The heatmap's shared alpha ladder (R133, ui-map-interface.md §14).
export const HEAT_ALPHA_LO = 0.12;
export const HEAT_ALPHA_HI = 0.68;

/** The neutral tint for anything unclaimed (ui-map-interface.md §2). */
export const NEUTRAL_COLOR = 0x88a0b0;
/** The white a mark with no team wears (arcade.md §4.9). */
export const MARKER_NEUTRAL = 0xffffff;
export const MARKER_NEUTRAL_CSS = '#ffffff';

// The chrome accent (ui-map-interface.md §2). One value in three
// shapes, because the canvas wants the integer, a stylesheet string
// wants the hex and an rgba() wants the channels. It is faction 1's
// colour and balancegen checks that, but it does not follow the
// faction the player wears: read factionColor where a mark must.
export const ACCENT_COLOR = 0x35e0d2;
export const ACCENT_CSS = '#35e0d2';
export const ACCENT_RGB = '53,224,210';
export const ACCENT_BRIGHT = 0xdffcf8;
export const ACCENT_BRIGHT_CSS = '#dffcf8';

// The chrome palette (ui-map-interface.md §2, R362). tokens.css
// declares these as the FIRST PAINT; ui/theme.ts overwrites them on
// the document root as soon as the settings and the faction are
// known. The eleven themed tokens are the shape theme.ts derives, so
// its faction-1 answer must equal this table.
export const PALETTE_TOKENS = {
  '--accent': '#35e0d2',
  '--accent-rgb': '53 224 210',
  '--text': '#a3cfe6',
  '--text-rgb': '163 207 230',
  '--dim': '#5e89a0',
  '--faint': '#4c7b93',
  '--faint-rgb': '76 123 147',
  '--panel-rgb': '6 22 35',
  '--sheet-rgb': '4 18 29',
  '--ink-rgb': '4 15 26',
  '--deep-rgb': '2 11 18',
} as const;

// The frozen verdict colours. A refusal, a confirmation and a price
// must look the same under every banner, so no theme turns these.
export const PALETTE_BAD = '#ff5c8a';
export const PALETTE_GOOD = '#7ee787';
export const PALETTE_GOLD = '#d8c66a';

// The two frozen chrome accents that are not verdicts (R381).
// Amber is what is fast and light, violet is what was paid for.
// Each collides with a banner colour on purpose, and neither
// reads the roster.
export const PALETTE_AMBER = '#ffb454';
export const PALETTE_VIOLET = '#b18cff';

// The NPC ink of the canvas (R1797, R2637, v2-the-deep.md §18.2 slot 2):
// the number twin of --npc and --npc-edge. The fleet layer tints an NPC
// hull with `color`; the atlas cell of a pirate bakes its inverse body
// in `edge` (R2874) and the ring of a monster its core in `edge` at
// `edgeAlpha`; the wreck piece draws a wreck of the NPC side in `color`.
export const NPC_INK = { color: 0xe8f3ff, edge: 0x020b12, edgeAlpha: 0.9 } as const;

/** The Aquaphobia sign (brand.md §1, R1644): the geometry of
 * [presentation.sign] in the 24-unit box, and the inks it reads. The
 * plate stops are [presentation.water] deep_top, deep_mid and deep_low,
 * and the ground of the square shape is [presentation.palette] ink.
 * `ui/sign.ts` is the one reader. */
export const SIGN = {
  glyphR: 12.12,
  plate: [[0, '#07223a'], [0.55, '#051829'], [1, '#020b12']],
  ground: '#040f1a',
  cuts: {
    full: {
      round: { r: 11.7, edge: 1.25 },
      square: { r: 10.2, edge: 1.25 },
      glyph: [[12, 3.4], [17.4, 18.6], [12, 16], [6.6, 18.6]],
      counter: [[12, 9.31], [13.67, 14], [10.33, 14]],
    },
    small: {
      round: { r: 12.12, edge: 1.5 },
      square: { r: 10.6, edge: 1.311881 },
      glyph: [[12, 2.9], [18, 19.5], [12, 16.7], [6, 19.5]],
      counter: [[12, 9.6], [13.95, 15], [10.05, 15]],
    },
  },
  /** The dev corner (brand.md §15, R2880): the legs on each shape, the
   * keyline in the ground ink, and the fill in [presentation.palette]
   * amber. */
  dev: { roundLeg: 10.5, squareLeg: 10, keyline: 1.6, ink: '#ffb454' },
} as const;

/** The header lockup (brand.md §2, R1645): every length is a fraction of
 * the sign box. `size` is the type size of the name, cap / faceCapEm.
 * The stylesheets read the same figures. */
export const LOCKUP = {
  cap: 0.44, gap: 0.25, clear: 0.5, trackEm: 0.3, weight: 500, faceCapEm: 0.73, size: 0.6027,
  minPx: 20, headerPx: 22, family: 'Aqua Lockup',
  /** The stacked lockup (brand.md §8): fractions of its sign box B. */
  stacked: { cap: 0.15, gap: 0.06, clear: 0.25, minPx: 64, size: 0.2055 },
  /** The tag line of a platform image (brand.md §7): fractions of the
   * cap height of the name, and the smallest tracking in em. */
  tag: { cap: 0.38, gap: 0.62, stackedGap: 0.7, minTrackEm: 0.06 },
  /** The DEV line of the dev identity (brand.md §15, R2880): `cap` and
   * `gap` of the cap height of the name, `tagCap` of the cap height of
   * the tag line, and the sting figures in its unit u. */
  dev: { word: 'DEV', trackEm: 0.22, cap: 0.5, tagCap: 1.5, gap: 0.7, stingCap: 0.3, stingDrop: 1.15 },
} as const;

// The terrain treatment (fast/layers/terrain.ts, ui-map-interface.md §4).
export const TERRAIN_RIDGE_FILL = { color: 0x16222c, alpha: 0.95 };
export const TERRAIN_RIDGE_RIM = { width: 1.5, color: 0x4a6274, alpha: 0.75 };
export const TERRAIN_RING_STEP = 0.155;
export const TERRAIN_RING_WIDTH = 1.2;
export const TERRAIN_RINGS = [
  { color: 0x2c3f4f, alpha: 0.55 },
  { color: 0x3d566a, alpha: 0.67 },
  { color: 0x587891, alpha: 0.79 },
  { color: 0x7fa2ba, alpha: 0.91 },
];
export const TERRAIN_TRENCH_FLOOR = { color: 0x03141f, alpha: 0.88 };
export const TERRAIN_TRENCH_RIM = { width: 1.6, color: 0x4f8ba6, alpha: 0.8 };
export const TERRAIN_VOID_COLOR = 0x000204;
export const TERRAIN_VOID_FEATHER_FROM = 0.66;
export const TERRAIN_VOID_FEATHER_STEP = 0.028;
export const TERRAIN_VOID_FEATHER_COUNT = 7;
export const TERRAIN_VOID_FEATHER_ALPHA = 0.19;
export const TERRAIN_VOID_CORE_INSET = 0.46;
/** The smallest void core, in cells of hex area. */
export const TERRAIN_VOID_MIN_CELLS = 3;
export const TERRAIN_TICK_MIN = 7;
export const TERRAIN_TICK_MAX = 12;
export const TERRAIN_TICK_ROOT = 0.55;
export const TERRAIN_TICK_ROOT_STYLE = { width: 1.7, color: 0x2f5f78, alpha: 0.75 };
export const TERRAIN_TICK_TIP_STYLE = { width: 0.9, color: 0x2f5f78, alpha: 0.35 };
export const TERRAIN_HACHURE_SEED = 0x100c0de;
/** The WebGL2 terrain plane's texel pitch in world px (R432). */
export const TERRAIN_FIELD_TEXEL_PX = 4;
/** The terrain field's kernel radius, as a multiple of HEX_SIZE. The
 * terrain pass, the territory pass and terrain-prep.ts hold this one
 * figure (fast/shaders/prelude.ts). */
export const TERRAIN_RADIUS_K = 1.8;
/** The EDT blend band in world px: field below the low figure, EDT
 * above the high one (fast/shaders/terrain.ts). */
export const TERRAIN_EDT_BLEND: readonly [number, number] = [4, 12];
/** The rim ticks of the default look (fast/shaders/terrain-styles.ts):
 * the chance a rim edge carries three ticks rather than two, and how far
 * outside the hex edge a tick starts, in world px. */
export const TERRAIN_TICK_THREE_CHANCE = 0.37;
export const TERRAIN_TICK_STANDOFF = 4;

// The designer's map surface (designer/render.ts, R268): the same
// inks as CSS strings, at the alphas the tool wants.
export const DESIGNER_WATER_FILL = '#0a2739';
export const DESIGNER_TRENCH_FILL = '#03141f';
export const DESIGNER_TRENCH_RIM = 'rgba(79, 139, 166, 0.45)';
export const DESIGNER_RIDGE_FILL = '#16222c';
export const DESIGNER_RIDGE_RIM = 'rgba(74, 98, 116, 0.75)';
export const DESIGNER_GRID_LINE = 'rgba(53, 224, 210, 0.09)';
export const DESIGNER_BRUSH_LINE = 'rgba(53, 224, 210, 0.85)';
export const DESIGNER_BRUSH_FILL = 'rgba(53, 224, 210, 0.14)';
export const DESIGNER_FIELD_RING = 'rgba(185, 199, 210, 0.35)';
export const DESIGNER_SYM_GUIDE = 'rgba(53, 224, 210, 0.4)';
export const DESIGNER_SYM_HATCH = 'rgba(53, 224, 210, 0.45)';
export const DESIGNER_NEUTRAL_FILL = '#88a0b0';
export const DESIGNER_FIELD_FILL = '#b9c7d2';

/**
 * The figures of the alternative terrain looks (R828,
 * ui-map-interface.md §4.4). `default` is not here: the
 * `TERRAIN_*` constants above are that look. Every length is a
 * world px, because the mockup the values come from is 1:1 with
 * the map.
 */
export const TERRAIN_STYLE_FIGURES = {
  'form': {
    ridge: {
      treatment: 'scarp',
      fill: 0x243544, fillAlpha: 1,
      rim: 0x16222c, rimWidth: 1.6, rimAlpha: 0.85,
      shadow: 0x00121c, shadowAlpha: 0.34, shadowOffset: [11, 14],
      flankOffset: [1.15, 1.5], flankAlphaDrop: 0.12,
      flank: [0x233748, 0x213443, 0x1e303e, 0x1a2a37, 0x152430, 0x101d28, 0x0b1620],
      crest: { color: 0x6f90aa, alpha: 0.8, width: 2, lift: 2.2 },
      hairline: { color: 0x8fb6cd, alpha: 0.35, width: 0.9, lift: 3.6 },
    },
    trench: {
      treatment: 'ramp', hachures: false,
      floor: 0x0d3444, floorAlpha: 0.92,
      rampStep: 0.185, ramp: [0x092634, 0x061c27, 0x02101a, 0x000406], rampAlpha: 1,
      wall: { color: 0x4f8ba6, alpha: 0.75, width: 1.8, lift: 2.5 },
      rim: { color: 0x061520, alpha: 0.9, width: 1.3, lift: 0 },
    },
  },
  'material': {
    ridge: {
      treatment: 'boulder',
      fill: 0x16222c, fillAlpha: 0.95,
      rim: 0x0d161e, rimWidth: 1.4, rimAlpha: 0.7,
      shadow: 0x00121c, shadowAlpha: 0.4, shadowOffset: [7, 9],
      chunkPitch: 12, chunkJitter: 0.35,
      chunkRMin: 5, chunkRMax: 11, chunkSquash: 0.85,
      chunk: 0x2b3d4d,
      chunkShadow: { color: 0x0b141c, alpha: 0.55, offset: [1.5, 2] },
      chunkLit: { color: 0x46617a, alpha: 0.55, width: 1, light: [0, -1] },
    },
    trench: {
      treatment: 'strata', hachures: false,
      floor: 0x03141f, floorAlpha: 0.9,
      shelf: { color: 0x2f6885, alpha: 0.5, width: 7, lift: 4 },
      bandStep: 0.13, band: 0x1e4256, bandWidth: 1.1,
      bandAlpha: [0.56, 0.5, 0.44, 0.38, 0.32, 0.26],
      dashOn: [6, 18], dashOff: [5, 14],
      litRim: { color: 0x4f8ba6, alpha: 0.55, width: 1.6, lift: 2.5 },
      rim: { color: 0x061520, alpha: 0.9, width: 1.3, lift: 0 },
    },
  },
} as const;

// The terrain lab's marks (terrainlab/render.ts, terrain-lab.md §7).
// The terrain itself wears the DESIGNER_* inks above.
export const TERRAINLAB = {
  objectFill: '#eafcfa',
  objectRim: '#05111a',
  anchorWidthPx: 2,
  fairwayLine: 'rgba(232, 241, 246, 0.85)',
  fairwayWidthPx: 2,
  fairwayDashPx: [8, 6] as readonly number[],
  markPx: [3, 9] as readonly number[],
  buoy: { port: '#e0453a', starboard: '#3fbf5f', mark: '#f2d23c', junction: '#f2d23c', band: '#05111a' },
  heatDefault: 0x5aa8ff,
  heat: { clearance: 0x5aa8ff, flow: 0xffc74d, height: 0x8fa6b4, narrows: 0xff5a4d } as Readonly<Record<string, number>>,
  territoryAlpha: 0.32,
  installationSonarAlpha: 0.3,
  pocketAlpha: 0.8,
  pocketWidthPx: 1.5,
  pocketDashPx: [5, 4] as readonly number[],
  fallback: '#ff5a4d',
  apronLine: 'rgba(234, 252, 250, 0.6)',
  regenMs: 100,
  hashMs: 150,
  toastMs: 2600,
  armMs: 2500,
  tapPx: 6,
  exportRevokeMs: 1000,
  npcMarkPx: [12, 26] as readonly number[],
  seamountLine: 'rgba(234, 252, 250, 0.75)',
  seamountWidthPx: 1.5,
  quietDen: '#ff5a4d',
  quietDashPx: [4, 3] as readonly number[],
  pointMarkPx: [10, 22] as readonly number[],
  huntInk: [0xf2b84b, 0xe8655a, 0x6f8cff, 0x4fd1a5, 0xb07cff] as readonly number[],
  huntAlpha: [0.16, 0.34] as readonly number[],
  huntEdgeRings: 2,
  sortieInk: 0x9fd8ff,
  sortieAlpha: 0.3,
  rangeInk: [0xff8a3d, 0x9a7bff, 0x7be08a, 0x5ad0ff, 0xff6fb5] as readonly number[],
  rangeAlpha: 0.45,
} as const;

// The battle lab page (battlelab/, battle-lab.md §5, R1298).
export const BATTLELAB = {
  hashMs: 150,
  toastMs: 2600,
  armMs: 2500,
  engineWaitMs: 10000,
  enginePollMs: 20,
  manyRuns: 20,
  fleetCountMax: 12,
  fleetsMax: 8,
  nameMax: 40,
  rollStep: 0.01,
  rollDecimals: 2,
  exportRevokeMs: 1000,
  tacticalScale: 60,
  tacticalScaleMax: 3600,
} as const;

/** One unit of a built-in scene of the sonar lab (sonar-lab.md §5.4). */
export interface SonarLabSceneUnit {
  id: string; kind: string; faction: number; x: number; y: number;
  class?: string; moving?: boolean; to?: readonly number[]; quietHand?: number;
  module?: readonly number[]; damp?: readonly number[]; typed?: string;
  toggles?: readonly string[]; station?: number;
}

/** One built-in scene of the sonar lab: a unit list and its flags. */
export interface SonarLabScene {
  id: string; depth: boolean; sapper: boolean; probe: string;
  units: readonly SonarLabSceneUnit[];
}

// The sonar lab page (sonarlab/, sonar-lab.md §5).
export const SONARLAB = {
  hashMs: 150,
  toastMs: 2600,
  armMs: 2500,
  engineWaitMs: 10000,
  enginePollMs: 20,
  exportRevokeMs: 1000,
  tapPx: 6,
  grabPx: 16,
  linePx: 8,
  hearHz: 10,
  patrolPxS: 60,
  patrolStep: 0.15,
  speeds: [0.5, 1, 2, 4] as readonly number[],
  speed: 1,
  fitPad: 0.25,
  fitMinPx: 480,
  unitsMax: 24,
  seed: 1337,
  scene: 'one_listener',
  size: 'small',
  rollStep: 0.01,
  rollDecimals: 2,
  markPx: [22, 44] as readonly number[],
  tagGapPx: 2,
  tagRowsMax: 4,
  thermoLine: 'rgba(143, 220, 236, 0.6)',
  thermoWidthPx: 1.5,
  fieldInk: '255, 107, 90',
  fieldAlpha: [0.16, 0.26, 0.36] as readonly number[],
  marginLine: 'rgba(255, 107, 90, 0.9)',
  marginWidthPx: 1.5,
  ringLine: 'rgba(111, 227, 255, 0.95)',
  ringWidthPx: 2,
  baffleFill: 'rgba(183, 156, 255, 0.18)',
  baffleLine: 'rgba(183, 156, 255, 0.8)',
  wakeLine: 'rgba(216, 238, 245, 0.55)',
  lineHeardAlpha: 0.85,
  lineDeafAlpha: 0.4,
  lineDashPx: [6, 5] as readonly number[],
  lineWidthPx: 1.5,
  patrolLine: 'rgba(232, 241, 246, 0.5)',
  patrolInk: '#e8f1f6',
  probeInk: '#eafcfa',
  pickInk: '#6fe3ff',
  buoyRim: 0x05111a,
  scenes: [{"id":"one_listener","depth":false,"sapper":true,"probe":"h2","units":[{"id":"h1","kind":"hull","faction":1,"x":0.47,"y":0.355,"class":"vedette"},{"id":"h2","kind":"hull","faction":2,"x":0.51,"y":0.355,"class":"cutlass","to":[0.47,0.355]}]},{"id":"under_way","depth":false,"sapper":true,"probe":"h3","units":[{"id":"h1","kind":"hull","faction":1,"x":0.47,"y":0.355,"class":"vedette"},{"id":"h2","kind":"hull","faction":2,"x":0.55,"y":0.335,"class":"cutlass","moving":true,"to":[0.55,0.375]},{"id":"h3","kind":"hull","faction":2,"x":0.39,"y":0.335,"class":"cutlass","to":[0.47,0.355]}]},{"id":"thermocline","depth":true,"sapper":true,"probe":"h2","units":[{"id":"h1","kind":"hull","faction":1,"x":0.3,"y":0.1,"class":"vedette"},{"id":"h2","kind":"hull","faction":2,"x":0.34,"y":0.11,"class":"corsair","moving":true,"to":[0.15,0.11]}]},{"id":"baffles","depth":false,"sapper":true,"probe":"h2","units":[{"id":"h1","kind":"hull","faction":1,"x":0.33,"y":0.62,"class":"vedette","moving":true,"to":[0.5,0.62]},{"id":"h2","kind":"hull","faction":2,"x":0.3,"y":0.62,"class":"corsair","toggles":["silent"]}]},{"id":"quiet_hand","depth":false,"sapper":true,"probe":"h2","units":[{"id":"x1","kind":"installation","faction":1,"x":0.5,"y":0.32},{"id":"h1","kind":"hull","faction":2,"x":0.576,"y":0.29,"class":"cutlass"},{"id":"h2","kind":"hull","faction":2,"x":0.576,"y":0.35,"class":"cutlass","quietHand":10}]},{"id":"oracle_share","depth":false,"sapper":true,"probe":"h3","units":[{"id":"h1","kind":"hull","faction":1,"x":0.3,"y":0.4,"class":"oracle","toggles":["share"]},{"id":"h2","kind":"hull","faction":1,"x":0.3,"y":0.65,"class":"oracle"},{"id":"h3","kind":"hull","faction":2,"x":0.58,"y":0.52,"class":"corsair","moving":true,"to":[0.66,0.42]}]},{"id":"deep_run","depth":true,"sapper":true,"probe":"h2","units":[{"id":"b1","kind":"hold","faction":1,"x":0.3,"y":0.38,"station":3},{"id":"p1","kind":"buoy","faction":1,"x":0.5,"y":0.36},{"id":"h1","kind":"hull","faction":1,"x":0.45,"y":0.45,"class":"cutlass"},{"id":"h2","kind":"hull","faction":2,"x":0.7,"y":0.42,"class":"lancer","moving":true,"to":[0.35,0.42],"toggles":["deepRun"]}]},{"id":"overview","depth":true,"sapper":true,"probe":"h3","units":[{"id":"b1","kind":"hold","faction":1,"x":0.47,"y":0.37,"station":2},{"id":"i1","kind":"installation","faction":1,"x":0.44,"y":0.41},{"id":"s1","kind":"spire","faction":2,"x":0.59,"y":0.355},{"id":"p1","kind":"buoy","faction":2,"x":0.57,"y":0.41},{"id":"h1","kind":"hull","faction":1,"x":0.49,"y":0.345,"class":"vedette","moving":true,"to":[0.56,0.345]},{"id":"h2","kind":"hull","faction":1,"x":0.495,"y":0.405,"class":"cutlass","module":[2,1.1]},{"id":"h3","kind":"hull","faction":2,"x":0.55,"y":0.39,"class":"corsair","moving":true,"to":[0.48,0.385]},{"id":"h4","kind":"hull","faction":2,"x":0.59,"y":0.39,"class":"oracle","toggles":["share"]}]}] as readonly SonarLabScene[],
} as const;

// The menu's frame rate, which the theme preview runs at (§16.7).
export const MENU_FRAME_MS = 33;

// The close-up of the MODDING column (R1914): the zoom over the
// focus and the frame interval of the second preview.
export const MENU_CLOSE_ZOOM = 2;
export const MENU_CLOSE_FRAME_MS = 66;

// The option pictures of MODDING (R1918): the zoom of a picture of one
// mark, the zoom of a picture whose thing reaches wide, and how many
// pictures the browser keeps. The baker's preview runs at
// MENU_PICTURE_CLOCK times the menu rate and clock (R2084).
export const MENU_PICTURE_ZOOM = 2.5;
export const MENU_PICTURE_WIDE_ZOOM = 1.5;
export const MENU_PICTURE_KEEP = 240;
export const MENU_PICTURE_CLOCK = 2;

// The suggested range of the theme workshop's UI tab (themes.md §3.1,
// R821): an OKLCh lightness band and a chroma band per UI token, in
// the order of THEME_UI_TOKENS. The hue is free.
export const THEME_UI_RANGE = {
  accent: { l: [0.62, 0.92], c: [0.08, 0.24] },
  text: { l: [0.75, 0.95], c: [0, 0.08] },
  faint: { l: [0.48, 0.65], c: [0, 0.09] },
  panel: { l: [0.128, 0.26], c: [0, 0.06] },
  sheet: { l: [0.108, 0.24], c: [0, 0.055] },
  ink: { l: [0.088, 0.22], c: [0, 0.055] },
  deep: { l: [0.058, 0.19], c: [0, 0.045] },
} as const;

// The layer order of the UI tab (themes.md §3.1, R821): the ground
// tokens from the top layer down, each darker in OKLCh L than the one
// above it, and how much lighter a lower layer may be before a warning.
export const THEME_UI_ORDER = {
  layers: ['panel', 'sheet', 'ink', 'deep'],
  lTolerance: 0.005,
} as const;

// The heatmap mode hues (ui-map-interface.md §14, R258). One hue per
// mode; state.ts owns the labels, keys and prose.
export const HEAT_HUES = {
  off: 0x8fa6b4,
  sov: 0x1fe3c0,
  activity: 0xffc74d,
  activity_season: 0xffc74d,
  kills: 0xff5a4d,
  currents: 0x38c8f0,
  beacon: 0xa97dff,
  depth: 0x7090ff,
  stability: 0x5aa8ff,
} as const;

/** The modes with a ramp of their own: dark endpoint and alpha span
 * (R258/R259, R2289). A mode not named here paints its one hue over
 * the shared span. */
export const HEAT_RAMPS = {
  sov: { dark: 0x12816d, alphaLo: 0.22, alphaHi: 0.82 },
  activity_season: { dark: 0x6e4f14, alphaLo: 0.05, alphaHi: 0.82 },
} as const;

// The water ambience (ui-map-interface.md §14, R101).
export const FOG_COUNT = 14;
export const FOG_SCALE_MIN = 3.5;
export const FOG_SCALE_SPAN = 5;
export const FOG_DRIFT_X = 9;
export const FOG_DRIFT_Y = 5;
export const SNOW_COUNT = 260;
export const SNOW_ALPHA_MIN = 0.12;
export const SNOW_ALPHA_SPAN = 0.3;
export const SNOW_SINK_MIN = 3.5;
export const SNOW_SINK_SPAN = 7;
export const LIT_BAND_PX = 34;
export const LIT_ALPHA_GAIN = 0.55;
export const LIT_SCALE_GAIN = 0.8;
export const LIT_DECAY_PER_SEC = 1.6;
// The floors of the area-share rule (R479).
export const FOG_COUNT_MIN = 2;
export const SNOW_COUNT_MIN = 12;
// The abyss glimmer (ui-map-interface.md §7): the pool factor, the bands
// shelf, slope and deep in band order, and the glimmer light of the abyss.
export const SNOW_GLIMMER = {
  pool: 2,
  bands: [{ share: 1, alpha: 1.3, alphaMax: 0.55, scale: 1.1 }, { share: 0.6667, alpha: 1, alphaMax: 1, scale: 1 }, { share: 0.3333, alpha: 0.7, alphaMax: 1, scale: 0.9 }],
  lightEvery: 2, paleEvery: 3,
  pulseRate: 0.55, pulsePhase: 3, pulsePower: 3, pulseMin: 0.02,
  halo: { scale: 13, alpha: 0.035 }, glow: { scale: 6, alpha: 0.09 }, core: { scale: 1.2, alpha: 0.75 },
} as const;
// The corner darkening (fast/gfx/worldquad.ts, ui-map-interface.md §7):
// clear inside the inner radius, the colour at the alpha outside the
// outer one, both in half-viewport units.
export const VIGNETTE_COLOR = 0x01060c;
export const VIGNETTE_ALPHA = 0.55;
export const VIGNETTE_INNER = 0.5078125;
export const VIGNETTE_OUTER = 1.40625;
// The deep gradient of the water, top to foot (ui-map-interface.md §2).
export const WATER_DEEP_TOP = '#07223a';
export const WATER_DEEP_MID = '#051829';
export const WATER_DEEP_LOW = '#020b12';

// The arrival clocks (ui-map-interface.md §3, R163/R182).
export const SPAWN_PLAY_SEC = {
  'sonar-bloom': 3,
  'caustic-sweep': 3,
  'cell-ripple': 3.2,
  'seaquake-settle': 2.6,
  'deep-rise': 3.2,
  'stacked-deck': 2.8,
  fade: 0.45,
} as const;
export const RESYNC_FADE_SEC = 0.35;
export const LATE_LEAD_SEC = 1.5;
// The arrival hold (ui-map-interface.md §3, R1533).
export const SPAWN_CALM_MS = 40;
export const SPAWN_CALM_FRAMES = 4;
export const SPAWN_HOLD_MAX_SEC = 1.5;
export const SPAWN_STEP_MAX_MS = 50;
export const DOCK_MS = 1000;
// The match card's countdown redraw (arcade.md §15.7, R1117).
export const MATCH_CARD_TICK_MS = 250;

// The seaquake shudder and silt (fast/layers/quake.ts,
// ui-map-interface.md §7). Stage-indexed arrays; the burst clock is the
// viewer's.
export const QUAKE_BURST_EVERY_SEC = [0, 300, 150];
export const QUAKE_BURST_SEC = [0, 1.1, 2.2];
export const QUAKE_BURST_AMPLITUDE_PX = [0, 1.8, 5.5];
export const QUAKE_SILT_PER_BURST = [0, 26, 70];
export const QUAKE_SETTLE_EVERY_SEC = [1.6, 0.35];
export const QUAKE_SETTLE_BURST_SEC = 1.2;
export const QUAKE_SETTLE_AMPLITUDE_PX = [3.6, 9];
export const QUAKE_SETTLE_SILT_PER_BURST = [30, 90];
export const QUAKE_SETTLE_RAMP_SEC = 45;
export const QUAKE_BURST_FREQ_HZ = 11;
export const QUAKE_VY_FREQ_RATIO = 1.37;
export const QUAKE_VY_AMP_FRAC = 0.7;
export const QUAKE_SILT_MAX = 220;
export const QUAKE_SILT_LIFE_SEC = 2.6;
export const QUAKE_SILT_FALL_PX_PER_SEC = 14;
export const QUAKE_SILT_FALL_SPAN_FRAC = 0.6;
export const QUAKE_SILT_DRIFT_FRAC = 0.35;
export const QUAKE_SILT_ALPHA = 0.42;
export const QUAKE_SILT_COLOR = 0xc9b79a;
export const QUAKE_SILT_SIZE_PX = 5;

// The season-start title card (ui-map-interface.md §3.3).
export const BANNER_IN_MS = 1000;
export const BANNER_HOLD_MS = 2600;
export const BANNER_OUT_MS = 900;
export const BANNER_SLACK_MS = 400;
// What the five other banner styles of the World theme need (R825).
export const BANNER_GAUGE_TICKS = 21;
export const BANNER_ECHO_DELAY_FRAC = [0.18, 0.34];
export const BANNER_ECHO_SPREAD = [0.35, 0.75];
export const BANNER_SPLIT_BAND_FRAC = 0.34;

/** The spawn overture's cell budget (ui-map-interface.md §3.1). */
export const SPAWN_MAX_CELLS = 1200;

// The heat ramp's step count and dark-mix ease (§14).
export const HEAT_BUCKETS = 12;
export const HEAT_DARK_EASE = 0.6;

/** A wake flare is full-size at this speed (px/s). */
export const WAKE_FULL_SPEED = 60;

// The sonar look (ui-map-interface.md §5).
export const PING_EVERY_SEC = 6;
export const PING_LIFE_SEC = 2.4;
export const HOVER_DASHES = 24;
export const HOVER_DASH_FILL = 0.62;
/** The stroke of the hovered-base ring: screen px and alpha. */
export const SONAR_HOVER_WIDTH = 2;
export const SONAR_HOVER_ALPHA = 0.8;

// The Coral Ward's aura ring (ui-map-interface.md §6.2, R1082).
export const WARD_RING_DASHES = 16;
export const WARD_RING_DASH_FILL = 0.62;
export const WARD_RING_WIDTH = 2;
export const WARD_RING_ALPHA = 0.45;

// The core map's touch tuning (main.ts, ui-map-interface.md §8).
export const PICK_FLEET_PX = 20;
export const PICK_SITE_PX = 26;
export const SNAP_DEPOSIT_PX = 16;
/** How near a structure an order point must fall to snap to it, in
 * screen px (R469). The move, gather, escort and START MISSION picks read
 * it; a caller divides it by the zoom to reach world px. */
export const SNAP_TARGET_PX = 26;
export const PEEK_MS = 4000;
export const TOUCH_MENU_GUARD_MS = 700;
export const AIM_CONFIRM_PX = 24;
/** How long a still finger rests on a chrome element with a `title`
 * before the explainer card shows the title, in ms (R1555). */
export const TITLE_HOLD_MS = 500;

// The arcade's touch tuning (fast/arcade/match.ts). aim_confirm_px and
// peek_ms fork the core map's figures on purpose: ratified
// per-surface tuning (R349; presentation.toml says why).
export const ARCADE_DRAG_SLOP_PX = 6;
export const ARCADE_PEEK_MS = 2600;
export const ARCADE_TOUCH_MENU_GUARD_MS = 700;
export const ARCADE_AIM_CONFIRM_PX = 44;

// The rest of the sonar layer (ui-map-interface.md §5). R323 moved
// the clocks; these are the colours and the geometry.
export const SONAR_PING_COLOR = 0x6ef7ea;
export const SONAR_HOSTILE = 0xff8080;
export const SONAR_BASE_COVERAGE = { fillAlpha: 0.02, strokeWidth: 1.2, strokeAlpha: 0.16 };
export const SONAR_SWEEP = {
  width: 2.5, alpha: 0.4, blipR: 6, blipAlpha: 0.5, blipWindow: 26,
};
export const SONAR_FLEET_RING = { texR: 252, texWidth: 4, alpha: 0.05, selectedAlpha: 0.18 };
// The ring of an Oracle that broadcasts its array to the faction.
export const SONAR_SHARE_RING = { alpha: 0.1, pulseHz: 0.5, pulseDepth: 0.4 };

// The capture picture (fast/layers/control.ts, ui-map-interface.md §6.5).
export const CONTROL_PIP_BASE_SEC = 6;
export const CONTROL_BEAM_TIERS = [
  { width: 7, alpha: 0.08, pulses: true },
  { width: 3.5, alpha: 0.144, pulses: true },
  { width: 1.5, alpha: 0.44, pulses: false },
];
export const CONTROL_BASE_BEAM = { width: 1, alpha0: 0.13, alpha1: 0.05 };
export const CONTROL_GAUGE_RING = { width: 1, alpha: 0.18 };
export const CONTROL_GAUGE_ARC = { width: 2.5, alpha0: 0.55, alpha1: 0.25 };
export const CONTROL_GAUGE_R_K = 0.62;
export const CONTROL_CONTEST_R_K = 1.05;
export const CONTROL_CONTEST_BRACKET = { arm: 8, width: 2, alpha0: 0.5, alpha1: 0.4 };
export const CONTROL_PIP = {
  texSize: 32,
  stops: [[0, 1], [0.4, 0.55], [1, 0]] as [number, number][],
  beaconAlpha: 0.68,
  baseAlpha: 0.32,
  beaconScale: 0.5,
  baseScale: 0.3,
};
/** One clock for the beam, the ring and the arc. */
export const CONTROL_PULSE_BASE = 0.55;
export const CONTROL_PULSE_SWING = 0.45;
export const CONTROL_PULSE_RATE = 2.2;

// The sovereignty wash and its border (fast/layers/territory.ts, R187).
export const TERRITORY_TINT_ALPHA = 0.06;
export const TERRITORY_PULSE_HZ = 10;
export const TERRITORY_BORDER_PASSES = [
  { width: 11, alpha: 0.07 },
  { width: 5.5, alpha: 0.22 },
  { width: 1.8, alpha: 0.95 },
];
/** How far each faction's glow of the outline border moves into its
 * own claim, in world px, so two glows on a shared border stay apart
 * (R497). */
export const TERRITORY_GEO_INSET_PX = 1.5;

// The fleet marks (fast/layers/fleets.ts, ui-map-interface.md §6.1).
export const FLEET_SPEED_SMOOTH_PER_SEC = 4;
export const FLEET_CARGO_COLOR = 0xc57a52;
/** The gold of an anchored Beacon's cable and ring (R548). The chart
 * furniture's limit line letters the same reach, so the two read one
 * value. */
export const FLEET_ANCHOR_GOLD = 0xffd166;
export const FLEET_OWN_HULL_SCALE = 1.05;
export const FLEET_HOLLOW_STROKE_PX = 1.5;
/** The side of the box of an NPC mark, map px (R2637). */
export const FLEET_NPC_MARK_PX = 26;
/** The light rim of the inverse hull of a pirate, map px outside the
 * body (R2874). */
export const FLEET_NPC_RIM_PX = 0.8;
/** The monster layer (R2719): the zoom of the still mark, the swim
 * speed and the strike of a gun hit, wall seconds. */
export const MONSTER_LOOK = { bodyMinZoom: 0.6, movePxPerSec: 3, strikeSec: 0.9 } as const;
export const FLEET_BLOOM_HALF_LEN = 20;
export const FLEET_BLOOM_HALF_W = 7;
/**
 * The control-group badge of an arcade match (R403): the digit mark at
 * the bottom-left corner of an assigned own hull. `h` is the height of
 * the mark's own box in map px, `gap` what stands between the selection
 * bracket and the mark, and `alpha` keeps the badge under the bracket.
 */
export const FLEET_GROUP_BADGE_H = 10;
export const FLEET_GROUP_BADGE_GAP = 4;
export const FLEET_GROUP_BADGE_ALPHA = 0.9;
/**
 * The face the badge is set in (R427): the vendored JetBrains Mono 500
 * subset of the digits 1-5, the monospaced stack behind it and the
 * weight both of them are asked for. The fallback is a LIST, because
 * a renderer may quote every family it is given.
 */
export const FLEET_GROUP_BADGE_FONT = 'Aqua Badge';
export const FLEET_GROUP_BADGE_FONT_FALLBACK = ['ui-monospace', 'SFMono-Regular', 'Menlo', 'monospace'] as const;
export const FLEET_GROUP_BADGE_WEIGHT = 500;
/**
 * The count beside a stack of friendly marks (R1004, §6.1). The
 * separation rule holds two friendly fleets apart, and it stands aside
 * where the course end is an action point, so a stack still happens
 * there. The client prints ONE digit beside the mark that leads it.
 *
 * `separationPx` is the pack figure `sim.separation_px`, written here by
 * balancegen, because an arcade match draws the same count and opens no
 * world catalog to read a rule from.
 */
export const FLEET_STACK = {
  separationPx: 15,
  restSpeedPxPerSec: 1,
  h: 9,
  dx: 13,
  dy: -9,
  color: 0xe8f3ff,
  alpha: 0.85,
  everyMs: 250,
  max: 9,
} as const;
/**
 * The grid of the drawn group digits (R833, §6.1). The four
 * seven-segment values of the `digits` field share one alphabet on a
 * box of `boxWUnits` by `boxHUnits`. A bar is `barUnits` wide and its
 * ends are held half a bar inside the box, so the ink of a digit
 * measures the box. `flagLenUnits` is the diagonal the 1 wears up-left
 * from the top of its stem, and `threeInsetUnits` holds the middle bar
 * of the 3 off the left edge. `render/digit-paths.ts` holds the shape.
 */
export const FLEET_DIGITS = {
  boxWUnits: 5, boxHUnits: 8, barUnits: 1.2,
  flagLenUnits: 1.6, threeInsetUnits: 1,
} as const;
/**
 * One style for every reach circle (§6.1, §6.3, R386): the gun reach of
 * the selected own fleet, and the two aim rings. `color` is the map's one
 * hostile red, shared with the hovered enemy base ring, so a reach ring
 * cannot be read as a cyan sonar ring beside it. `gunColor` is the
 * attack red of `FLEET_ORDER_COLORS`: the gun ring is the reach of the
 * attack order, so it wears that order's red (R533). The dead zone
 * disc of an artillery hull wears the same red, hatched (R1472).
 * `beamColor` is the good green of the palette, the verdict green of
 * the heal beam: the heal beam reach of a Tender wears it (R2738).
 */
export const FLEET_REACH_RING = {
  color: 0xff8080, gunColor: 0xc0392b, beamColor: 0x7ee787,
  aimWidth: 1.5, aimAlpha: 0.5, aimHalfWidth: 1, aimHalfAlpha: 0.18,
  gunWidth: 1.2, gunAlpha: 0.28,
  hoverWidth: 1.2, hoverAlpha: 0.45,
  deadWidth: 1, deadAlpha: 0.22, deadHatchWidth: 0.8, deadHatchAlpha: 0.14, deadHatchStep: 4,
};

/**
 * The aspect chevrons (§6.1.11, R2407): card 10 of mockup round 104.
 * Lengths are world px against the hull centre, except the `figure*`
 * figures of the damage figure (§6.3.2), which are ems and screen px.
 * `friendColor` is palette.text and `flashColor` the shield white.
 */
export const FLEET_ASPECT = {
  innerR: 17, sternR: 25, stepR: 4.2, arm: 2.8, spread: 0.75, width: 1.4,
  friendColor: 0xa3cfe6, flashColor: 0xe8f3ff,
  peaceAlpha: 0.35, threatAlpha: 0.9, easeMs: 250, minScale: 0.7,
  flashSec: 0.9, flashStepPx: 3, flashWidth: 2, flashAlpha: 0.95,
  figureArmEm: 0.3, figureStepEm: 0.36, figureGapPx: 3, figureStrokePx: 1.6,
  figureDiamondEm: 0.36, figureDiamondAdvEm: 0.95, figureDiamondPx: 1.4,
} as const;

/**
 * The tick arc of a hull below its depth rating (§6.1.16, R3129): card 04
 * of mockup round 088. `r`, `tickPx` and the strokes are world px; the
 * angles are screen degrees, 0 east and 90 straight down. `color` is
 * palette.bad.
 */
export const FLEET_PRESSURE_ARC = {
  r: 20, fromDeg: 55, toDeg: 125, width: 2,
  ticksDeg: [65, 90, 115] as readonly number[],
  tickPx: 4, tickWidth: 1.4, alpha: 0.9, color: 0xff5c8a,
} as const;

/**
 * One colour per standing order (§6.1, R43, R469). The mission dashes of
 * The fleet layer and the pick crosshair both
 * read this table, so an armed order and the line it draws cannot
 * disagree. `patrol` is the chrome accent, `gather` is the cargo
 * brown and `commit` is the chrome gold (R1208): each already has one
 * home, so none is stated twice. `search` is the ink of SEARCH, and
 * `commission` the ink of a fleet that works a commission (R2833).
 */
export const FLEET_ORDER_COLORS = {
  move:   { color: 0xd8f4f0, alpha: 0.3 },
  attack: { color: 0xc0392b, alpha: 0.35 },
  patrol: { color: 0x35e0d2, alpha: 0.35 },
  gather: { color: 0xc57a52, alpha: 0.35 },
  home:   { color: 0xa3cfe6, alpha: 0.3 },
  escort: { color: 0xb18cff, alpha: 0.35 },
  anchor: { color: 0xff5c8a, alpha: 0.4 },
  commit: { color: 0xd8c66a, alpha: 0.35 },
  search: { color: 0xd4f55a, alpha: 0.35 },
  commission: { color: 0xff7ad9, alpha: 0.35 },
} as const;

/**
 * Which ink a Tender's mark wears (§6.1, R725). `faction` is the ink of
 * the hull the mark belongs to; `verdict` is the colour the mark's own
 * entry carries as `verdictColor`, `hullColor` or `shieldColor`.
 */
export type TenderInk = 'faction' | 'verdict';

/**
 * The Tender's three marks (fast/layers/fleets.ts, fast/layers/damage.ts,
 * §6.1 and §6.3.2, R725), from mockup round thirty-four: the heal beam of
 * card 02, the regen wave of card 14 and the two pluses of cards 06 and 16.
 *
 * The beam draws with the strokes of `CONTROL_BEAM_TIERS`, so only its
 * breath is stated here: `p = 0.5 + 0.5 sin(2 pi pulseHz t)` scales every
 * stroke's alpha by `alphaBase + alphaSwing p` and its width by
 * `widthBase + widthSwing p`. A verdict colour has a home elsewhere —
 * `PALETTE_GOOD` for the beam and the hull plus, the shield white of
 * `[presentation.fleets] shield_color` for the wave and the shield plus — so the emitter
 * fills it in, the rule `FLEET_ORDER_COLORS` follows for patrol.
 */
export const FLEET_TENDER = {
  beam: {
    ink: 'faction' as TenderInk, verdictColor: 0x7ee787,
    pulseHz: 0.67, alphaBase: 0.55, alphaSwing: 0.45, widthBase: 0.8, widthSwing: 0.4,
  },
  wave: {
    ink: 'faction' as TenderInk, verdictColor: 0xe8f3ff,
    periodSec: 3, rings: 2, alpha: 0.4, width0: 2, width1: 1,
  },
  plus: {
    ink: 'verdict' as TenderInk, hullColor: 0x7ee787, shieldColor: 0xe8f3ff,
    lifeSec: 1, risePx: 14, gapSec: 0.35,
  },
} as const;

/**
 * The friendly marks (fast/layers/fleets.ts, render/fleet-marks.ts,
 * §6.1, R185, R830), from mockup round twelve, series A and B.
 *
 * Two values state nothing here. `white-core` (the own AUTO value) is
 * the white tint, `FLEET_OWN_HULL_SCALE` and the bloom, and `hollow-hull`
 * is the hollow master; both are hull treatments with figures above.
 * Every other value adds ONE mark beside the hull, and one entry here
 * carries its geometry.
 *
 * Every length is map px against the hull's own origin, and y grows
 * DOWN. An alpha rides the quad and never the baked cell, so one cell
 * serves every zoom and every fade.
 */
export const FLEET_MARKS = {
  squadLift: 0.25,
  squadChange: { lift: 0.75, lifeSec: 1.3, pulseSec: 1.2 },
  caretPair: { dy: 14, halfW: 5, h: 4, w: 1.8, alpha: 0.85 },
  diamondCage: { r: 16, w: 1.4, alpha: 0.75 },
  viewfinder: { r: 15, arm: 5.5, w: 1.6, alpha: 0.8 },
  commandPennant: { stemY0: -4, stemY1: -19, stemW: 1.3, flagLen: 10, flagH: 6, alpha: 0.92 },
  hexFrame: { r: 15, w: 1.2, alpha: 0.65 },
  trailingDot: { dx: -15, r: 2.4, alpha: 0.8 },
  underDash: { dy: 12, pitch: 6, half: 2, w: 1.5, alpha: 0.7 },
  slotNumeral: { dx: 10, dy: -11, alpha: 0.85 },
  faintLozenge: { r: 15, w: 1.2, alpha: 0.3 },
} as const;

/**
 * The readout bars (fast/layers/fleets.ts, render/bar-styles.ts, §6.1,
 * R425, R829): the cargo, shield and hull lanes of an own hull, and the
 * pair a contact wears. Every length is map px against the hull's own
 * origin, so a negative offset is above the hull.
 *
 * The six nested tables are the six values of `SHIELD_STYLES`, and
 * `BAR_STYLES` of `render/bar-styles.ts` draws one of them. `shieldColor`
 * and `cargoColor` repeat `presentation.fleets`, so a style function
 * needs this one object and nothing else.
 */
export const FLEET_BARS = {
  w: 24, h: 3, x: -12,
  ownCargoY: -31, ownShieldY: -26, ownHullY: -22,
  contactHullY: 15, contactShieldY: 19,
  ground: 0x0a1620, groundAlpha: 0.8,
  hullBands: { good: 0x7ee787, gold: 0xffb454, bad: 0xff5c8a },
  shieldColor: 0xe8f3ff, cargoColor: 0xc57a52,
  hullAlpha: 0.95, ownShieldAlpha: 0.92, cargoAlpha: 0.9,
  contactHullAlpha: 0.85, contactShieldAlpha: 0.35,
  contactFrameAlpha: 0.5, contactFrameW: 1,
  stack: { contactPlace: 'below', cargoY: -31 },
  cap: {
    contactPlace: 'above', cargoY: -30,
    capH: 2, groundH: 5, capAlpha: 0.92,
    contactDashOn: 3, contactDashOff: 1, contactCapAlpha: 0.7,
  },
  sheath: {
    contactPlace: 'above', cargoY: -31,
    railH: 1, railDy: -2, cheekW: 1, cheekDy: -1, cheekH: 4,
    overhang: 1, alpha: 0.9,
    contactDashOn: 1, contactDashOff: 1, contactAlpha: 0.7,
  },
  ticks: {
    contactPlace: 'below', cargoY: -31,
    segments: 4, gap: 1, ownAlpha: 0.92,
    contactHullAlpha: 0.85, frameOnAlpha: 0.6, frameOffAlpha: 0.18, frameW: 1,
  },
  lanes: {
    contactPlace: 'below', cargoY: -30,
    plateH: 6, plateDy: -3, plateAlpha: 0.85, shieldH: 2,
    contactW: 16, contactShieldAlpha: 0.5,
  },
  fade: {
    contactPlace: 'above', cargoY: -30,
    groundH: 2, groundDy: -3, groundAlpha: 0.5,
    alphaFloor: 0.08, alphaSpan: 0.85,
    framePad: 1, frameH: 5, frameW: 1, frameFloor: 0.08, frameSpan: 0.7,
  },
} as const;

/** The figures every shield bar style reads (§6.1, R829). */
export type FleetBars = typeof FLEET_BARS;

/**
 * The five ALTERNATIVE heal beams of the world theme (§6.1.2, R827),
 * from mockup round thirty-four cards 01, 03, 04, 05 and 07.
 *
 * The AUTO value `breathing-line` is not here: it draws with
 * `CONTROL_BEAM_TIERS` and the breath of `FLEET_TENDER.beam`, and it
 * needs no figures of its own. `render/beam-styles.ts` holds the shape
 * of each value and reads its table from here.
 *
 * `maxSegments` caps ONE polyline: the step widens to `len / maxSegments`
 * on a long run, so a per-frame beam costs a fixed count of instances
 * however far it reaches (§10.1). The twisted pair pays it twice,
 * because it draws two strands.
 */
export const FLEET_BEAM = {
  'pip-cable': {
    lineAlpha: 0.15, lineW: 1, periodSec: 1.6, pipR: 8, pipAlpha: 0.6,
  },
  'marching-dash': {
    on: 6, off: 6, w: 1.6, alpha: 0.65, speedPxPerSec: 30,
  },
  cable: {
    waveLen: 12, amp: 2.5, phaseRadPerSec: 4, stepPx: 2, maxSegments: 64,
    w: 1.2, alpha: 0.55,
    periodSec: 1, pipR: 7, pipAlpha: 0.5, dotR: 1.8, dotAlpha: 0.95,
  },
  'gathering-ripple': {
    r0: 22, r1: 6, periodSec: 1.2, rings: 2,
    alpha0: 0.1, alpha1: 0.6, w0: 1.2, w1: 2.2,
  },
  'twisted-pair': {
    waveLen: 10, amp: 3, rateRadPerSec: 6, stepPx: 1.5, maxSegments: 96,
    w: 1.2, alpha: 0.5,
  },
} as const;

/**
 * The six ALTERNATIVE shield auras of the world theme
 * (`render/aura-styles.ts`, §6.1, R831), one entry per card of mockup
 * round thirty-four: 11, 12, 13, 15, 17 and 20.
 *
 * The AUTO aura is the regen wave, whose figures stay in `FLEET_TENDER`,
 * because the wave also drives the shield plus. Every aura wears the ink
 * of `FLEET_TENDER.wave.ink`, and every alpha here is multiplied by the
 * Tender's own fade. The reach is not a figure of this pack: it rides
 * `Hello.catalog.rules.tender_aura_px`.
 */
export const FLEET_AURA = {
  coverageDisc: {
    discAlpha: 0.04, ringW: 1, ringAlpha: 0.16, ringSwing: 0.06, breatheHz: 0.5,
  },
  bubble: {
    midStop: 0.9, midAlpha: 0.1, rimAlpha: 0.22,
    ringW: 1.5, ringAlpha: 0.4,
    sheenInsetPx: 2.5, sheenW: 3, sheenAlpha: 0.25, sheenSweep: 1.05, sheenPeriodSec: 12,
  },
  latticeRing: {
    discAlpha: 0.03, dashW: 2, dashAlpha: 0.45, dashOn: 10, dashOff: 7, speedPxPerSec: 8,
  },
  hexCells: {
    fillAlpha: 0.05, fillSwing: 0.07, edgeAlpha: 0.12, edgeSwing: 0.1, edgeW: 1, rippleSec: 2,
  },
  spokes: {
    lineW: 1, lineAlpha: 0.2, pipR: 6, pipAlpha: 0.5, periodSec: 1, stagger: 0.33,
  },
  mesh: {
    cellPx: 9, lineW: 0.8, lineAlpha: 0.06,
    breatheHz: 0.5, breatheFloor: 0.8, rimW: 1, rimAlpha: 0.2, discAlpha: 0.02,
  },
} as const;

/**
 * The five alternative deposit marks (render/marks.ts, §6.2, R832),
 * from mockup round twenty-five: cards 03, 05, 06, 08 and 10.
 *
 * The AUTO value `drain` states nothing here. It is the diamond, the
 * chips and the rising fill of R475, and the shapes carry their own
 * figures.
 *
 * Every length is map px against the field's own origin, and y grows
 * DOWN. An alpha is the alpha of ONE paint, because the atlas bakes the
 * cell with it: a deposit quad carries no per-field fade.
 */
export const DEPOSIT_MARKS = {
  ghostInk: 0x56646e,
  strikeInk: 0x8fa3b0,
  solidChipAlpha: 0.8, quietFillAlpha: 0.75, quietChipAlpha: 0.5, quietRimAlpha: 0.9,
  strike: { emptyAlpha: 0.3, barHalf: 11, barW: 2, barAlpha: 0.95 },
  gauge: {
    ringR: 11, ringW: 1.5, trackAlpha: 0.15, arcAlpha: 0.9,
    emptyAlpha: 0.25, emptyDashOn: 1.5, emptyDashOff: 3, emptyW: 1.2, emptyRingAlpha: 0.6,
  },
  ghost: {
    haloR: 16, haloAlpha: 0.35, chipAlpha: 0.85,
    emptyDashOn: 2, emptyDashOff: 1.5, emptyAlpha: 0.5,
  },
  tag: {
    size: 16, corner: 3, fontPx: 11, ink: 0x04121d,
    letterDy: 0.5, rimAlpha: 0.9, emptyAlpha: 0.4,
  },
  tally: {
    barW: 4, barH: 12, gap: 2.5, corner: 1,
    rimW: 0.8, rimAlpha: 0.9, emptyW: 1, emptyAlpha: 0.35,
  },
} as const;

/**
 * The hold marks (fast/layers/sites.ts, render/hold-rank-marks.ts,
 * §6.2, R185, R834), from mockup round twelve, series C and D.
 *
 * The AUTO pair states nothing here: `ground-plate` and `half-plate`
 * are the plate of R185, and `drawPlate` of `render/marks.ts` holds
 * its figures. Every other value REPLACES that plate.
 *
 * Every length is map px against the hold's own origin, and y grows
 * DOWN. Every y is the mockup card's y plus 4, because the dome of
 * this client sits 4 px lower than the dome of the mockup.
 */
export const SITE_HOLD_MARKS = {
  columnBands: 24,
  beamColumn: { y0: -10, y1: -68, halfW0: 3.5, halfW1: 7, alpha: 0.55 },
  beamLine: { y0: -10, y1: -60, w: 1, alphaBase: 0.5, alphaSwing: 0.3, hz: 1.4 },
  crownChevrons: { dy: -36, pitch: 8, halfW: 9, h: 6, w: 2, alphas: [0.85, 0.6, 0.35] },
  crossRays: { cy: 4, r0: 20, r1: 34, w: 1.5, alpha: 0.7 },
  breathingLozenge: { cy: 4, r: 31, squash: 0.85, w: 2.4, alphaBase: 0.25, alphaSwing: 0.55, scaleSwing: 0.1, hz: 0.9 },
  landingPillars: { dx: 24, barW: 2.8, barY: -14, barH: 26, glowW: 8, glowY: -16, glowH: 30, glowAlpha: 0.35, alphaBase: 0.35, alphaSwing: 0.5, hz: 1.6 },
  singleChevron: { dy: -24, halfW: 8, h: 5.5, w: 1.8, alpha: 0.7 },
  waterlineTicks: { dy: 8, x0: 21, x1: 28, w: 1.6, alpha: 0.75 },
  shortColumn: { y0: -10, y1: -36, halfW0: 2.5, halfW1: 5, alpha: 0.34 },
  smallLozenge: { cy: -26, r: 7, w: 1.4, alpha: 0.75 },
} as const;

/**
 * The pick crosshair (§8, §6.3, R469): four arms on the two axes, with a
 * missing middle. One arm runs from the gap out to the arm length, in
 * screen px. The torpedo aim draws the same mark larger, and because
 * `aimArmPx` is over `aimRingR` every arm crosses the ring.
 */
export const FLEET_CROSSHAIR = {
  armPx: 9, gapPx: 5, width: 1.6, alpha: 0.9,
  aimArmPx: 26, aimGapPx: 7,
  aimRingR: 20, aimRingWidth: 1.4, aimRingAlpha: 0.55,
  snapRingR: 13, snapRingWidth: 1.2, snapRingAlpha: 0.7,
} as const;

/**
 * The drag order preview (§8, R1208): the dashed line a finger draws
 * from an own fleet to the point its release orders. Every length is
 * screen px. Every order, a commit too, wears its colour of
 * `FLEET_ORDER_COLORS`. The plot line draws the joining run to the
 * first leg at `joinAlpha` (R2729).
 */
export const FLEET_ORDER_DRAG = {
  width: 2, alpha: 0.85, dashOnPx: 8, dashOffPx: 5, joinAlpha: 0.4,
  refreshMs: 100,
} as const;

/**
 * The course line and the on-ramp offer (§8 "The on-ramp offer",
 * R3075): a lit stretch of a course wears a band of the faction ink,
 * `litWidth` screen px wide at `litAlpha`; the drag preview draws the
 * lane course at `laneAlpha`; an offer stands `offerSec` wall seconds,
 * and the frame of the fleet must show the MOVE after `graceSec`.
 */
export const FLEET_COURSE = {
  litWidth: 5, litAlpha: 0.35, laneAlpha: 0.6, offerSec: 30, graceSec: 2,
} as const;

/**
 * The helm keys of the season map (§9, R2707, R3237): a held turn key
 * turns the ordered heading at `rudderRateShare` of the class turn rate,
 * the rate builds over `rudderRampS`, and the heading leads the bow by
 * `leadMaxDeg` at most; the telegraph steps from 0 (STOP) to `topStep`
 * (FULL), once a press. A hull under `stopShare` of its top speed
 * reads as STOP. A change goes at most once each `sendMs`, the order
 * goes again each `refreshSec`, and a helm the wire does not confirm
 * as STEER within `confirmSec` lets go.
 */
export const MAP_HELM = {
  leadMaxDeg: 40, rudderRateShare: 1.5, rudderRampS: 0.35,
  topStep: 3, stopShare: 0.08,
  sendMs: 100, refreshSec: 1.5, confirmSec: 3,
} as const;

/**
 * The damage figure (fast/layers/damage.ts, §6.3, R538). A figure pops at
 * a struck hull when the commander's own fleet takes damage, and when the
 * commander's fleet damages another hull. Mockup round thirty.
 *
 * EVERY length here is SCREEN px: the figure holds one size at every zoom,
 * so the layer packs its quads with the F_SCREEN flag. The five nested
 * tables are the five motions the settings pick between, in the order
 * `DAMAGE_STYLES` states them.
 */
export const DAMAGE_FIGURE = {
  sizePx: 12, torpedoScale: 1.45,
  weight: 500, torpedoWeight: 700,
  takenColor: 0xff4a24, dealtColor: 0xe8f3ff,
  haloPx: 3, sideOffsetPx: 7,
  punchScale: 1.6, punchSec: 0.12,
  mergeSec: 0.3,
  rise: { lifeSec: 0.9, torpedoLifeSec: 1.3, risePx: 26, hold: 0.55 },
  pop: { lifeSec: 1.05, appearScale: 1.5, settleSec: 0.15, hangSec: 0.45, gravityPxPerSec2: 260, driftPxPerSec: 22 },
  fly: { lifeSec: 1, travelPx: 44, torpedoTravelPx: 60, hold: 0.6 },
  stack: { lifeSec: 1.6, stepPx: 13, pushSec: 0.15, fadeAtSec: 1, maxRows: 5 },
  pin: { lifeSec: 1.4, holdSec: 1, ringPx: 16, growSec: 0.12, slotsDeg: [-70, -30, -110, 10, -150, 50] },
} as const;

// The spawn overture's unrevealed ground (§3.1).
export const SPAWN_DEEP_TOP = '#020c14';
export const SPAWN_DEEP_MID = '#010810';
export const SPAWN_DEEP_LOW = '#000407';
export const SPAWN_CELL_TINT = 0x0a2033;

// The haze of Rise from the Deep, top to bottom (§3.1, R838).
export const SPAWN_HAZE_TOP = '#09283e';
export const SPAWN_HAZE_MID = '#051a2c';
export const SPAWN_HAZE_LOW = '#020c16';
/** The alpha of each haze stop at full haze. */
export const SPAWN_HAZE_ALPHA = [0.62, 0.8, 0.92] as const;

// The creatures (fast/layers/creatures.ts, ui-map-interface.md §6.4).
export const CREATURE_WHALES = 3;
export const CREATURE_KRAKEN_MIN_SEC = 18;
export const CREATURE_KRAKEN_MAX_SEC = 38;
export const CREATURE_KRAKEN_LIFE_SEC = 9;
// The four beasts of the old charts (fast/layers/kraken.ts, R525).
export const CREATURE_KRAKEN_INK = 0x000407;
export const CREATURE_KRAKEN_MARK = 0xa3cfe6;
export const CREATURE_KRAKEN_AMBIENT_ALPHA = 0.22;
export const CREATURE_KRAKEN_LIT_ALPHA = 0.95;
export const CREATURE_KRAKEN_MARK_ALPHA = 0.14;
export const CREATURE_KRAKEN_MARK_LIT_ALPHA = 0.98;
export const CREATURE_KRAKEN_BODY_ALPHA = 0.92;
export const CREATURE_KRAKEN_RIM_PX = 2.4;
/** How long each beast is, in the order the beast index numbers them. */
export const CREATURE_KRAKEN_BEAST_PX: readonly number[] = [118, 114, 84, 122];

// The arrival ring of the Surface Wake dock-in (R826, §3.2).
export const MINIMAP_DOCK_RING_R0_PX = 7;
export const MINIMAP_DOCK_RING_SCALE = 5.5;
export const MINIMAP_DOCK_RING_ALPHA = 0.75;

// The two hex-grid layers (fast/layers/hexgrid.ts, ui-map-interface.md §4.3).
export const HEXGRID = { fillAlpha: 0.1, borderWidth: 1.5, borderAlpha: 0.9 };

// The camera's zoom range. audio/model.ts reads MIN_ZOOM from here
// rather than mirroring it: it is the far end of the loudness ramp.
export const CAMERA_MIN_ZOOM = 0.18;
export const CAMERA_MAX_ZOOM = 3.5;
// Under this scale the map draws no fleet, torpedo, wake or sonar
// (ui-map-interface.md §10.17).
export const CAMERA_DETAIL_MIN_ZOOM = 0;
/** The void beyond the world covers at most this share of the
 *  viewport on each axis (ui-map-interface.md §8). */
export const CAMERA_PAN_MARGIN = 0.35;
/** One px of wheel travel scales the view by exp(-rate). The
 *  terrain lab's view reads the same rate. */
export const CAMERA_WHEEL_ZOOM_RATE = 0.0015;
/** The first fit shows this share of the world on the tighter axis
 *  (R395). */
export const CAMERA_FIT_FRACTION = 0.85;

// The audio director's arithmetic (audio/model.ts, director.ts).
export const AUDIO_GAIN_CUTOFF_R = 2;
export const AUDIO_ZOOM_GAIN_FLOOR = 0.5;
export const AUDIO_PAN_MAX = 0.7;
export const AUDIO_MAX_VOICES = 16;
export const AUDIO_MIN_AUDIBLE_GAIN = 0.01;
// How long one music track crosses into the next. 0 is a hard cut.
export const AUDIO_CROSSFADE_SEC = 10;
// The time constant of the master fade at a hide and a show, and the
// clock watch: its window and the rate error it allows before two such
// windows renew the graph (audio.md §8.3, §8.8). 0 turns the watch off.
export const AUDIO_HIDE_FADE_SEC = 0.015;
export const AUDIO_CLOCK_WATCH_SEC = 2;
export const AUDIO_CLOCK_DRIFT_MAX = 0.03;
// The cue watcher's six edge rules (audio.md §4.3, §4.4): the least
// gap between two taking-damage cues, how close a hostile round
// must pass an own hull to read as incoming, how often the beacon
// pulse fires again and how many closing seconds of the founding
// truce carry a tick. The two hours the day cue turns on are
// DAWN_HOUR and DUSK_HOUR of gen/balance.ts (R2144). The
// fatigue cue is not here: it speaks at the hull's own readiness
// floor, which the wire states per fleet (R769).
export const AUDIO_FIGHT_QUIET_SEC = 20;
export const AUDIO_TORPEDO_INCOMING_PX = 60;
export const AUDIO_BEACON_PULSE_SEC = 3;
export const AUDIO_TRUCE_TICK_SEC = 10;
// The shortest wall gap between two cell flip cues, and how long a
// change of the active round counts as the answer to an order
// (audio.md §4.4, §4.6, R3120, R3121).
export const AUDIO_FLIP_CUE_GAP_SEC = 2;
export const AUDIO_ROUND_SELECT_WAIT_SEC = 3;
// How many top grades of the module ladder make a masterwork blueprint,
// and how long the cue of the club share waits (audio.md §4.4, §4.9,
// R3134, R3135).
export const AUDIO_MASTERWORK_TOP_GRADES = 2;
export const AUDIO_CLUB_PAYOUT_DELAY_SEC = 4;
// The cue of a repair hit, the effect alone, and its gain scale
// (audio.md §8.5, R2804). balancegen holds the id to the registered
// vocabulary.
export const AUDIO_REPAIR_CUE = 'sfx-torpedo-repair';
export const AUDIO_REPAIR_SCALE = 0.8;

// The torpedo look (render/torpedo-defs.ts, fast/layers/torpedoes.ts).
export const TORPEDO_WHITE = 0xffffff;
export const TORPEDO_AMBER = 0xffb454;
export const TORPEDO_HOT = 0xff4030;
export const TORPEDO_PLUME = 0xffd9a0;
export const TORPEDO_FOAM = 0xcfe8f2;
export const TORPEDO_STEEL = 0xdff6ff;
export const TORPEDO_HEAVY_SCALE = 1.45;
export const TORPEDO_FORGET_MS = 400;
// The alpha of a round a Torpor slowed in flight (R2783).
export const TORPEDO_SLOWED_ALPHA = 0.55;
export const TORPEDO_JOLT_SEC = 0.075;

/** The wait look of the Stonefish (R2848, ui-map-interface.md §6.3):
 *  card 05 Square Fuse of mockup round 133. Times are wall seconds,
 *  lengths world px at zoom 1, `MinPx` and `WidthPx` screen px. */
export const TORPEDO_WAIT = {
  settleSec: 0.35,
  popSec: 0.6,
  coolSec: 1,
  sparkDelaySec: 0.3,
  cueSec: 1.5,
  flareSec: 0.35,
  killFadeSec: 0.25,
  correctSec: 0.5,
  endMatchPx: 8,
  sidePx: 16,
  fuseWidthPx: 1.2,
  fuseAlpha: 0.6,
  ashWidthPx: 1,
  ashAlpha: 0.07,
  dashPx: 2,
  sparkGlowPx: 7,
  flareGlowPx: 6,
  sparkGlowAlpha: 0.45,
  flareGlowAlpha: 0.4,
  flickerShare: 0.25,
  sparkDotPx: 1.1,
  sparkDotMinPx: 1.3,
  sparkDotAlpha: 0.95,
  slowedDotAlpha: 0.6,
  emberCount: 2,
  emberHz: 1.6,
  emberDriftPx: 2.2,
  emberFallPx: 3.2,
  emberDotPx: 0.7,
  emberDotMinPx: 0.9,
  emberAlpha: 0.6,
  slowedWaitAlpha: 0.7,
  coreGlowPx: 3,
  coreGrowPx: 4,
  coreGlowXPx: 0.6,
  coreGlowAlpha: 0.7,
  coreDotPx: 1.6,
  coreDotMinPx: 1.5,
} as const;

// The bottom-left console's geometry and the map buttons (ui/layout.ts, §12.0, R218, R1747).
export const LAYOUT_PAD = 12;
export const LAYOUT_GAP = 12;
export const LAYOUT_VIEW_PX = 48;
export const LAYOUT_VIEW_PX_COARSE = 52;
export const LAYOUT_BUTTON_GAP = 10;
export const LAYOUT_MAP_ART = 168;
export const LAYOUT_MAP_SLOT = 168;
export const LAYOUT_MAP_SLOT_SHEET = 112;
export const LAYOUT_DISC_PX = 128;
export const LAYOUT_DISC_PX_SHEET = 84;
export const LAYOUT_SCALE_BAR_PX = 112;
export const LAYOUT_SCALE_BAR_CELLS = 5;
export const LAYOUT_ROSE_SLOT = 136;
export const LAYOUT_ROSE_SLOT_SHEET = 90;
/** The faction key's default on a desktop and on a telephone (round 083 open point 6). */
export const LAYOUT_KEY_DESKTOP = true;
export const LAYOUT_KEY_PHONE = false;
/** The tallest the VIEW panel stands on a desktop (round 086 card 15). */
export const LAYOUT_VIEW_PANEL_MAX_PX = 450;
/** The painted height of the action rows of the VIEW panel (R2832). */
export const LAYOUT_VIEW_ROW_PX = 34;
export const LAYOUT_CHAT_PANE_PX = 280;
/** The catch zones of the chat pane grip at the line and at the whole column (R1870). */
export const LAYOUT_CHAT_PANE_LINE_CATCH_PX = 120;
export const LAYOUT_CHAT_PANE_COLUMN_CATCH_PX = 48;
/** The outer size of the chat box of SMALL and LARGE on a wide desktop (R1841). */
export const LAYOUT_CHAT_BOX_W = 512;
export const LAYOUT_CHAT_BOX_H = 320;
export const LAYOUT_CHAT_BOX_LARGE_W = 800;
export const LAYOUT_CHAT_BOX_LARGE_H = 500;
/** The landscape rail of a telephone (round 083 card 15): the rail and the sheet beside it. */
export const LAYOUT_RAIL_PX = 64;
export const LAYOUT_RAIL_PANEL_PX = 340;
export const LAYOUT_RAIL_PAD_PX = 4;
/** The least height of a rail cell whose caps show their words (round 090 card 09 C). */
export const LAYOUT_RAIL_WORD_PX = 36;
/** The finger target (`--target-finger`): the least height of a rail cell. */
export const TARGET_FINGER = 44;
export const LAYOUT_CTX_INSET = 8;
export const LAYOUT_CTX_OBJECT_VH = 45;
export const LAYOUT_CTX_CATALOGUE_VH = 55;
export const LAYOUT_CTX_SWIPE_PX = 24;
export const LAYOUT_CTX_TAP_PX = 8;
export const LAYOUT_CTX_DRAG_GIVE = 0.3;
// The width of a card of the chrome (round 083 card 05). The other
// widths reach the stylesheets alone, as tokens of gen/tokens.css.
export const WIDTH_CARD = 300;

// The chat as a state of the dock (ui/chatdock.ts, §12.0, R1799).
export const CHAT_BAND_LINES = 6;
export const CHAT_BAND_KEYBOARD_LINES = 3;
export const CHAT_LINE_MS = 6000;

// The tab glyphs of the six game menus (ui/tabglyphs.ts, ui/tabhold.ts, §12.0, R2214).
export const TAB_GLYPH = {
  holdMs: 400,
  phonePx: 22,
  narrowPx: 18,
  wordPx: 18,
  railPx: 20,
  deskPx: 14,
  deskAlonePx: 16,
  gapPx: 4,
  headPx: 20,
} as const;

// What the shell surfaces share (ui/theme.ts, ui/overlay.ts, the hub).
export const CHROME_PANEL_ALPHA = 0.82;
export const CHROME_EDGE_ALPHA = 0.25;
export const CHROME_NUDGE_STEP = 0.01;
/** How long an armed control waits for its second press. */
export const CHROME_ARM_MS = 4000;
/** The pane takes two columns from this width up. A media query
 *  cannot read a custom property, so the stylesheets that carry a
 *  breakpoint are rendered from a `.css.tmpl` and take the same
 *  figure at generation time (R362). */
export const CHROME_WIDE_PX = 900;
export const CHROME_TICK_MS = 1000;
/** The rest height of the telephone sheet, in vh (R1371). The
 *  stylesheet takes the same figure at generation time, so the sheet
 *  and the drag stops of ui/overlay.ts cannot disagree. */
export const CHROME_SHEET_REST_VH = 52;
/** The UI scale steps in percent, and the default step
 *  (ui-map-interface.md §13, R1556). `ui/uiscale.ts` sets a step
 *  as CSS `zoom` on the chrome roots. */
export const CHROME_UI_SCALE_STEPS = [100, 120, 140] as const;
export const CHROME_UI_SCALE_DEFAULT = 100;
/** The render scale steps in percent of the device pixel ratio, and
 *  the default step (ui-map-interface.md §10.16, R484). The engine
 *  sizes its backing store at the capped ratio times the step. */
export const CHROME_RENDER_SCALE_STEPS = [100, 75, 50] as const;
export const CHROME_RENDER_SCALE_DEFAULT = 100;
/** The second reset of the viewport guard after a rotation (R1277). */
export const CHROME_ROTATE_SETTLE_MS = 400;
/** The floor between two inbox refetches. The client refetches the
 *  list when the unread badge rises, and this floor holds a busy
 *  fight to one fetch. */
export const CHROME_INBOX_REFETCH_MS = 10000;
export const CHROME_NEWS_PAGE = 10;
export const CHROME_CHRONICLE_SHOWN = 3;
/** How long the chronicle book says LINK COPIED (chronicle.md §9.2). */
export const CHROME_CHRONICLE_COPIED_MS = 2500;
/** How long the game entry waits for the film of a replay link
 *  before it says that no film came (chronicle.md §8). */
export const CHROME_REPLAY_LINK_WAIT_MS = 10000;
export const CHROME_HISTORY_NAMES = 5;
/** How many places of the ladder list the arcade LADDER section
 *  shows (R1948). */
export const CHROME_LADDER_LINES = 10;
/** How many pool entries the RANKS board MEMORIALS asks for (R1243). */
export const CHROME_MEMORIALS_SHOWN = 30;
// Toast clocks: FALLBACKS ONLY. Hello.catalog EventDefaults carries
// the server's own toast_ms and toast_dedup_ms, and both shells take
// them at the hello. These cover the frames before it lands.
export const CHROME_NOTICE_MS = 6000;
export const CHROME_NOTICE_DEDUP_MS = 2000;
// The notice queue (ui/notices.ts, R3081): a line stands at least
// CHROME_NOTICE_MIN_MS before the cap may drop it, and at most
// CHROME_NOTICE_QUEUE_MAX lines wait behind a full column.
export const CHROME_NOTICE_MIN_MS = 1500;
export const CHROME_NOTICE_QUEUE_MAX = 8;
// The life of a line is at least CHROME_NOTICE_CHAR_MS for each
// character of its text (R3103).
export const CHROME_NOTICE_CHAR_MS = 60;
// The two figures the ledger notices style of the World theme reads
// (ui/notices.ts, ui-map-interface.md §8, R824). The ledger stands
// off the bar's centre line, so it holds more and longer. The clocks
// of the lane and the ribbon reach the stylesheet alone.
export const CHROME_LEDGER_NOTICE_MS = 9000;
export const CHROME_LEDGER_LINES = 6;

// The replay viewer (ui/replay.ts, ui-map-interface.md §12.3): the
// combat log played on the real terrain (R528).
export const REPLAY_PLAY_RATE_X = 4;
export const REPLAY_MIN_WINDOW_PX = 120;
export const REPLAY_MARGIN_FRAC = 0.15;
// The film's own clocks (fast/film.ts, R531). The four figures that
// dress the film are CSS and reach ui/styles.css through its
// template, because a stylesheet reads no TypeScript constant.
export const REPLAY_LOOP_HOLD_MS = 5000;
export const REPLAY_HIT_PULSE_DS = 4;
export const REPLAY_CAMERA_EASE_MS = 900;
export const REPLAY_CAMERA_HOME_DWELL_MS = 1500;
// Past this zoom the film's blasts hold their screen size (0 = never),
// and a damage figure on film is this many times its map size (R552).
export const REPLAY_FILM_FX_HOLD_ZOOM = 1.5;
export const REPLAY_FILM_FIGURE_SCALE = 1.75;

// The match shell's beats (arcade/phase.ts, moments.ts, chrome.ts).
export const ARCADE_COUNTDOWN_SEC = 4;
// A match draws no kraken while this is false (arcade.md §7.2, R546).
export const ARCADE_KRAKEN = false;
// A match draws no chart furniture while this is false, whatever the
// reader's `chart` setting says (arcade.md §7.2, R548).
export const ARCADE_CHART = false;
// The chart pieces a match draws although ARCADE_CHART is false (R1580).
export const ARCADE_CHART_PIECES: readonly string[] = ['sonar_sweep', 'depth_tints', 'edge_seam', 'current_arrows', 'fairways'];
export const ARCADE_BEAT_IN_BEZIER = 'cubic-bezier(.215, .61, .355, 1)';
export const ARCADE_BEAT_OUT_BEZIER = 'cubic-bezier(.55, .085, .68, .53)';
export const ARCADE_LANE_WARN_SEC = 180;
export const ARCADE_LANE_CRIT_SEC = 60;
export const ARCADE_CLOCK_TICK_SEC = 10;
// The longest wait of the own seat's voice line (audio.md §4.8, R1148).
export const ARCADE_SEAT_LINE_WAIT_SEC = 3;
export const ARCADE_BUILD_FLASH_MS = 550;
// How tall the eye badge's glyph is drawn, in CSS px (arcade.md
// §15.9, R900). The badge is hidden while nobody watches.
export const ARCADE_EYE_PX = 14;
// The community maps of the lobby (community-maps.md §9.2, R1973): the
// hours of the NEW mark, and the plays from which the map card states
// its shares.
export const ARCADE_COMMUNITY_NEW_HOURS = 48;
export const ARCADE_COMMUNITY_FEW_PLAYS = 100;
// The characters of a revision's SHA-256 that the designer and MY MAPS
// show (community-maps.md §2.3, R1978).
export const ARCADE_COMMUNITY_HASH_CHARS = 6;

// The drawing of the arcade structures (arcade.md §7.2, §19.2, R2029): the
// capture ring of a match, its outline in the map designer and the objective
// tell. A `Hex` figure is a share of HEX_SIZE; a `Px` figure is world px.
export const ARCADE_CAPTURE = {
  ringPx: 2,
  ringAlpha: 0.8,
  countPx: 14,
  countDyHex: -1.5,
  designerRingPx: 1.3,
  designerRingAlpha: 0.6,
  designerRingDashPx: [4, 4] as const,
  flagDxHex: 0.55,
  flagFootDyHex: -0.35,
  flagTopDyHex: -1.05,
  flagLenHex: 0.5,
  flagTipDyHex: 0.18,
  flagDropHex: 0.36,
  flagFillAlpha: 0.85,
  flagLinePx: 1.2,
} as const;

// The person mark of a team-size tab of the lobby on a telephone
// (arcade/lobby.ts, arcade.md §10.2, R2074): one SVG path on a 24 x 24
// box, drawn as a line in the current ink.
export const ARCADE_PERSON_MARK = {
  px: 12,
  line: 1.8,
  d: 'M12 4.5a3.5 3.5 0 1 0 0 7a3.5 3.5 0 1 0 0-7zM5 20c.8-3.9 3.6-6 7-6s6.2 2.1 7 6',
} as const;

// The client half of the drill (arcade/drill.ts, fast/layers/drillspot.ts,
// arcade.md §17.8, R1573). The spot lengths are px at a cell of
// DRILL_SPOT_REF_CELL_PX; the layer scales them to the map's own cell.
export const DRILL_SPOT_REF_CELL_PX = 34;
export const DRILL_SPOT_LINE_PX = 1.5;
export const DRILL_SPOT_LINE_ALPHA = 0.85;
export const DRILL_SPOT_DASH_PX = [5, 4] as const;
export const DRILL_SPOT_PERIOD_SEC = 1.6;
export const DRILL_SPOT_ARROW_FAR_PX = 62;
export const DRILL_SPOT_ARROW_NEAR_PX = 44;
export const DRILL_SPOT_ALPHA_FAR = 0.95;
export const DRILL_SPOT_ALPHA_NEAR = 0.25;
export const DRILL_SPOT_ALPHA_STILL = 0.85;
export const DRILL_SPOT_ARROW_LEN_PX = 11;
export const DRILL_SPOT_ARROW_W_PX = 11;
export const DRILL_DART_NOTCH = 0.36;
export const DRILL_EDGE_INSET_PX = 22;
export const DRILL_EDGE_LEN_PX = 14;
export const DRILL_EDGE_W_PX = 18;
export const DRILL_EDGE_ALPHA = 0.92;
export const DRILL_FLASH_MS = 800;
export const DRILL_FLASH_R0_PX = 6;
export const DRILL_FLASH_R1_PX = 22;
export const DRILL_FLASH_ALPHA = 0.55;
export const DRILL_STAMP_MS = 320;
export const DRILL_HOLD_MS = 800;
export const DRILL_TRAVEL_MS = 420;
export const DRILL_PAN_MS = 600;
export const DRILL_BREATH_MS = 1600;
export const DRILL_DIM_ALPHA = 0.42;

// The mark scale (R1981, R1992, arcade.md §7.2, ui-map-interface.md §6.1):
// the size of the fleets and the torpedoes while the switch of a mode is on,
// in percent.
export const MARK_SCALE = { arcadePct: 70, corePct: 70 } as const;

// The match viewer (arcade/viewer/, arcade.md §15.7). One set of
// figures serves a finished replay and a live spectator, because the two
// carry one format.
export const VIEWER_TAP_RADIUS_PX = 14;
export const VIEWER_TAP_FADE_MS = 900;
export const VIEWER_TAP_RING_PX = 2;
export const VIEWER_VIEWPORT_STROKE_PX = 1.5;
export const VIEWER_VIEWPORT_ALPHA = 0.55;
export const VIEWER_HOTKEY_LANE_N = 6;
export const VIEWER_JUMP_MS = 10000;
/** How far behind the newest record a reader still reads as LIVE
 *  (R913). */
export const VIEWER_EDGE_GRACE_MS = 2000;
/** The play rates the SPEED control cycles, slowest first. 1 is the
 *  rate the match played at. */
export const VIEWER_SPEEDS = [0.5, 1, 2, 4] as const;
/** The most bytes the viewer fetches to build the PAST of a match it
 *  joined late, through one Range request off ReplayChunk.history_bytes
 *  (R921). A larger past is refused and the reader stays at the edge. */
export const VIEWER_HISTORY_FETCH_MAX_BYTES = 67108864;

/**
 * One value of the World body's `dock` field: how the DOM chrome
 * arrives after the map spawn (ui-map-interface.md §3.2, R826).
 *
 * `delayMs` names the panels that start late, by the id of the
 * panel; a panel it leaves out starts at 0. `minimap` is the chart,
 * which is drawn on the canvas. `chartMs` is the chart's own
 * travel. Every value spends the same `DOCK_MS`: the last arrival
 * lands on that figure, and balancegen refuses a table that does
 * not.
 */
export interface DockInStyle {
  /** How long one panel travels, in ms. */
  ms: number;
  /** The CSS `cubic-bezier(x1, y1, x2, y2)` of the travel. */
  bezier: readonly [number, number, number, number];
  /** The panels that start late, in ms. */
  delayMs: Readonly<Record<string, number>>;
  /** The chart's own travel, in ms. */
  chartMs: number;
  /** Does a bordered panel flash as it lands? */
  flash: boolean;
  /** The opacity fade, in ms. 0 means no fade. */
  fadeMs: number;
  /** How far outside its dock line a panel starts, in px. */
  offsetPx: number;
  /** The scale a panel starts at. */
  scale: number;
  /** The backdrop blur a panel wears, in px. */
  blurPx: number;
  /** The chart ring: how long it opens for and how long it waits. */
  ringMs: number;
  ringDelayMs: number;
}
export const DOCKIN: Readonly<Record<string, DockInStyle>> = {
  'magnet': {
    ms: 1000, bezier: [0.34, 1.42, 0.64, 1], chartMs: 1000, flash: true,
    delayMs: {},
    fadeMs: 0, offsetPx: 0, scale: 1, blurPx: 0,
    ringMs: 0, ringDelayMs: 0,
  },
  'hard-dock': {
    ms: 1000, bezier: [0.22, 0.61, 0.36, 1], chartMs: 1000, flash: false,
    delayMs: {},
    fadeMs: 0, offsetPx: 0, scale: 1, blurPx: 0,
    ringMs: 0, ringDelayMs: 0,
  },
  'cascade': {
    ms: 760, bezier: [0.22, 0.61, 0.36, 1], chartMs: 760, flash: false,
    delayMs: { dock: 80, hint: 60, infocard: 160, mapbtns: 160, minimap: 240, notices: 60, selection: 160 },
    fadeMs: 0, offsetPx: 0, scale: 1, blurPx: 0,
    ringMs: 0, ringDelayMs: 0,
  },
  'pressure-rise': {
    ms: 1000, bezier: [0.16, 1, 0.3, 1], chartMs: 1000, flash: false,
    delayMs: {},
    fadeMs: 700, offsetPx: 22, scale: 0.96, blurPx: 3,
    ringMs: 0, ringDelayMs: 0,
  },
  'surface-wake': {
    ms: 1000, bezier: [0.22, 0.61, 0.36, 1], chartMs: 820, flash: false,
    delayMs: { minimap: 180 },
    fadeMs: 0, offsetPx: 0, scale: 1, blurPx: 0,
    ringMs: 760, ringDelayMs: 420,
  },
};

/**
 * The chart furniture (data/presentation/chart.toml, R548): the
 * 54 pieces of sea-chart decoration and information the owner
 * picked from the mockup rounds (ui-map-interface.md §17).
 *
 * `fadeSec` is the crossfade on a reading change. `magenta` is the
 * chart's magenta ink (R2868). `text` is the two
 * vendored map faces and every size the atlas bakes them at. Each
 * piece carries its card, its two form-factor gates, its zoom band,
 * a corner and an offset for a screen or DOM piece, its own figures,
 * and the two readings. An `ink` of 0 means the piece reads a colour
 * the client already holds; a reading with `on: false` keeps the
 * piece out of that reading. `off: true` draws the piece under the
 * chart setting `off` too.
 */
export const CHART = {
  fadeSec: 0.35,
  magenta: 0xff5ec4,
  text: {
    monoFamily: 'Aqua Chart Mono',
    fellFamily: 'Aqua Chart Fell',
    fallback: ['Georgia', 'serif'],
    monoSizesPx: [7, 8, 9, 9.5, 10, 11, 12, 14],
    fellSizesPx: [9, 10, 11, 12, 13, 14, 15, 16],
    haloPx: 1.5,
    haloAlpha: 0.5,
    bandMin: 0.85,
    bandMax: 1.25,
    steps: {
      note: { monoPx: 8, fellPx: 10, zoomGate: 0.75 },
      label: { monoPx: 9.5, fellPx: 12, zoomGate: 0.45 },
      name: { monoPx: 11, fellPx: 14, zoomGate: 0.3 },
      feature: { monoPx: 14, fellPx: 16, zoomGate: 0 },
    },
  },
  groups: {
    names: ['place_names', 'ribbons', 'heraldry', 'banks', 'bottom_nature', 'light_chars', 'imprint', 'clan_burgee', 'spoil_ground', 'tidal_diamond'],
    tracks: ['ship_tracks', 'speed_label', 'bearing_lines', 'torpedo_run', 'cables'],
    depth: ['soundings', 'depth_tints', 'shoal_stipple', 'edge_seam'],
    currents: ['current_arrows'],
    wrecks: ['wrecks', 'battle_marks'],
  },
  groupFlags: {
    names: '',
    tracks: '',
    depth: 'depth',
    currents: 'currents',
    wrecks: '',
  },
  pieces: {
    water_lines: {
      card: 1, desktop: true, mobile: false, off: false,
      zoomMin: 0, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { early_out_px: 41 },
      arr: { ridge_alpha: [0.32, 0.24, 0.16, 0.1], ridge_d: [7, 15, 26, 40], ridge_w: [0.9, 0.8, 0.7, 0.6] },
      text: {},
      historical: { on: true, ink: 0x000000, alpha: 1, fill: 0x000000, width: 0, dash: [], fig: {}, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 1, fill: 0x000000, width: 0, dash: [], fig: {}, arr: {} },
    },
    soundings: {
      card: 2, desktop: true, mobile: true, off: false,
      zoomMin: 1, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { every: 5, ramp_cells: 4, round_m: 10, site_clear_px: 22 },
      arr: { band_span_m: [180, 1800, 2000, 2000], band_top_m: [20, 200, 2000, 4000] },
      text: { main: 'note' },
      historical: { on: true, ink: 0x000000, alpha: 0.46, fill: 0x000000, width: 0, dash: [], fig: {}, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 0.34, fill: 0x000000, width: 0, dash: [], fig: {}, arr: {} },
    },
    compass_rose: {
      card: 3, desktop: true, mobile: true, off: false,
      zoomMin: 0, zoomMax: 99, corner: 'bl', dx: 0, dy: 0, show: '',
      fig: { fill_w: 1.2, home_k: 0.38, home_lit_alpha: 0.95, home_min_px: 10, home_rest_alpha: 0.9, home_size_k: 0.32, home_width: 1.2, hover_alpha: 0.9, hover_dr: 3, hover_width: 2, needle_alpha: 0.95, needle_fill_w: 0.6, needle_half_k: 0.15, needle_k: 0.85, needle_tail_alpha: 0.32, press_alpha: 0.9, press_fill_alpha: 0.16, press_grow: 6, press_sec: 0.3, press_width: 2, rim_bottom: 26, rim_bottom_sheet: 14, rim_top: 13, rim_top_sheet: 12, round_home_k: 0.83, round_home_px: 12, round_label_dy: 11, round_needle_half: 4, round_needle_in: 1, round_needle_out: 8, round_rim_k: 0.16, round_tick_k: 0.3, round_tick_major_k: 0.6, round_word_dy_k: 0.86, round_word_inset: 2, share_alpha: 0.9, share_dr: 4, share_gap_deg: 2, share_width: 3 },
      arr: {},
      text: { bearing: 'label', north: 'label', point: 'label' },
      historical: { on: true, ink: 0x000000, alpha: 0.4, fill: 0x000000, width: 0.8, dash: [], fig: { fleur_alpha: 0.85, fleur_band: 0.36, fleur_curl_dx: 0.52, fleur_curl_dy: 0.42, fleur_curl_r: 0.26, fleur_curl_sweep: 3.9, fleur_dy: 1.5, fleur_foot: 0.3, fleur_petal_at: 0.45, fleur_petal_w: 0.28, fleur_r: 8, ground_alpha: 0.25, keel_alpha: 0.3, mid_k: 0.6, point_alpha: 0.95, point_dy: 8, point_k: 0.96, star_alpha: 0.55, valley_k: 0.2 }, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 0.45, fill: 0x000000, width: 1, dash: [], fig: { figure_alpha: 0.95, figure_dy: 9, ground_alpha: 0.35, label_alpha: 0.9, label_dy: 7, major_every: 6, tick_alpha: 0.35, tick_k: 0.09, tick_major_alpha: 0.6, tick_major_k: 0.18, ticks: 24 }, arr: {} },
    },
    graticule: {
      card: 5, desktop: true, mobile: false, off: false,
      zoomMin: 0, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { chequer_alpha: 0.22, chequer_px: 3, every_cells: 5, figure_alpha: 0.55, figure_gap: 2, figure_inset: 3, figure_margin: 12, grid_alpha: 0.045, grid_width: 0.6, grid_zoom_max: 1, lat_origin_min: 840, lon_origin_min: -1920, slot_margin: 8, tick_alpha: 0.5, tick_px: 8 },
      arr: {},
      text: { main: 'label' },
      historical: { on: true, ink: 0x000000, alpha: 0.55, fill: 0x000000, width: 1, dash: [], fig: {}, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 0.55, fill: 0x000000, width: 1, dash: [], fig: {}, arr: {} },
    },
    cartouche: {
      card: 6, desktop: true, mobile: false, off: false,
      zoomMin: 0, zoomMax: 99, corner: 'br', dx: 0, dy: 0, show: '',
      fig: { bar_px: 3, scale_cells: 5, scale_cells_min: 2, stack_gap: 8 },
      arr: {},
      text: { scale: 'note', season: 'label', title: 'name' },
      historical: { on: true, ink: 0x000000, alpha: 0.9, fill: 0x000000, width: 0.8, dash: [], fig: {}, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 0.9, fill: 0x000000, width: 0.8, dash: [], fig: {}, arr: {} },
    },
    current_arrows: {
      card: 7, desktop: true, mobile: true, off: false,
      zoomMin: 0, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { alpha_cut: 0.06, alpha_gain: 1.6, area_px: 10000, atlas_alpha: 0.42, atlas_band_gain: 4.5, atlas_bands: 4, atlas_gap_px: 120, atlas_head_px: 4, atlas_head_step_px: 1, atlas_len_px: 22, atlas_min_px_h: 6, atlas_rate_alpha: 0.55, atlas_rate_off_px: 12, atlas_rate_px_h: 180, atlas_width_px: 0.6, atlas_width_step_px: 0.8, budget_segments: 40000, budget_segments_sheet: 10000, chev_alpha: 0.12, chev_alpha_step: 0.11, chev_cut: 0.08, chev_floor: 0.15, chev_gain: 1.8, chev_gap_px: 44, chev_jitter_px: 30, chev_levels: 4, chev_min_px_h: 1, chev_rate: 0.25, chev_rate_gain: 0.6, chev_size_gain_px: 2, chev_size_px: 4, chev_slide_gain_px: 14, chev_slide_px: 6, chev_width_px: 1, chev_wing: 0.8, fade_sec: 0.35, field_band: 0.15, glimmer_floor: 0.3, glimmer_hz: 0.8, glimmer_hz_step: 0.13, glimmer_kinds: 7, glimmer_phase: 1.7, levels: 4, margin_px: 12, min_streaks: 20, rezoom_ratio: 1.25, rezoom_spread_sec: 0.6, sample_px: 20, smooth_px: 30, spawn_tries: 12, tail_cut: 0.03, warm_sec: 0.0333, warm_steps: 40 },
      arr: { alpha: [0.32, 0.7, 0.55, 0.7, 0, 0.75, 0.7, 0.8, 0.38, 0], alpha_floor: [0.6, 0.4, 0.5, 1, 0, 0.45, 0.5, 1, 0.5, 0], density: [3.5, 28, 4, 14, 0, 24, 7, 20, 5, 0], dot: [0, 0, 0, 1, 0, 0, 0, 0, 0, 0], every_sec: [0.0333, 0.0333, 0.05, 0.0333, 0, 0.0333, 0.0333, 0.0333, 0.0333, 0], fade_pow: [1, 1, 1.3, 1, 0, 1, 1, 1, 1, 0], fast_from: [0, 0, 0, 0, 0, 0, 0, 0.08, 0, 0], fast_to: [0, 0, 0, 0, 0, 0, 0, 0.5, 0, 0], field_alpha: [0, 0, 0, 0, 0, 1.15, 1, 1.1, 0.45, 0], field_min: [0, 0, 0, 0, 0, 0, 0, 0.3, 0, 0], glimmer: [0, 0, 0, 1, 0, 0, 0, 0, 0, 0], jitter_px: [0, 0, 0, 6, 0, 0, 0, 0, 0, 0], life_max: [4, 4, 7, 10, 0, 4, 4, 4, 4, 0], life_min: [1.5, 1.5, 3, 5, 0, 1.5, 1.5, 1.5, 1.5, 0], pace: [0.3, 0.3, 0.25, 0.09, 0, 0.3, 0.3, 0.3, 0.18, 0], ramp_alpha: [0, 0.12, 0.22, 0.3, 0.38], ramp_at: [0, 0.12, 0.32, 0.6, 1], seed: [9, 2, 6, 15, 17, 1, 4, 8, 10, 19], tail: [10, 12, 36, 1, 0, 12, 12, 12, 10, 0], width_px: [0.8, 1, 0.9, 1.4, 0, 1, 1, 1, 0.8, 0] },
      text: { rate: 'note' },
      historical: { on: true, ink: 0x000000, alpha: 1, fill: 0x000000, width: 1, dash: [], fig: {}, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 1, fill: 0x000000, width: 1, dash: [], fig: {}, arr: {} },
    },
    wrecks: {
      card: 8, desktop: true, mobile: true, off: false,
      zoomMin: 1.5, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { alpha: 0.35, bale_fill: 0.35, list_page_rows: 4, pack_slack: 0.5, scale: 0.6, touch_margin_px: 8 },
      arr: {},
      text: {},
      historical: { on: true, ink: 0x000000, alpha: 1, fill: 0x000000, width: 0.9, dash: [], fig: {}, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 1, fill: 0x000000, width: 0.9, dash: [], fig: {}, arr: {} },
    },
    depth_tints: {
      card: 9, desktop: true, mobile: true, off: false,
      zoomMin: 0, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { feather_k: 1.7, heat_edge_alpha: 0.55, heat_edge_px: 1.25, lantern_hold_px: 190, lantern_holds: 4, lantern_hull_px: 130, lantern_hulls: 16, lantern_mid_at: 0.45 },
      arr: {},
      text: {},
      historical: { on: true, ink: 0x000000, alpha: 1, fill: 0x000000, width: 1, dash: [], fig: { lantern_alpha: 0.098, lantern_max_alpha: 0.123, lantern_mid_alpha: 0.041 }, arr: { band_alpha: [0, 0, 0.115, 0.295], heat_alpha: [0.55, 0.5, 0.5, 0.6], heat_ink: [1.382164e+07, 7.317658e+06, 4.614298e+06, 2.89392e+06], hue_alpha: [0, 0, 0.025, 0.016], light_alpha: [0.029, 0.012, 0, 0], step_alpha: [0, 0, 0.131, 0.328] } },
      modern: { on: true, ink: 0x000000, alpha: 1, fill: 0x000000, width: 1, dash: [], fig: { lantern_alpha: 0.12, lantern_max_alpha: 0.15, lantern_mid_alpha: 0.05 }, arr: { band_alpha: [0, 0, 0.14, 0.36], heat_alpha: [0.55, 0.5, 0.5, 0.6], heat_ink: [1.0478553e+07, 3.122856e+06, 2.973631e+06, 2.761584e+06], hue_alpha: [0, 0, 0.03, 0.02], light_alpha: [0.035, 0.015, 0, 0], step_alpha: [0, 0, 0.16, 0.4] } },
    },
    ship_tracks: {
      card: 10, desktop: true, mobile: true, off: false,
      zoomMin: 0.75, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { alpha_head: 0.58, alpha_tail: 0.08, dot_px: 6, dot_r: 0.9, label_alpha_tail: 0.2, label_lift: 8, max_points: 1024, tick_alpha_tail: 0.25, tick_every_map_sec: 5400, tick_len: 4, window_map_sec: 27000 },
      arr: {},
      text: { main: 'note' },
      historical: { on: true, ink: 0x000000, alpha: 0.75, fill: 0x000000, width: 0.9, dash: [], fig: { cross_r: 3 }, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 0.75, fill: 0x000000, width: 1, dash: [], fig: {}, arr: {} },
    },
    isobaths: {
      card: 13, desktop: true, mobile: true, off: false,
      zoomMin: 0.75, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { field_texels: 2, figure_alpha_lift: 0.3, gap_px: 22, rim_px: 2, step_px: 6, width: 0.8 },
      arr: { alphas: [0.4, 0.3, 0.22], dash_0: [], dash_1: [6, 3], dash_2: [2, 3], figures: [6, 4, 2], offsets: [14, 32, 54] },
      text: { main: 'note' },
      historical: { on: true, ink: 0x000000, alpha: 1, fill: 0x000000, width: 0.8, dash: [], fig: {}, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 1, fill: 0x000000, width: 0.8, dash: [], fig: {}, arr: {} },
    },
    bottom_nature: {
      card: 14, desktop: true, mobile: true, off: false,
      zoomMin: 1, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { alpha: 0.7, dx: 8, dy: 12, ridge_alpha: 0.85 },
      arr: {},
      text: { main: 'note' },
      historical: { on: true, ink: 0x000000, alpha: 1, fill: 0x000000, width: 0, dash: [], fig: {}, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 1, fill: 0x000000, width: 0, dash: [], fig: {}, arr: {} },
    },
    tidal_diamond: {
      card: 15, desktop: true, mobile: true, off: false,
      zoomMin: 0.5, zoomMax: 99, corner: '', dx: 0, dy: 0, show: 'hover',
      fig: { alpha: 0.8, diamond_dx: -46, diamond_dy: 30, half_h: 7, half_w: 5.5, row_h: 12, table_dx: 10, width: 0.9 },
      arr: {},
      text: { main: 'label', row: 'note' },
      historical: { on: true, ink: 0x000000, alpha: 0.55, fill: 0x000000, width: 0.9, dash: [], fig: {}, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 0.95, fill: 0x000000, width: 0.9, dash: [], fig: { value_alpha: 0.8 }, arr: {} },
    },
    shipping_lanes: {
      card: 16, desktop: true, mobile: true, off: false,
      zoomMin: 0.25, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { anchor_arc_alpha: 0.85, anchor_arc_width: 1.6, anchor_ring_alpha: 0.2, anchor_ring_width: 1, anchor_steps: 60, band: 9, end_alpha: 0.8, end_width: 1, foe_chain_alpha: 0.45, foe_chain_dash_off: 6, foe_chain_dash_on: 4, foe_chain_tol_px: 10, foe_chain_width: 1, gap_bracket_alpha: 0.7, gap_bracket_arm_px: 2.5, gap_bracket_half_px: 8, gap_bracket_width: 0.9, gap_dash_off: 2, gap_dash_on: 2, gap_ghost_alpha: 0.3, gap_tag_alpha: 0.85, gap_tag_off_px: 14, gap_tag_zoom: 1, guide_dash_off: 4, guide_dash_on: 5, guide_disc_alpha: 0.06, guide_ghost_alpha: 0.4, guide_line_alpha: 0.55, guide_line_width: 1, guide_max: 3, guide_px: 250, guide_rim_alpha: 0.3, guide_rim_width: 1, guide_snap_alpha: 0.4, guide_snap_lit_alpha: 0.95, guide_snap_lit_width: 2, guide_snap_width: 1.2, guide_step_px: 8, hunt_dash_off: 3, hunt_dash_on: 3, hunt_half_px: 90, hunt_line_alpha: 0.45, hunt_line_width: 0.8, hunt_px: 130, mate_band: 6, mate_mul: 0.55, teeth_alpha: 0.8, teeth_amp_px: 3.4, teeth_off_px: 8, teeth_step_px: 3.5, teeth_taper_px: 24, teeth_width: 0.9, view_band_alpha: 0.3, view_fill: 0.6, view_sec: 4, view_width: 2.5, water_step_px: 4 },
      arr: {},
      text: { corsairs: 'note', course: 'note', gap: 'note', line: 'note', quiet: 'note' },
      historical: { on: true, ink: 0x000000, alpha: 0.8, fill: 0x000000, width: 1.1, dash: [6, 4], fig: { bar_alpha: 0.85, bar_half_px: 4.5, bar_width: 0.9, char_alpha: 0.8, char_dx: 10, char_dy: 9, char_px: 7.5, char_zoom: 1, corsair_alpha: 0.85, corsair_dy: 13, corsair_ring_alpha: 0.75, corsair_ring_dots: 28, corsair_ring_fill: 0.3, corsair_ring_px: 26, corsair_ring_width: 1.6, course_alpha: 0.85, course_at: 0.3, course_gap_px: 4, course_min_px: 90, end_half_px: 5, end_width: 1.2, hollow_alpha: 0.6, hollow_width: 0.9, light_alpha: 0.95, light_mate_alpha: 0.6, line_alpha: 0.9, line_dy: 11, mate_bar_half_px: 3.5, mate_mul: 0.55, mate_width: 0.8, quiet_lane_lit_mul: 0.6, quiet_lane_mul: 0.5, quiet_lane_width: 0.6, quiet_note_alpha: 0.75, quiet_note_at: 0.5, quiet_note_dy: -12, quiet_note_half_px: 40, quiet_note_zoom: 1, ring_px: 14, rule_alpha: 0.85, rule_gap_px: 1.4, rule_width: 0.8, star_inner: 1.8, star_mid: 5.5, star_outer: 9 }, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 0.95, fill: 0x000000, width: 1.1, dash: [], fig: { anchor_alpha: 0.4, anchor_glow_alpha: 0.2, char_alpha: 0.8, char_dx: 12, char_dy: -6, char_px: 7, char_zoom: 1, fill_alpha: 0.16, glow_px: 16, light_alpha: 0.95, light_glow_alpha: 0.45, mate_mul: 0.55, mate_tick_half_px: 5, quiet_lane_lit_mul: 0.6, quiet_lane_mul: 0.45, ray_half: 1.1, ray_px: 6, relay_dot_alpha: 0.9, relay_dot_px: 1.3, relay_gap_px: 60, relay_glow_alpha: 0.6, relay_glow_px: 7, relay_phase: 0.7, relay_speed_px: 55, ring_px: 12, tick_alpha: 0.8, tick_half_px: 6.5, tick_width: 1, unlit_alpha: 0.45, unlit_width: 0.8, water_fill_alpha: 0.1 }, arr: {} },
    },
    light_chars: {
      card: 17, desktop: true, mobile: false, off: false,
      zoomMin: 1, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { alpha: 0.7, cap_inset: 2, dx: 4, dy: -2, flare_alpha: 0.75, flare_h: 13, flare_lift: 2, hull_alpha: 0.5, hull_angle: 0.9, hull_dy: 2, ring_angle: -0.7 },
      arr: {},
      text: { hull: 'note', main: 'note' },
      historical: { on: true, ink: 0x000000, alpha: 1, fill: 0x000000, width: 0.7, dash: [], fig: { ray_count: 7, ray_r0: 4, ray_r1: 11 }, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 1, fill: 0x000000, width: 0.7, dash: [], fig: {}, arr: {} },
    },
    coastal_profile: {
      card: 18, desktop: true, mobile: true, off: false,
      zoomMin: 0, zoomMax: 99, corner: '', dx: 0, dy: 0, show: 'hover',
      fig: { at_alpha: 0.8, base_lift: 6, fig_room: 22, h: 52, max_columns: 24, outline_alpha: 0.5, top_room: 8, w: 236 },
      arr: { outline_dash: [4, 3] },
      text: { step: 'note' },
      historical: { on: true, ink: 0x000000, alpha: 0.85, fill: 0x000000, width: 1.1, dash: [], fig: { hatch_alpha: 0.55, hatch_px: 3 }, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 0.85, fill: 0x000000, width: 1.2, dash: [], fig: { fill_alpha: 0.16, step_alpha: 0.9 }, arr: {} },
    },
    place_names: {
      card: 19, desktop: true, mobile: true, off: false,
      zoomMin: 0, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { arc_step_px: 6, curve_deg: 22, depth_max: 11, depth_min: 6, depth_size_full: 60, max_names: 20, ridge_alpha: 0.8, ridge_offset: 13, ridge_zoom_min: 1, trench_alpha: 0.75, trench_offset: 26 },
      arr: {},
      text: { dedication: 'note', depth: 'note', ridge: 'name', trench: 'feature' },
      historical: { on: true, ink: 0x000000, alpha: 1, fill: 0x000000, width: 0, dash: [], fig: { dedication_alpha: 0.9, dedication_gap_px: 16, dedication_spacing: 0.4, depth_alpha: 0, ridge_spacing: 1, trench_spacing: 1.5 }, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 1, fill: 0x000000, width: 0, dash: [], fig: { dedication_alpha: 0.9, dedication_gap_px: 16, dedication_spacing: 1.4, depth_alpha: 0.8, ridge_spacing: 2, trench_spacing: 3 }, arr: {} },
    },
    speed_label: {
      card: 22, desktop: true, mobile: false, off: false,
      zoomMin: 0.75, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { alpha: 0.6, dx: 16, dy: 14, hold_sec: 1, min_speed: 0.5, round_to: 1 },
      arr: {},
      text: { main: 'note' },
      historical: { on: true, ink: 0x000000, alpha: 1, fill: 0x000000, width: 0, dash: [], fig: {}, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 1, fill: 0x000000, width: 0, dash: [], fig: {}, arr: {} },
    },
    heraldry: {
      card: 23, desktop: true, mobile: true, off: false,
      zoomMin: 0, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { alpha: 0.85, dx: 30, dy: -4, label_dx: 12, sub_alpha: 0.55 },
      arr: {},
      text: { main: 'label', sub: 'note' },
      historical: { on: true, ink: 0x000000, alpha: 0.75, fill: 0x000000, width: 0.9, dash: [], fig: { crest_base: 10, crest_gap: 5, crest_peak: 2, crest_top: 14, crest_w: 7, label_dy: 2, shield_h: 19, shield_w: 15 }, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 0.85, fill: 0x000000, width: 0.9, dash: [], fig: { anchor_dy: 1, anchor_scale: 0.7, label_dy: -3, port_r: 7, sub_dy: 7 }, arr: {} },
    },
    imprint: {
      card: 24, desktop: true, mobile: false, off: false,
      zoomMin: 0, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { gap_px: 40, hash_chars: 6, line_em: 1.4 },
      arr: {},
      text: { line: 'label' },
      historical: { on: true, ink: 0x000000, alpha: 0.6, fill: 0x000000, width: 0, dash: [], fig: {}, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 0.7, fill: 0x000000, width: 0, dash: [], fig: {}, arr: {} },
    },
    hazards: {
      card: 26, desktop: true, mobile: true, off: false,
      zoomMin: 0.5, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { cross_every: 4, cross_inset: 9, cross_r: 3.5, label_alpha: 0.55, line_alpha: 0.42, line_offset: 8, rk_dx: 13, star_r: 4 },
      arr: {},
      text: { main: 'note' },
      historical: { on: false, ink: 0x000000, alpha: 0.85, fill: 0x000000, width: 0.9, dash: [1, 4], fig: { dot_r: 0.8 }, arr: { dots: [0, 6, -5, 4, 5, 4] } },
      modern: { on: false, ink: 0x000000, alpha: 0.85, fill: 0x000000, width: 0.9, dash: [1.2, 3], fig: { dot_offset: 3, dot_r: 0.7 }, arr: {} },
    },
    banks: {
      card: 27, desktop: true, mobile: true, off: false,
      zoomMin: 0.5, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { alpha: 0.5, fish_dx: 50, fish_dy: -22, join_cells: 2, label_dy: -54, min_fields: 2, name_offset: 8, sub_dy: -42, width: 0.9 },
      arr: {},
      text: { main: 'name', sub: 'note' },
      historical: { on: true, ink: 0x000000, alpha: 0.8, fill: 0x000000, width: 0.9, dash: [1, 3.5], fig: {}, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 0.8, fill: 0x000000, width: 0.9, dash: [1.5, 3], fig: { sub_alpha: 1 }, arr: {} },
    },
    harbour_limits: {
      card: 28, desktop: true, mobile: true, off: false,
      zoomMin: 0.5, zoomMax: 99, corner: '', dx: 0, dy: 0, show: 'hover',
      fig: { alpha: 0.6, label_gap: 6, width: 1 },
      arr: {},
      text: { main: 'note' },
      historical: { on: true, ink: 0x000000, alpha: 0.6, fill: 0x000000, width: 1, dash: [1, 3.5], fig: {}, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 0.55, fill: 0x000000, width: 1, dash: [6, 3], fig: {}, arr: {} },
    },
    cables: {
      card: 29, desktop: true, mobile: true, off: false,
      zoomMin: 0.5, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { alpha: 0.4, arrow_every: 70, arrow_head: 5, arrow_len: 10, arrow_side: 3, halo_alpha: 0.12, halo_r: 5, label_lift: 12, pulse_hz: 0.35, pulse_r: 2.2, stand_off: 14, step_px: 2, wave_amp: 2.4, wave_len: 6 },
      arr: {},
      text: { main: 'note' },
      historical: { on: true, ink: 0x000000, alpha: 0.4, fill: 0x000000, width: 0.9, dash: [1.2, 4], fig: {}, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 0.45, fill: 0x000000, width: 0.9, dash: [], fig: {}, arr: {} },
    },
    restricted: {
      card: 30, desktop: true, mobile: true, off: false,
      zoomMin: 0, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { alpha: 0.6, fill_alpha: 0.05, fill_r_k: 0.866, legend_dx: 10, legend_dy: 66, tick_len: 4, width: 1 },
      arr: {},
      text: { main: 'label', word: 'feature' },
      historical: { on: true, ink: 0x000000, alpha: 0.7, fill: 0x000000, width: 1, dash: [1, 3.5], fig: { sentence_alpha: 0.55, word_alpha: 0.7, word_dy: 20 }, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 0.7, fill: 0x000000, width: 1, dash: [6, 3], fig: {}, arr: {} },
    },
    limit_line: {
      card: 34, desktop: true, mobile: true, off: false,
      zoomMin: 0.5, zoomMax: 99, corner: '', dx: 0, dy: 0, show: 'hover',
      fig: { alpha: 0.45, text_offset: 9, width: 0.9 },
      arr: {},
      text: { main: 'label' },
      historical: { on: true, ink: 0x000000, alpha: 0.75, fill: 0x000000, width: 0.9, dash: [1, 5], fig: { spacing: 0.5 }, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 0.75, fill: 0x000000, width: 0.9, dash: [1.5, 4], fig: { spacing: 2 }, arr: {} },
    },
    ribbons: {
      card: 35, desktop: true, mobile: true, off: false,
      zoomMin: 0, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { lift: 126 },
      arr: {},
      text: { main: 'name' },
      historical: { on: true, ink: 0x000000, alpha: 0.85, fill: 0x000000, width: 0.9, dash: [], fig: { scroll_alpha: 0.6, scroll_h: 22, scroll_w: 236, tail_w: 14 }, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 0.7, fill: 0x000000, width: 0.7, dash: [], fig: { caps_alpha: 0.7, caps_spacing: 4, disc_gap: 2, disc_r: 1.5, leader_alpha: 0.4, leader_len: 32, leader_top: 8 }, arr: {} },
    },
    border_band: {
      card: 39, desktop: true, mobile: false, off: false,
      zoomMin: 0.5, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { band_alpha: 0.55, band_px: 7, edge_margin: 20, figure_alpha: 0.6, inner_rule_alpha: 0.4, numeral_dx: 3, numeral_dy_bottom: 4, numeral_dy_side: 0, numeral_every: 5 },
      arr: {},
      text: { main: 'label' },
      historical: { on: false, ink: 0x000000, alpha: 0.34, fill: 0x000000, width: 0.8, dash: [], fig: { fill_dark: 0.34, fill_light: 0.08, numeral_dy: 10, outer_rule_alpha: 0.35 }, arr: {} },
      modern: { on: false, ink: 0x000000, alpha: 0.55, fill: 0x000000, width: 0.8, dash: [], fig: { half_tick_frac: 0.5, numeral_dy: 9, tick_frac: 1 }, arr: {} },
    },
    legend: {
      card: 40, desktop: true, mobile: false, off: false,
      zoomMin: 0, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { label_alpha: 0.75, panel_alpha: 0.72, row_h: 14, swatch_h: 16, swatch_w: 28 },
      arr: {},
      text: { letter: 'label' },
      historical: { on: true, ink: 0x000000, alpha: 0.9, fill: 0x000000, width: 0.8, dash: [], fig: {}, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 0.85, fill: 0x000000, width: 0.8, dash: [], fig: {}, arr: {} },
    },
    designations: {
      card: 41, desktop: true, mobile: true, off: false,
      zoomMin: 0.6, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { tag_dx: 14, tag_dy: -10 },
      arr: {},
      text: { main: 'note' },
      historical: { on: false, ink: 0x000000, alpha: 0.8, fill: 0x000000, width: 0, dash: [], fig: {}, arr: {} },
      modern: { on: false, ink: 0x000000, alpha: 0.8, fill: 0x000000, width: 0, dash: [], fig: {}, arr: {} },
    },
    bearing_lines: {
      card: 42, desktop: true, mobile: true, off: false,
      zoomMin: 0.5, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { alpha: 0.5, end_off: 14, label_at: 0.5, label_lift: 5, label_room: 0.9, stand_off: 16, width: 0.9 },
      arr: {},
      text: { main: 'label' },
      historical: { on: true, ink: 0x000000, alpha: 0.8, fill: 0x000000, width: 0.9, dash: [3, 3], fig: {}, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 0.8, fill: 0x000000, width: 0.9, dash: [], fig: {}, arr: {} },
    },
    range_rings: {
      card: 46, desktop: true, mobile: true, off: false,
      zoomMin: 0.5, zoomMax: 99, corner: '', dx: 0, dy: 0, show: 'hover',
      fig: { alpha0: 0.45, alpha_step: 0.08, hull_ring_base: 20, hull_ring_step: 40, hull_rings: 3, label_dx: 4, label_dy: 8, width: 0.8 },
      arr: {},
      text: { main: 'note' },
      historical: { on: true, ink: 0x000000, alpha: 0.7, fill: 0x000000, width: 0.8, dash: [1, 3], fig: {}, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 0.7, fill: 0x000000, width: 0.8, dash: [3, 3], fig: {}, arr: {} },
    },
    listening_watch: {
      card: 47, desktop: true, mobile: true, off: false,
      zoomMin: 0.45, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { axis_h: 9, axis_inset_px: 8, axis_lift_px: 1, grid_alpha: 0.15, ground_alpha: 0.6, label_dy: 8, ring_dash_fill: 0.5, ring_dashes: 18, ring_px: 17, rule_w: 0.6, sample_sec: 1, strip_h: 56, strip_w: 232, trace_alpha_age: 0.6, trace_alpha_floor: 0.25, trace_h: 2, trace_near_floor: 0.4, trace_near_k: 0.6, trace_px: 2.5, window_map_sec: 600 },
      arr: {},
      text: { main: 'note' },
      historical: { on: true, ink: 0x000000, alpha: 0.5, fill: 0x000000, width: 1, dash: [], fig: {}, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 0.5, fill: 0x000000, width: 1, dash: [], fig: {}, arr: {} },
    },
    torpedo_run: {
      card: 48, desktop: true, mobile: true, off: false,
      zoomMin: 0.5, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { aim_alpha: 0.5, aim_label_dx: 16, fuse_cross_r: 3, hold_alpha: 0.4, ring_alpha: 0.6, text_offset: 8, width: 1 },
      arr: { aim_dash: [2, 2] },
      text: { hold: 'note', main: 'note' },
      historical: { on: true, ink: 0xe0705f, alpha: 0.8, fill: 0x000000, width: 0.9, dash: [1, 4], fig: { hold_angle: 0.75, ring_angle: 2.95, spacing: 0.5 }, arr: { hold_dash: [1, 5] } },
      modern: { on: true, ink: 0xe0705f, alpha: 0.85, fill: 0x000000, width: 1, dash: [6, 4], fig: { hold_angle: 0.8, ring_angle: 2.7, spacing: 2 }, arr: { hold_dash: [2, 4] } },
    },
    picket_line: {
      card: 49, desktop: true, mobile: true, off: false,
      zoomMin: 0.45, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { float_px: 2.5, float_step_px: 22, inset_px: 12, label_dy: 14, sag_px: 6, sag_step_px: 4 },
      arr: {},
      text: { main: 'note' },
      historical: { on: true, ink: 0x000000, alpha: 0.7, fill: 0x000000, width: 1, dash: [], fig: {}, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 0.65, fill: 0x000000, width: 1, dash: [5, 3], fig: {}, arr: {} },
    },
    cardinal_marks: {
      card: 50, desktop: true, mobile: true, off: false,
      zoomMin: 0.6, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { max_guts: 96, spacing_px: 160 },
      arr: {},
      text: { main: 'note' },
      historical: { on: true, ink: 0x000000, alpha: 0.9, fill: 0x000000, width: 1, dash: [], fig: { ball_alpha: 0.95, ball_at_px: 22.5, ball_px: 2.3, label_alpha: 0.85, label_dy: 18, perch_from_px: 10, perch_to_px: 20 }, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 0.9, fill: 0x000000, width: 1.6, dash: [], fig: { gap_glow_alpha: 0.16, gap_glow_cell_px: 10, gap_glow_px: 14, post_face_px: 17, post_glow_alpha: 0.35, post_glow_px: 9, post_half_px: 5 }, arr: {} },
    },
    battle_marks: {
      card: 52, desktop: true, mobile: true, off: false,
      zoomMin: 0, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { alpha_new: 0.9, alpha_old: 0.55, alpha_read_mul: 0.45, dart_scale: 0.55, label_dx: 13, max_marks: 24, pick_px: 14, window_world_sec: 86400 },
      arr: {},
      text: { main: 'note' },
      historical: { on: true, ink: 0x000000, alpha: 0.85, fill: 0x000000, width: 0.9, dash: [], fig: {}, arr: {} },
      modern: { on: true, ink: 0xe0705f, alpha: 1, fill: 0x000000, width: 0.9, dash: [], fig: {}, arr: {} },
    },
    here_be_monsters: {
      card: 53, desktop: true, mobile: true, off: false,
      zoomMin: 0, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { alpha: 0.85, head_dx: 3, head_dy: -3, head_px: 3.5, label_dy: 30, last_label_k: 0.7, life_world_sec: 86400, mark_px: 8, max_marks: 8, serpent_amp_div: 7.3, serpent_px: 44, serpent_steps: 22, serpent_waves: 5, tag_dx: 14, tag_dy: -10, width: 1.1 },
      arr: {},
      text: { main: 'note' },
      historical: { on: true, ink: 0x000000, alpha: 0.85, fill: 0x000000, width: 1.4, dash: [], fig: {}, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 0.9, fill: 0x000000, width: 1.1, dash: [], fig: {}, arr: {} },
    },
    epicentre: {
      card: 54, desktop: true, mobile: true, off: false,
      zoomMin: 0, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { label_dy: 22, ring_samples: 64, ring_text_gap: 8, star_alpha: 0.9, star_r_long: 9, star_r_short: 4, star_width: 1.1 },
      arr: {},
      text: { main: 'label' },
      historical: { on: true, ink: 0x000000, alpha: 0.5, fill: 0x000000, width: 1, dash: [1, 4], fig: { label_alpha: 0.8 }, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 0.5, fill: 0x000000, width: 1, dash: [5, 4], fig: { label_alpha: 0.8 }, arr: {} },
    },
    clan_burgee: {
      card: 56, desktop: true, mobile: true, off: false,
      zoomMin: 0.5, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { alpha: 0.9, dx: 14, dy: -24, label_gap: 6 },
      arr: {},
      text: { main: 'note', tag: 'note' },
      historical: { on: true, ink: 0x000000, alpha: 0.75, fill: 0x000000, width: 0.8, dash: [], fig: { flag_h: 12, flag_w: 22, tag_dx: 6 }, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 0.8, fill: 0x000000, width: 1, dash: [], fig: { flag_h: 10, flag_w: 16 }, arr: {} },
    },
    spoil_ground: {
      card: 57, desktop: true, mobile: true, off: false,
      zoomMin: 0.75, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { alpha: 0.55, dx: 22, line_h: 6, r: 17, width: 0.9 },
      arr: {},
      text: { main: 'label', sub: 'note' },
      historical: { on: true, ink: 0x000000, alpha: 0.75, fill: 0x000000, width: 0.9, dash: [1, 3], fig: {}, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 0.8, fill: 0x000000, width: 0.9, dash: [3, 3], fig: { sub_alpha: 1 }, arr: {} },
    },
    works: {
      card: 58, desktop: true, mobile: true, off: false,
      zoomMin: 0.75, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { alpha: 0.8, crane_dx: -16, crane_dy: 30, label_dx: -8 },
      arr: {},
      text: { main: 'label', sub: 'note' },
      historical: { on: true, ink: 0x000000, alpha: 0.75, fill: 0x000000, width: 0.9, dash: [], fig: { label_dy: 12 }, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 0.8, fill: 0x000000, width: 0.9, dash: [], fig: { label_dy: 8, next_dy: 18, sub_alpha: 1 }, arr: {} },
    },
    sonar_sweep: {
      card: 59, desktop: true, mobile: true, off: false,
      zoomMin: 0, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { flare_alpha: 0.35, flare_r0: 6, flare_r1: 6, label_dx: 14, label_dy: -14, line_alpha: 0.85, line_w: 1.2, ring_alpha0: 0.3, ring_alpha1: 0.6, ring_r: 9, turn_sec: 10 },
      arr: { stop_alpha: [0, 0.03, 0.16, 0.38], stop_at: [0, 0.7, 0.985, 1] },
      text: { main: 'note' },
      historical: { on: false, ink: 0x000000, alpha: 0, fill: 0x000000, width: 0, dash: [], fig: {}, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 0.75, fill: 0x000000, width: 1.2, dash: [], fig: {}, arr: {} },
    },
    margin_warning: {
      card: 61, desktop: true, mobile: true, off: false,
      zoomMin: 0, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { offset_px: 80, spacing_px: 1000 },
      arr: {},
      text: { caution: 'feature', line: 'note', sub: 'label', title: 'feature' },
      historical: { on: true, ink: 0x000000, alpha: 0.34, fill: 0x000000, width: 0.6, dash: [], fig: { rule_alpha: 0.3, rule_b: -1, rule_half: 70, rule_sag: 3, rule_steps: 8, sub_alpha: 0.3, sub_b: 15, title_b: -15 }, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 0.45, fill: 0x000000, width: 1, dash: [], fig: { box_h: 60, box_w: 124, caution_alpha: 0.5, caution_dy: 12, line_alpha: 0.45, line_dy: 30, line_pitch: 10, rule_alpha: 0.3, rule_dy: 20, rule_inset: 8, rule_width: 0.6 }, arr: {} },
    },
    neat_line: {
      card: 62, desktop: true, mobile: true, off: false,
      zoomMin: 0, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { divisions_per_block: 1, label_every: 5, label_zoom_min: 0.75, rule_gap: 2 },
      arr: {},
      text: { main: 'note' },
      historical: { on: true, ink: 0x000000, alpha: 0.5, fill: 0x000000, width: 1, dash: [], fig: { band_px: 7, block_alpha: 0.28, label_alpha: 0.45, label_d: 14, outer_alpha: 0.35, outer_width: 0.7 }, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 0.5, fill: 0x000000, width: 1, dash: [], fig: { bar_in: 5, bar_out: 9, fill_alpha: 0.5, hollow_alpha: 0.35, hollow_width: 0.6, label_alpha: 0.5, label_d: 16, tick_alpha: 0.5, tick_out: 14, tick_width: 0.8 }, arr: {} },
    },
    memorial_reef: {
      card: 63, desktop: true, mobile: true, off: false,
      zoomMin: 0.75, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { alpha: 0.85, arc_offset: 26, arc_step_px: 6, curve_deg: 18, line_dy: 30, line_h: 11 },
      arr: {},
      text: { main: 'name', sub: 'note', tag: 'note' },
      historical: { on: true, ink: 0x000000, alpha: 1, fill: 0x000000, width: 0.9, dash: [], fig: { coral_depth: 3, coral_dy: 6, coral_len: 9, letter_spacing: 0.4 }, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 1, fill: 0x000000, width: 0.9, dash: [2, 2.5], fig: { mark_alpha: 0.8, mark_r: 2.5, tag_alpha: 0.8 }, arr: {} },
    },
    hold_site: {
      card: 64, desktop: true, mobile: true, off: false,
      zoomMin: 1, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { alpha: 1, label_dy: -28, line_h: 12, star_alpha: 0.9, star_r: 7, star_r_inner: 2.9, symbol_scale: 1 },
      arr: {},
      text: { main: 'label', sub: 'note' },
      historical: { on: true, ink: 0x000000, alpha: 1, fill: 0x000000, width: 0.9, dash: [], fig: {}, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 1, fill: 0x000000, width: 0.9, dash: [], fig: {}, arr: {} },
    },
    pool_monument: {
      card: 65, desktop: true, mobile: true, off: false,
      zoomMin: 1, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { label_dy: -30, leaf_alpha: 0.85, leaf_dt: 0.13, leaf_off: 2.6, leaf_rx: 3.6, leaf_ry: 1.5, leaf_spread: 1, leaf_t0: 0.12, leaf_turn: -0.5, leaves: 7, stem_alpha: 0.85, stem_cx: 0, stem_cy: -2, stem_steps: 12, stem_x0: -14, stem_x1: 14, stem_y0: 8, stem_y1: -8 },
      arr: {},
      text: { main: 'label', sub: 'note' },
      historical: { on: true, ink: 0x000000, alpha: 1, fill: 0x000000, width: 0.9, dash: [], fig: { line_h: 12 }, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 1, fill: 0x000000, width: 0.9, dash: [], fig: { leaf_width: 0.7, line_h: 10 }, arr: {} },
    },
    map_markers: {
      card: 66, desktop: true, mobile: true, off: true,
      zoomMin: 0, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { age_steps: 60, disc_glyph: 4.5, disc_glyph_hollow: 4, disc_r: 7, flag_dot_r: 1.8, flag_drop: 12, flag_glyph: 3.4, flag_glyph_dx: 5.6, flag_h: 9, flag_label_dy: 8, flag_notch: 4, flag_staff: 24, flag_staff_width: 1.2, flag_w: 14, flare_alpha: 0.9, flare_alpha_age: 0.5, flare_dot_r: 2.6, flare_flicker: 0.15, flare_flicker_rate: 13, flare_gap: 2.2, flare_h: 30, flare_h_age: 18, flare_head_dy: 6, flare_label_dy: 9, flare_width: 4, flare_width_hollow: 0.9, glyph_width: 1.2, label_age_fade: 0.35, label_alpha: 0.9, menu_centre_px: 44, menu_reach_px: 50, menu_target_px: 48, pencil_alpha: 0.9, pencil_alpha_age: 0.6, pencil_dash_age: 0.75, pencil_label_dy: 16, pencil_r: 13, pencil_r2: 15.5, pencil_width: 1.3, pick_px: 14, pin_dot_r: 2, pin_fade: 0.65, pin_glyph: 5, pin_glyph_hollow: 4.6, pin_glyph_width: 1.3, pin_head_dy: 15, pin_head_r: 9, pin_label_dy: 9, pin_width: 1.6, pulse_alpha: 0.7, pulse_alpha_age: 0.6, pulse_label_dy: 12, pulse_period_age_sec: 2.4, pulse_period_sec: 1.6, pulse_reach: 22, pulse_reach_age: 12, quick_ring_alpha: 0.8, quick_ring_r0: 14, quick_ring_reach: 46, quick_ring_sec: 2.4, quick_ring_still: 0.4, quick_ring_width: 2, ring_width: 1.5 },
      arr: { pencil_dash: [3, 3] },
      text: { name: 'label', pencil: 'label' },
      historical: { on: true, ink: 0x000000, alpha: 1, fill: 0x000000, width: 0, dash: [], fig: {}, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 1, fill: 0x000000, width: 0, dash: [], fig: {}, arr: {} },
    },
    faction_key: {
      card: 67, desktop: true, mobile: false, off: true,
      zoomMin: 0, zoomMax: 99, corner: 'br', dx: 0, dy: 0, show: '',
      fig: { badge_px: 14, chip_dash_px: 12, dash_px: 48, gap_px: 6, npc_mark_gap_px: 2, npc_mark_px: 14, row_px: 24, swatch_alpha: 0.95, swatch_px: 8 },
      arr: {},
      text: { row: 'label', title: 'name' },
      historical: { on: true, ink: 0x000000, alpha: 1, fill: 0x000000, width: 0, dash: [], fig: {}, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 1, fill: 0x000000, width: 0, dash: [], fig: {}, arr: {} },
    },
    inbox_pins: {
      card: 68, desktop: true, mobile: true, off: true,
      zoomMin: 0, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { alpha_bad: 1, alpha_plain: 0.9, disc_alpha: 0.85, dot_r: 2, head_dy: 18, head_r: 9, inset_cells: 4, inset_name_chars: 9, inset_pin_r: 7, inset_px: 56, lit_gap: 3, lit_width: 1.2, num_alpha: 1, pick_px: 14, ring_width: 1.6, stem_alpha: 0.7, stem_width: 1 },
      arr: { inset_trench_dash: [2, 1.5] },
      text: { num: 'label' },
      historical: { on: true, ink: 0x000000, alpha: 1, fill: 0x000000, width: 0, dash: [], fig: {}, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 1, fill: 0x000000, width: 0, dash: [], fig: {}, arr: {} },
    },
    points_of_interest: {
      card: 69, desktop: true, mobile: true, off: true,
      zoomMin: 0, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { abbr_arrow_per_tide: 12, abbr_arrow_px: 12, abbr_gate_dy: -5, abbr_gate_gap: 4, abbr_name_alpha: 0.9, abbr_name_dy: 1, abbr_note_alpha: 0.7, abbr_note_dy: 12, abbr_rate_dy: 13, abbr_spent_alpha: 0.5, bake_scale: 4, bed_dot_alpha: 0.9, bed_dot_px: 2.5, bed_dot_zoom: 0.75, bed_glint_alpha: 0.9, bed_glint_core_alpha: 0.4, bed_glint_core_px: 1.4, bed_glint_dx: 1, bed_glint_dy: -1, bed_glint_flash: 0.18, bed_glint_grow_px: 6, bed_glint_r0_px: 2, bed_glint_sec: 3, bed_glint_width: 1, bed_glint_work_sec: 1.2, bed_rise_per_sec: 0.22, bed_rise_px: 22, bed_speck_alpha: 0.75, bed_speck_grow_px: 0.5, bed_speck_low: 0.3, bed_speck_px: 0.9, bed_speck_share: 0.7, bed_speck_spread_px: 10, bed_speck_sway: 5, bed_speck_sway_px: 2, bed_specks: 7, bed_stream_alpha: 0.35, bed_stream_flare: 0.58, bed_stream_gap_px: 6, bed_stream_half_px: 32, bed_stream_lines: 5, bed_stream_off: 5, bed_stream_on: 6, bed_stream_pinch: 0.42, bed_stream_px_per_sec: 26, bed_stream_slack_alpha: 0.3, bed_stream_slack_off: 4, bed_stream_slack_on: 1, bed_stream_step_px: 4, bed_stream_tide_alpha: 0.45, bed_stream_width: 1.1, dot_alpha: 0.95, dot_bar_alpha: 0.9, dot_bar_dy: 9, dot_bar_len: 28, dot_bar_w: 2, dot_ground_alpha: 0.7, dot_ground_px: 4, dot_label_dx: 8, dot_label_dy: 0.5, dot_main_alpha: 0.95, dot_px: 2.6, dot_spent_alpha: 0.55, gate_area_alpha: 0.6, gate_area_width: 1, grammar_dot_px: 2.2, grammar_orbit_px: 15, grammar_orbit_sec: 4, grammar_trail: 0.25, grammar_trail_alpha: 0.5, grammar_trail_w: 1.2, lair_design_dy: 15, lair_kind_alpha: 0.9, lair_kind_dx: 11, lair_kind_dy: -11, lair_kind_scale: 0.6, lair_state_dy: 11, left_alpha: 0.95, mag_step: 0.1, pick_half_px: 11, reach_arrow_alpha: 0.6, reach_arrow_head: 3, reach_arrow_per_tide: 8, reach_arrow_px: 4, reach_arrow_rings: 2, reach_cell_edge: 0.16, reach_cell_fill: 0.04, reach_cell_inset: 1, reach_lair_dashes: 63, reach_lair_fill: 0.05, reach_lair_fill_away: 0.02, reach_lair_ring: 0.55, reach_lair_ring_away: 0.2, reach_slack_alpha: 0.5, reach_slack_px: 1.3, reach_width: 1.2, slack_below: 0.2, vent_steps: 8 },
      arr: { abbr_name_dx: [9, 11, 13, 9, 14], bed_left_dy: [20, 22], grammar_left_dy: [24, 24], reach_left_dy: [34, 22] },
      text: { name: 'label', note: 'note' },
      historical: { on: true, ink: 0x000000, alpha: 1, fill: 0x000000, width: 0, dash: [1, 3.5], fig: {}, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 1, fill: 0x000000, width: 0, dash: [6, 3], fig: {}, arr: {} },
    },
    fairways: {
      card: 70, desktop: true, mobile: true, off: false,
      zoomMin: 0.25, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { smooth_passes: 2 },
      arr: { glow_stop_alpha: [1, 0], glow_stops: [0, 1] },
      text: { name: 'name', sounding: 'note' },
      historical: { on: true, ink: 0x000000, alpha: 0.8, fill: 0x000000, width: 0.8, dash: [], fig: { buoy_alpha: 0.9, buoy_unit_px: 1, name_alpha: 0.75, name_dy: -18, sounding_far_px: 64, sounding_phase_px: 14, sounding_side_px: 5, sounding_step_px: 32, waterline_alpha: 0.55, waterline_half_px: 5 }, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 1, fill: 0x000000, width: 0, dash: [], fig: { buoy_alpha: 0.95, buoy_glow_alpha: 0.32, buoy_glow_px: 10, buoy_px: 2.4, glow_alpha: 0.038, glow_px: 23, glow_step_px: 5 }, arr: {} },
    },
    shoal_stipple: {
      card: 71, desktop: true, mobile: true, off: false,
      zoomMin: 0, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { max: 12, spread_px: 18 },
      arr: { per_cell: [8, 3, 0.34, 0] },
      text: {},
      historical: { on: false, ink: 0x000000, alpha: 1, fill: 0x000000, width: 1, dash: [], fig: { dot_alpha: 0.34, dot_r: 0.85 }, arr: {} },
      modern: { on: false, ink: 0x000000, alpha: 1, fill: 0x000000, width: 1, dash: [], fig: { dot_alpha: 0.28, dot_r: 0.7 }, arr: {} },
    },
    edge_seam: {
      card: 72, desktop: true, mobile: true, off: false,
      zoomMin: 0, zoomMax: 99, corner: '', dx: 0, dy: 0, show: '',
      fig: { glow_px: 6, hulls: 16, line_px: 1, radius_px: 150 },
      arr: {},
      text: {},
      historical: { on: true, ink: 0x000000, alpha: 1, fill: 0x000000, width: 1, dash: [], fig: { glow_alpha: 0.06, line_alpha: 0.32 }, arr: {} },
      modern: { on: true, ink: 0x000000, alpha: 1, fill: 0x000000, width: 1, dash: [], fig: { glow_alpha: 0.06, line_alpha: 0.4 }, arr: {} },
    },
  },
} as const;

/** The slug of one piece of chart furniture. */
export type ChartPieceId = keyof typeof CHART.pieces;

/**
 * The four chart text steps, smallest first (ui-map-interface.md §17.4,
 * R1796). A glyph quad carries the index of its step in its flags, so
 * the order is the contract between the pieces and the quad shader.
 */
export const CHART_STEPS = ['note', 'label', 'name', 'feature'] as const;

/** One chart text step. */
export type ChartStep = (typeof CHART_STEPS)[number];

/** The per-reading keys a Chart theme may set for one piece
 * (chart.toml [chart.theme], themes.md §3.6). Every other key of a
 * piece stays as CHART gives it. */
export const CHART_THEME_TUNABLE = ['on'] as const;

/** What a Chart theme sets for one piece in one reading. */
export interface ChartThemeReading {
  readonly on?: boolean;
}

/** A Chart theme body: an overlay on CHART, piece -> reading -> keys. */
export type ChartThemeOverlay = {
  readonly [P in ChartPieceId]?: {
    readonly historical?: ChartThemeReading;
    readonly modern?: ChartThemeReading;
  };
};

/** One vendored UI theme: a colour per channel token and the two
 * alphas of the token sheet (themes.md §3.1). */
export interface VendoredUITheme {
  readonly id: string;
  readonly key: string;
  readonly tokens: Readonly<Record<string, string>>;
  readonly alphas: Readonly<Record<string, number>>;
}

/**
 * The vendored themes (data/presentation/themes.toml, themes.md §4),
 * in the body schema of a custom theme. Every category starts with
 * `auto`, which is today's look. `key` is the tier mark: '' is free,
 * and any other value is the entitlement key the entry needs. The UI
 * category holds no AUTO: AUTO and the faction themes are derived in
 * ui/theme.ts. The Music and the SFX category are the audio manifest.
 */
export const VENDORED_THEMES = {
  ui: [
    { id: 'blue', key: '', tokens: { accent: '#759ee9', text: '#b3c2db', faint: '#5d6d87', panel: '#050d1a', sheet: '#050915', ink: '#030711', deep: '#010409' }, alphas: { panelAlpha: 0.82, edgeAlpha: 0.25 } },
    { id: 'graphite', key: '', tokens: { accent: '#c4c4c4', text: '#b4b4b4', faint: '#696969', panel: '#0d0d0d', sheet: '#0a0a0a', ink: '#070707', deep: '#030303' }, alphas: { panelAlpha: 0.86, edgeAlpha: 0.18 } },
  ],
  world: [
    { id: 'auto', key: '', territory: 'default', terrain: 'default', currents: 'quiet-drift', currentsHeat: 'full-flow', depth: 'feathered', factionSite: 'charge', factionHull: 'pip', factionEdge: 'dash', factionKey: 'key', spawn: 'sonar-bloom', notices: 'drain', dock: 'magnet', banner: 'abyss', torpedo: 'terminal-burn', detonation: 'tide-front', seaMineDetonation: 'reveal-ping', reload: 'clock-digit', damage: 'rise', shotMelee: 'burst-fire', shotArtillery: 'track-arc', shotSentinel: 'charge-and-snap', hitShield: 'interference', hitHull: 'through-and-through', hitSink: 'implosion', holdFire: 'safety-lock', beam: 'breathing-line', aura: 'regen-wave', gather: 'chips-lift', anchoring: 'corner-brackets', seaMineLay: 'countdown-ring', deployableLay: 'carpet-unroll', seaMineCollect: 'ping-and-pull', deployableCollect: 'blueprint-drain', cacheWork: 'keel-squeeze' },
    { id: 'minimal', key: '', territory: 'default', terrain: 'default', currents: 'stream-atlas', currentsHeat: 'dusk-field', depth: 'stepped', factionSite: 'charge', factionHull: 'pip', factionEdge: 'dash', factionKey: 'key', spawn: 'stacked-deck', notices: 'bare-type', dock: 'hard-dock', banner: 'abyss', torpedo: 'ribbon', detonation: 'pressure-shell', seaMineDetonation: 'water-column', reload: 'countdown-tag', damage: 'leader-pin', shotMelee: 'stitch', shotArtillery: 'shell-lob', shotSentinel: 'interceptor-thread', hitShield: 'ring-flare', hitHull: 'list', hitSink: 'wreck-print', holdFire: 'clamp', beam: 'pip-cable', aura: 'coverage-disc', gather: 'work-lights', anchoring: 'ground-line', seaMineLay: 'plain-drop', deployableLay: 'plain-set', seaMineCollect: 'closing-ring', deployableCollect: 'quiet-take', cacheWork: 'clock-rim' },
    { id: 'flashy', key: '', territory: 'hex', terrain: 'material', currents: 'streaks', currentsHeat: 'full-flow', depth: 'feathered', factionSite: 'charge', factionHull: 'pip', factionEdge: 'dash', factionKey: 'key', spawn: 'seaquake-settle', notices: 'ribbon', dock: 'surface-wake', banner: 'echo-count', torpedo: 'two-stage', detonation: 'fireball-rim', seaMineDetonation: 'pip-fuse', reload: 'loading-slide', damage: 'pop-and-drop', shotMelee: 'arc-discharge', shotArtillery: 'star-shell', shotSentinel: 'charge-and-snap', hitShield: 'rim-sparks', hitHull: 'inner-fire', hitSink: 'steam-shroud', holdFire: 'hatch-shimmer', beam: 'twisted-pair', aura: 'regen-wave', gather: 'grab-beats', anchoring: 'bubble-column', seaMineLay: 'ripple', deployableLay: 'crane-lowers', seaMineCollect: 'hex-sweep', deployableCollect: 'weigh-anchors', cacheWork: 'hex-sweep' },
  ],
  marks: [
    { id: 'auto', key: '', ship: 'default', shipCorsair: 'follow', shipCutlass: 'follow', shipLancer: 'follow', shipFalconet: 'follow', shipBasilisk: 'follow', shipBombard: 'follow', shipCommodore: 'follow', shipVedette: 'follow', shipDredger: 'follow', shipSentinel: 'follow', shipBeacon: 'follow', shipOracle: 'follow', shipTender: 'follow', shipSapper: 'follow', ownFleet: 'white-core', squadFleet: 'trailing-dot', shield: 'stack', digits: 'mono', hold: 'beacon-post', structure: 'default', deployable: 'terrain-kin', seaMine: 'overprint-restricted', ownHold: 'ground-plate', squadHold: 'half-plate', deposit: 'drain', mapMarker: 'pulse-ring', poi: 'chart-abbreviation' },
    { id: 'minimal', key: '', ship: 'insignia', shipCorsair: 'follow', shipCutlass: 'follow', shipLancer: 'follow', shipFalconet: 'follow', shipBasilisk: 'follow', shipBombard: 'follow', shipCommodore: 'follow', shipVedette: 'follow', shipDredger: 'follow', shipSentinel: 'follow', shipBeacon: 'follow', shipOracle: 'follow', shipTender: 'follow', shipSapper: 'follow', ownFleet: 'caret-pair', squadFleet: 'tint-only', shield: 'sheath', digits: 'seg-stem', hold: 'dome', structure: 'pictogram', deployable: 'effect-fields', seaMine: 'foul-ground', ownHold: 'crown-chevrons', squadHold: 'single-chevron', deposit: 'strike', mapMarker: 'map-pin', poi: 'dot-and-label' },
    { id: 'flashy', key: '', ship: 'by-name', shipCorsair: 'follow', shipCutlass: 'follow', shipLancer: 'follow', shipFalconet: 'follow', shipBasilisk: 'follow', shipBombard: 'follow', shipCommodore: 'follow', shipVedette: 'follow', shipDredger: 'follow', shipSentinel: 'follow', shipBeacon: 'follow', shipOracle: 'follow', shipTender: 'follow', shipSapper: 'follow', ownFleet: 'command-pennant', squadFleet: 'slot-numeral', shield: 'lanes', digits: 'seg-flag-foot', hold: 'rose', structure: 'tile', deployable: 'light-rhythms', seaMine: 'living-motion', ownHold: 'beam-column', squadHold: 'short-column', deposit: 'ghost', mapMarker: 'flare-column', poi: 'sea-bed' },
  ],
  chart: [
    { id: 'auto', key: '', pieces: {} as ChartThemeOverlay },
    { id: 'minimal', key: '', pieces: { bottom_nature: { historical: { on: false }, modern: { on: false } }, coastal_profile: { historical: { on: false }, modern: { on: false } }, heraldry: { historical: { on: false }, modern: { on: false } }, imprint: { historical: { on: false }, modern: { on: false } }, isobaths: { historical: { on: false }, modern: { on: false } }, margin_warning: { historical: { on: false }, modern: { on: false } }, memorial_reef: { historical: { on: false }, modern: { on: false } }, ribbons: { historical: { on: false }, modern: { on: false } }, water_lines: { historical: { on: false }, modern: { on: false } } } as ChartThemeOverlay },
    { id: 'flashy', key: '', pieces: { border_band: { historical: { on: true }, modern: { on: true } }, hazards: { historical: { on: true }, modern: { on: true } }, sonar_sweep: { historical: { on: true } } } as ChartThemeOverlay },
  ],
} as const;

// The effect catalog (R908, docs/design/effects.md, §6.6). One row
// per code, joining the machine half of data/contracts/effects.toml
// onto the look half of data/presentation/effects.toml. `wire` is
// what a fleet, a round or a hold carries on the wire; `hull` and
// `torpedo` are the ShipClass and TorpedoKind numbers a scoped row
// is limited to, and 0 means every hull and every kind.
//
// `radius2Px`, `widthPx`, `lengthPx`, `alpha2`, `speed` and `count2`
// are the optional figure fields (R924). 0 means the row does not
// use one. A recipe of `render/effect-recipes-*.ts` reads every
// figure it draws with from the row and holds no literal.
export const EFFECTS = [
  { code: 'halo', wire: 1, targets: ['fleet'] as const, hull: 0, torpedo: 0,
    family: 'flare', tint: 'faction', ink: null, periodSec: 6, radiusPx: 26, alpha: 0.4, count: 1,
    radius2Px: 0, widthPx: 0, lengthPx: 0, alpha2: 0, speed: 0, count2: 0 },
  { code: 'stardust_wake', wire: 5, targets: ['fleet'] as const, hull: 0, torpedo: 0,
    family: 'trail', tint: 'faction', ink: null, periodSec: 5, radiusPx: 9, alpha: 0.4, count: 16,
    radius2Px: 6, widthPx: 1.3, lengthPx: 34, alpha2: 0, speed: 0, count2: 0 },
  { code: 'ember_rim', wire: 6, targets: ['fleet'] as const, hull: 0, torpedo: 0,
    family: 'drift', tint: 'faction', ink: null, periodSec: 12, radiusPx: 14, alpha: 0.45, count: 1,
    radius2Px: 0, widthPx: 1.4, lengthPx: 0, alpha2: 0.6, speed: 0, count2: 0 },
  { code: 'twin_sprites', wire: 7, targets: ['fleet'] as const, hull: 0, torpedo: 0,
    family: 'ring', tint: 'fixed', ink: 0xffffff, periodSec: 20, radiusPx: 24, alpha: 0.35, count: 2,
    radius2Px: 5.5, widthPx: 0, lengthPx: 0, alpha2: 0.45, speed: 0, count2: 0 },
  { code: 'third_eye', wire: 8, targets: ['fleet'] as const, hull: 8, torpedo: 0,
    family: 'ring', tint: 'fixed', ink: 0x35e0d2, periodSec: 8, radiusPx: 17, alpha: 0.45, count: 1,
    radius2Px: 0, widthPx: 1, lengthPx: 0, alpha2: 0.6, speed: 0, count2: 0 },
  { code: 'lantern', wire: 9, targets: ['fleet'] as const, hull: 12, torpedo: 0,
    family: 'flare', tint: 'faction', ink: null, periodSec: 10, radiusPx: 14, alpha: 0.42, count: 1,
    radius2Px: 13, widthPx: 1, lengthPx: 8, alpha2: 0.4, speed: 0, count2: 0 },
  { code: 'silt_plume', wire: 10, targets: ['fleet'] as const, hull: 9, torpedo: 0,
    family: 'fog', tint: 'fixed', ink: 0x88a0b0, periodSec: 7, radiusPx: 16, alpha: 0.34, count: 3,
    radius2Px: 10, widthPx: 0, lengthPx: 40, alpha2: 0, speed: 0, count2: 0 },
  { code: 'bow_shimmer', wire: 11, targets: ['fleet'] as const, hull: 0, torpedo: 0,
    family: 'trail', tint: 'faction', ink: null, periodSec: 5, radiusPx: 40, alpha: 0.4, count: 7,
    radius2Px: 6, widthPx: 16, lengthPx: 0, alpha2: 0, speed: 0, count2: 2 },
  { code: 'kelp_drift', wire: 12, targets: ['fleet'] as const, hull: 0, torpedo: 0,
    family: 'trail', tint: 'faction', ink: null, periodSec: 8, radiusPx: 38, alpha: 0.45, count: 2,
    radius2Px: 8, widthPx: 1, lengthPx: 0, alpha2: 0.5, speed: 0, count2: 16 },
  { code: 'lantern_chain', wire: 13, targets: ['fleet'] as const, hull: 0, torpedo: 0,
    family: 'trail', tint: 'fixed', ink: 0xffffff, periodSec: 6, radiusPx: 5.5, alpha: 0.4, count: 3,
    radius2Px: 15, widthPx: 0, lengthPx: 13, alpha2: 0.45, speed: 0, count2: 0 },
  { code: 'compass_rose', wire: 14, targets: ['fleet'] as const, hull: 0, torpedo: 0,
    family: 'radiant', tint: 'fixed', ink: 0xa3cfe6, periodSec: 60, radiusPx: 30, alpha: 0.3, count: 4,
    radius2Px: 16.5, widthPx: 1.3, lengthPx: 0, alpha2: 0.18, speed: 0, count2: 4 },
  { code: 'bubble_breath', wire: 15, targets: ['fleet'] as const, hull: 0, torpedo: 0,
    family: 'glitter', tint: 'fixed', ink: 0xffffff, periodSec: 6, radiusPx: 9, alpha: 0.45, count: 12,
    radius2Px: 5, widthPx: 2.3, lengthPx: 26, alpha2: 0.16, speed: 0, count2: 0 },
  { code: 'corsair_blaze', wire: 16, targets: ['fleet'] as const, hull: 1, torpedo: 0,
    family: 'flare', tint: 'faction', ink: null, periodSec: 6, radiusPx: 12, alpha: 0.42, count: 1,
    radius2Px: 12, widthPx: 0, lengthPx: 0, alpha2: 0, speed: 0, count2: 0 },
  { code: 'cutlass_glint', wire: 17, targets: ['fleet'] as const, hull: 2, torpedo: 0,
    family: 'glitter', tint: 'fixed', ink: 0xffffff, periodSec: 7, radiusPx: 4.5, alpha: 0.45, count: 2,
    radius2Px: 4.8, widthPx: 0, lengthPx: 10, alpha2: 0.55, speed: 0, count2: 0 },
  { code: 'falconet_feathers', wire: 18, targets: ['fleet'] as const, hull: 3, torpedo: 0,
    family: 'trail', tint: 'faction', ink: null, periodSec: 6, radiusPx: 34, alpha: 0.45, count: 6,
    radius2Px: 6.5, widthPx: 1.7, lengthPx: 0, alpha2: 0, speed: 0, count2: 2 },
  { code: 'basilisk_gaze', wire: 19, targets: ['fleet'] as const, hull: 4, torpedo: 0,
    family: 'radiant', tint: 'faction', ink: null, periodSec: 9, radiusPx: 46, alpha: 0.42, count: 1,
    radius2Px: 9, widthPx: 9.9, lengthPx: 0, alpha2: 0, speed: 0, count2: 0 },
  { code: 'sentinel_watch', wire: 20, targets: ['fleet'] as const, hull: 6, torpedo: 0,
    family: 'ring', tint: 'fixed', ink: 0x35e0d2, periodSec: 20, radiusPx: 22, alpha: 0.45, count: 1,
    radius2Px: 0, widthPx: 1.6, lengthPx: 0, alpha2: 0.55, speed: 0, count2: 0 },
  { code: 'lancer_spearhead', wire: 21, targets: ['fleet'] as const, hull: 10, torpedo: 0,
    family: 'pulse', tint: 'faction', ink: null, periodSec: 6, radiusPx: 6, alpha: 0.42, count: 1,
    radius2Px: 9, widthPx: 0, lengthPx: 23, alpha2: 0.45, speed: 0, count2: 0 },
  { code: 'beacon_crown', wire: 22, targets: ['fleet'] as const, hull: 11, torpedo: 0,
    family: 'ring', tint: 'faction', ink: null, periodSec: 12, radiusPx: 18, alpha: 0.4, count: 6,
    radius2Px: 7, widthPx: 0, lengthPx: 0, alpha2: 0.45, speed: 0, count2: 0 },
  { code: 'frost', wire: 57, targets: ['fleet'] as const, hull: 0, torpedo: 0,
    family: 'glitter', tint: 'fixed', ink: 0xffffff, periodSec: 6, radiusPx: 13, alpha: 0.45, count: 9,
    radius2Px: 7, widthPx: 3.8, lengthPx: 0, alpha2: 0, speed: 0, count2: 0 },
  { code: 'comet_tail', wire: 3, targets: ['torpedo'] as const, hull: 0, torpedo: 0,
    family: 'trail', tint: 'faction', ink: null, periodSec: 2, radiusPx: 46, alpha: 0.45, count: 16,
    radius2Px: 4, widthPx: 1.6, lengthPx: 0, alpha2: 0, speed: 0, count2: 0 },
  { code: 'ring_wake', wire: 23, targets: ['torpedo'] as const, hull: 0, torpedo: 0,
    family: 'ring', tint: 'faction', ink: null, periodSec: 2, radiusPx: 16, alpha: 0.45, count: 2,
    radius2Px: 3, widthPx: 1, lengthPx: 30, alpha2: 0.5, speed: 0, count2: 0 },
  { code: 'seeker_eye', wire: 24, targets: ['torpedo'] as const, hull: 0, torpedo: 2,
    family: 'radiant', tint: 'fixed', ink: 0x35e0d2, periodSec: 3, radiusPx: 20, alpha: 0.45, count: 1,
    radius2Px: 0, widthPx: 1, lengthPx: 0, alpha2: 0.5, speed: 0, count2: 0 },
  { code: 'interceptor_thread', wire: 25, targets: ['torpedo'] as const, hull: 0, torpedo: 5,
    family: 'trail', tint: 'fixed', ink: 0xa3cfe6, periodSec: 2, radiusPx: 52, alpha: 0.45, count: 6,
    radius2Px: 0, widthPx: 1, lengthPx: 0, alpha2: 0, speed: 9, count2: 0 },
  { code: 'bulwark_lattice', wire: 26, targets: ['torpedo'] as const, hull: 0, torpedo: 6,
    family: 'ring', tint: 'faction', ink: null, periodSec: 4, radiusPx: 14, alpha: 0.45, count: 2,
    radius2Px: 8, widthPx: 1, lengthPx: 0, alpha2: 0.5, speed: 0.0625, count2: 0 },
  { code: 'ember_trail', wire: 27, targets: ['torpedo'] as const, hull: 0, torpedo: 0,
    family: 'trail', tint: 'faction', ink: null, periodSec: 3, radiusPx: 34, alpha: 0.4, count: 9,
    radius2Px: 6.5, widthPx: 0, lengthPx: 0, alpha2: 0, speed: 0, count2: 0 },
  { code: 'spiral', wire: 28, targets: ['torpedo'] as const, hull: 0, torpedo: 0,
    family: 'trail', tint: 'fixed', ink: 0xffffff, periodSec: 2, radiusPx: 8, alpha: 0.42, count: 15,
    radius2Px: 0, widthPx: 1.5, lengthPx: 40, alpha2: 0, speed: 0.8, count2: 0 },
  { code: 'bow_arcs', wire: 29, targets: ['torpedo'] as const, hull: 0, torpedo: 0,
    family: 'ring', tint: 'faction', ink: null, periodSec: 2, radiusPx: 11, alpha: 0.45, count: 2,
    radius2Px: 17, widthPx: 1, lengthPx: 0, alpha2: 0, speed: 0, count2: 0 },
  { code: 'pulse_core', wire: 30, targets: ['torpedo'] as const, hull: 0, torpedo: 0,
    family: 'pulse', tint: 'faction', ink: null, periodSec: 3, radiusPx: 12, alpha: 0.42, count: 1,
    radius2Px: 1.3, widthPx: 0, lengthPx: 0, alpha2: 0.4, speed: 0, count2: 0 },
  { code: 'twin_tails', wire: 31, targets: ['torpedo'] as const, hull: 0, torpedo: 0,
    family: 'trail', tint: 'faction', ink: null, periodSec: 2.5, radiusPx: 32, alpha: 0.4, count: 7,
    radius2Px: 5, widthPx: 10, lengthPx: 0, alpha2: 0, speed: 0, count2: 2 },
  { code: 'cavitation_cloud', wire: 32, targets: ['torpedo'] as const, hull: 0, torpedo: 0,
    family: 'fog', tint: 'fixed', ink: 0x88a0b0, periodSec: 2.5, radiusPx: 12, alpha: 0.38, count: 3,
    radius2Px: 8, widthPx: 0, lengthPx: 30, alpha2: 0, speed: 0, count2: 0 },
  { code: 'ring_chain', wire: 33, targets: ['torpedo'] as const, hull: 0, torpedo: 0,
    family: 'ring', tint: 'fixed', ink: 0xa3cfe6, periodSec: 2, radiusPx: 4, alpha: 0.45, count: 5,
    radius2Px: 3, widthPx: 1, lengthPx: 90, alpha2: 0, speed: 22, count2: 0 },
  { code: 'bubble_ring', wire: 34, targets: ['torpedo'] as const, hull: 0, torpedo: 0,
    family: 'glitter', tint: 'fixed', ink: 0xa3cfe6, periodSec: 4, radiusPx: 11, alpha: 0.4, count: 8,
    radius2Px: 0, widthPx: 2, lengthPx: 0, alpha2: 0, speed: 0.125, count2: 0 },
  { code: 'searchlight', wire: 35, targets: ['torpedo'] as const, hull: 0, torpedo: 0,
    family: 'radiant', tint: 'fixed', ink: 0xa3cfe6, periodSec: 5, radiusPx: 36, alpha: 0.26, count: 1,
    radius2Px: 0, widthPx: 1, lengthPx: 0, alpha2: 0.18, speed: 0, count2: 0 },
  { code: 'light_lantern', wire: 36, targets: ['torpedo'] as const, hull: 0, torpedo: 1,
    family: 'flare', tint: 'faction', ink: null, periodSec: 2, radiusPx: 8, alpha: 0.42, count: 1,
    radius2Px: 8, widthPx: 0, lengthPx: 0, alpha2: 0.42, speed: 0, count2: 0 },
  { code: 'seeker_pulse', wire: 37, targets: ['torpedo'] as const, hull: 0, torpedo: 2,
    family: 'ring', tint: 'faction', ink: null, periodSec: 2, radiusPx: 24, alpha: 0.45, count: 2,
    radius2Px: 8, widthPx: 1, lengthPx: 60, alpha2: 0, speed: 22, count2: 0 },
  { code: 'heavy_wake', wire: 38, targets: ['torpedo'] as const, hull: 0, torpedo: 4,
    family: 'fog', tint: 'fixed', ink: 0x88a0b0, periodSec: 4, radiusPx: 20, alpha: 0.34, count: 4,
    radius2Px: 10, widthPx: 0, lengthPx: 15, alpha2: 0, speed: 0, count2: 0 },
  { code: 'chase_flare', wire: 39, targets: ['torpedo'] as const, hull: 0, torpedo: 5,
    family: 'flare', tint: 'fixed', ink: 0xffffff, periodSec: 2, radiusPx: 11, alpha: 0.44, count: 1,
    radius2Px: 2.8, widthPx: 0, lengthPx: 4.5, alpha2: 0.45, speed: 0, count2: 4 },
  { code: 'anchor_rings', wire: 40, targets: ['torpedo'] as const, hull: 0, torpedo: 6,
    family: 'ring', tint: 'faction', ink: null, periodSec: 4, radiusPx: 9, alpha: 0.45, count: 2,
    radius2Px: 16, widthPx: 1, lengthPx: 0, alpha2: 0, speed: 0, count2: 0 },
  { code: 'halo_round', wire: 58, targets: ['torpedo'] as const, hull: 0, torpedo: 0,
    family: 'flare', tint: 'faction', ink: null, periodSec: 4, radiusPx: 15, alpha: 0.4, count: 1,
    radius2Px: 0, widthPx: 0, lengthPx: 0, alpha2: 0, speed: 0, count2: 0 },
  { code: 'beacon_lantern', wire: 41, targets: ['hold'] as const, hull: 0, torpedo: 0,
    family: 'flare', tint: 'faction', ink: null, periodSec: 8, radiusPx: 34, alpha: 0.4, count: 1,
    radius2Px: 0, widthPx: 0, lengthPx: 0, alpha2: 0, speed: 0, count2: 0 },
  { code: 'aurora', wire: 42, targets: ['hold'] as const, hull: 0, torpedo: 0,
    family: 'drift', tint: 'faction', ink: null, periodSec: 20, radiusPx: 42, alpha: 0.3, count: 3,
    radius2Px: 30, widthPx: 4.6, lengthPx: 9, alpha2: 0, speed: 0, count2: 0 },
  { code: 'sea_glitter', wire: 43, targets: ['hold'] as const, hull: 0, torpedo: 0,
    family: 'glitter', tint: 'faction', ink: null, periodSec: 5, radiusPx: 50, alpha: 0.42, count: 26,
    radius2Px: 0, widthPx: 1.6, lengthPx: 0, alpha2: 0, speed: 0, count2: 0 },
  { code: 'orbiting_sentries', wire: 44, targets: ['hold'] as const, hull: 0, torpedo: 0,
    family: 'ring', tint: 'faction', ink: null, periodSec: 30, radiusPx: 44, alpha: 0.35, count: 3,
    radius2Px: 5.5, widthPx: 1, lengthPx: 0, alpha2: 0.45, speed: 0, count2: 0 },
  { code: 'lighthouse', wire: 45, targets: ['hold'] as const, hull: 0, torpedo: 0,
    family: 'radiant', tint: 'fixed', ink: 0xa3cfe6, periodSec: 30, radiusPx: 54, alpha: 0.16, count: 3,
    radius2Px: 0, widthPx: 1, lengthPx: 0, alpha2: 0.3, speed: 0, count2: 0 },
  { code: 'kelp_garden', wire: 46, targets: ['hold'] as const, hull: 0, torpedo: 0,
    family: 'trail', tint: 'faction', ink: null, periodSec: 24, radiusPx: 30, alpha: 0.45, count: 4,
    radius2Px: 17, widthPx: 1.6, lengthPx: 32, alpha2: 0.34, speed: 0, count2: 3 },
  { code: 'hold_halo', wire: 47, targets: ['hold'] as const, hull: 0, torpedo: 0,
    family: 'flare', tint: 'faction', ink: null, periodSec: 8, radiusPx: 62, alpha: 0.26, count: 1,
    radius2Px: 0, widthPx: 0, lengthPx: 0, alpha2: 0, speed: 0, count2: 0 },
  { code: 'pearl_chain', wire: 48, targets: ['hold'] as const, hull: 0, torpedo: 0,
    family: 'ring', tint: 'fixed', ink: 0xffffff, periodSec: 12, radiusPx: 23, alpha: 0.45, count: 12,
    radius2Px: 6, widthPx: 1, lengthPx: 0, alpha2: 0.3, speed: 0, count2: 0 },
  { code: 'bubble_column', wire: 49, targets: ['hold'] as const, hull: 0, torpedo: 0,
    family: 'glitter', tint: 'fixed', ink: 0xffffff, periodSec: 6, radiusPx: 15, alpha: 0.4, count: 14,
    radius2Px: 0, widthPx: 2.4, lengthPx: 46, alpha2: 0, speed: 0, count2: 0 },
  { code: 'hold_compass', wire: 50, targets: ['hold'] as const, hull: 0, torpedo: 0,
    family: 'radiant', tint: 'fixed', ink: 0xa3cfe6, periodSec: 90, radiusPx: 52, alpha: 0.3, count: 8,
    radius2Px: 10, widthPx: 1, lengthPx: 0, alpha2: 0.09, speed: 0, count2: 0 },
  { code: 'star_field', wire: 51, targets: ['hold'] as const, hull: 0, torpedo: 0,
    family: 'glitter', tint: 'faction', ink: null, periodSec: 6, radiusPx: 60, alpha: 0.42, count: 30,
    radius2Px: 3.6, widthPx: 1.6, lengthPx: 0, alpha2: 0.3, speed: 0, count2: 0 },
  { code: 'heartbeat', wire: 52, targets: ['hold'] as const, hull: 0, torpedo: 0,
    family: 'pulse', tint: 'faction', ink: null, periodSec: 8, radiusPx: 26, alpha: 0.16, count: 1,
    radius2Px: 0, widthPx: 1.4, lengthPx: 0, alpha2: 0.6, speed: 0, count2: 0 },
  { code: 'ember_bed', wire: 53, targets: ['hold'] as const, hull: 0, torpedo: 0,
    family: 'glitter', tint: 'faction', ink: null, periodSec: 7, radiusPx: 30, alpha: 0.42, count: 12,
    radius2Px: 7.5, widthPx: 0, lengthPx: 13, alpha2: 0.38, speed: 0, count2: 0 },
  { code: 'kraken_ink', wire: 54, targets: ['hold'] as const, hull: 0, torpedo: 0,
    family: 'fog', tint: 'fixed', ink: 0x88a0b0, periodSec: 20, radiusPx: 34, alpha: 0.22, count: 5,
    radius2Px: 25, widthPx: 17, lengthPx: 0, alpha2: 0, speed: 0, count2: 0 },
  { code: 'tidal_pull', wire: 55, targets: ['hold'] as const, hull: 0, torpedo: 0,
    family: 'glitter', tint: 'faction', ink: null, periodSec: 6, radiusPx: 58, alpha: 0.45, count: 22,
    radius2Px: 7, widthPx: 1.9, lengthPx: 0, alpha2: 0, speed: 0, count2: 0 },
  { code: 'echo_lines', wire: 56, targets: ['hold'] as const, hull: 0, torpedo: 0,
    family: 'ring', tint: 'fixed', ink: 0x35e0d2, periodSec: 9, radiusPx: 56, alpha: 0.45, count: 3,
    radius2Px: 20, widthPx: 1.4, lengthPx: 0, alpha2: 0.5, speed: 0, count2: 0 },
  { code: 'guardian_rays', wire: 59, targets: ['hold'] as const, hull: 0, torpedo: 0,
    family: 'radiant', tint: 'fixed', ink: 0xa3cfe6, periodSec: 60, radiusPx: 50, alpha: 0.45, count: 6,
    radius2Px: 22, widthPx: 1.4, lengthPx: 0, alpha2: 0.28, speed: 0, count2: 0 },
  { code: 'crown', wire: 60, targets: ['hold'] as const, hull: 0, torpedo: 0,
    family: 'ring', tint: 'faction', ink: null, periodSec: 18, radiusPx: 54, alpha: 0.45, count: 6,
    radius2Px: 9, widthPx: 3.1, lengthPx: 0, alpha2: 0.3, speed: 0, count2: 0 },
  { code: 'moonlight', wire: 61, targets: ['hold'] as const, hull: 0, torpedo: 0,
    family: 'flare', tint: 'fixed', ink: 0xa3cfe6, periodSec: 30, radiusPx: 70, alpha: 0.16, count: 1,
    radius2Px: 46, widthPx: 18, lengthPx: 6, alpha2: 0, speed: 0, count2: 0 },
  { code: 'spokes', wire: 62, targets: ['hold'] as const, hull: 0, torpedo: 0,
    family: 'radiant', tint: 'faction', ink: null, periodSec: 60, radiusPx: 52, alpha: 0.45, count: 8,
    radius2Px: 18, widthPx: 1, lengthPx: 8, alpha2: 0.44, speed: 0, count2: 0 },
] as const;

/** Every effect code of the catalog. */
export type EffectCode = (typeof EFFECTS)[number]['code'];

// The "not flashy" rule of mockup round 040, from
// [effects.limits]. The style leaf holds every recipe to it and
// balancegen refuses a row that breaks it.
export const EFFECT_LIMITS = {
  minPeriodSecFleet: 4,
  minPeriodSecHold: 4,
  minPeriodSecTorpedo: 2,
  maxAlphaFill: 0.45,
  maxAlphaStroke: 0.7,
  maxDriftTowardWhite: 0.25,
} as const;

/** Every slot an account picks an effect for, in one fixed order:
 *  the whole fleet, one slot per hull in roster order, the whole
 *  magazine, one slot per kind, and the hold. */
export const EFFECT_SLOTS = ['fleet', 'fleet:Corsair', 'fleet:Cutlass', 'fleet:Lancer', 'fleet:Falconet', 'fleet:Basilisk', 'fleet:Bombard', 'fleet:Commodore', 'fleet:Vedette', 'fleet:Dredger', 'fleet:Sentinel', 'fleet:Beacon', 'fleet:Oracle', 'fleet:Tender', 'torpedo', 'torpedo:light', 'torpedo:seeker', 'torpedo:disruptor', 'torpedo:heavy', 'torpedo:interceptor', 'torpedo:bulwark', 'torpedo:countermine', 'torpedo:stonefish', 'torpedo:wrasse', 'torpedo:sepia', 'torpedo:sailfish', 'hold'] as const;

// The achievement catalog (R926, docs/design/achievements.md §2).
// One row per code, joining the machine half of
// data/contracts/achievements.toml onto the thresholds of its
// ladder. `thresholds` is already resolved, so the client never
// reads a ladder name. `metric` is the metric code the row counts,
// and it is empty for a recognition.
//
// The hidden rows ride this bundle. Hidden means the API and the
// pages filter the account's view: the bundle is public, so a
// person who reads it can read the codes.
//
// `unit` is what the metric counts (data/contracts/metrics.toml).
// The client prints a figure by it: a `sec` row is a span of the
// player's own time and reads as hours (R949), and a `mask` row
// already arrives as its bit count (R947).
export interface AchievementRow {
  readonly code: string;
  readonly kind: 'lifetime' | 'journey' | 'recognition';
  readonly category: string;
  readonly metric: string;
  readonly unit: string;
  readonly thresholds: readonly number[];
  readonly mode: '' | 'event' | 'clanwar' | 'arcade';
  readonly hidden: boolean;
  readonly rotation: number;
}
export const ACHIEVEMENTS: readonly AchievementRow[] = [
  { code: 'buildings_levels', kind: 'lifetime', category: 'industry', metric: 'building_levels', unit: 'count', thresholds: [5, 25, 100, 500, 2000, 6000], mode: '', hidden: false, rotation: -1 },
  { code: 'level_base', kind: 'lifetime', category: 'industry', metric: 'level_base_max', unit: 'level', thresholds: [1, 3, 5, 7, 9, 10], mode: '', hidden: false, rotation: -1 },
  { code: 'level_researchlab', kind: 'lifetime', category: 'industry', metric: 'level_researchlab_max', unit: 'level', thresholds: [1, 2, 3, 4, 5], mode: '', hidden: false, rotation: -1 },
  { code: 'level_construction', kind: 'lifetime', category: 'industry', metric: 'level_construction_max', unit: 'level', thresholds: [1, 2, 3, 4, 5], mode: '', hidden: false, rotation: -1 },
  { code: 'level_shipdesign', kind: 'lifetime', category: 'industry', metric: 'level_shipdesign_max', unit: 'level', thresholds: [1, 2, 3, 4, 5], mode: '', hidden: false, rotation: -1 },
  { code: 'level_wharf', kind: 'lifetime', category: 'industry', metric: 'level_wharf_max', unit: 'level', thresholds: [1, 2, 3, 4, 5], mode: '', hidden: false, rotation: -1 },
  { code: 'level_harbour', kind: 'lifetime', category: 'industry', metric: 'level_harbour_max', unit: 'level', thresholds: [1, 2, 3, 4, 5], mode: '', hidden: false, rotation: -1 },
  { code: 'level_storage', kind: 'lifetime', category: 'industry', metric: 'level_storage_max', unit: 'level', thresholds: [1, 3, 5, 7, 9, 10], mode: '', hidden: false, rotation: -1 },
  { code: 'level_alloymine', kind: 'lifetime', category: 'industry', metric: 'level_alloymine_max', unit: 'level', thresholds: [1, 3, 5, 7, 9, 10], mode: '', hidden: false, rotation: -1 },
  { code: 'level_biomassfarm', kind: 'lifetime', category: 'industry', metric: 'level_biomassfarm_max', unit: 'level', thresholds: [1, 3, 5, 7, 9, 10], mode: '', hidden: false, rotation: -1 },
  { code: 'level_volatilesextractor', kind: 'lifetime', category: 'industry', metric: 'level_volatilesextractor_max', unit: 'level', thresholds: [1, 3, 5, 7, 9, 10], mode: '', hidden: false, rotation: -1 },
  { code: 'level_logistics', kind: 'lifetime', category: 'industry', metric: 'level_logistics_max', unit: 'level', thresholds: [1, 2, 3, 4, 5], mode: '', hidden: false, rotation: -1 },
  { code: 'level_communications', kind: 'lifetime', category: 'industry', metric: 'level_communications_max', unit: 'level', thresholds: [1, 2, 3, 4, 5], mode: '', hidden: false, rotation: -1 },
  { code: 'level_sonar', kind: 'lifetime', category: 'industry', metric: 'level_sonar_max', unit: 'level', thresholds: [1, 2, 3, 4, 5], mode: '', hidden: false, rotation: -1 },
  { code: 'level_radiationcontrol', kind: 'lifetime', category: 'industry', metric: 'level_radiationcontrol_max', unit: 'level', thresholds: [1, 2, 3, 4, 5], mode: '', hidden: false, rotation: -1 },
  { code: 'level_torpedobanks', kind: 'lifetime', category: 'industry', metric: 'level_torpedobanks_max', unit: 'level', thresholds: [1, 2, 3, 4, 5], mode: '', hidden: false, rotation: -1 },
  { code: 'level_recruitment', kind: 'lifetime', category: 'industry', metric: 'level_recruitment_max', unit: 'level', thresholds: [1, 2, 3, 4, 5], mode: '', hidden: false, rotation: -1 },
  { code: 'level_academy', kind: 'lifetime', category: 'industry', metric: 'level_academy_max', unit: 'level', thresholds: [1, 2, 3, 4, 5], mode: '', hidden: false, rotation: -1 },
  { code: 'level_hospital', kind: 'lifetime', category: 'industry', metric: 'level_hospital_max', unit: 'level', thresholds: [1, 2, 3, 4, 5], mode: '', hidden: false, rotation: -1 },
  { code: 'level_prison', kind: 'lifetime', category: 'industry', metric: 'level_prison_max', unit: 'level', thresholds: [1, 2, 3, 4, 5], mode: '', hidden: false, rotation: -1 },
  { code: 'every_building', kind: 'lifetime', category: 'industry', metric: 'buildings_built_mask', unit: 'mask', thresholds: [10, 12, 14, 16, 18, 19], mode: '', hidden: false, rotation: -1 },
  { code: 'every_building_max', kind: 'lifetime', category: 'industry', metric: 'buildings_maxed_mask', unit: 'mask', thresholds: [1, 4, 8, 12, 16, 19], mode: '', hidden: false, rotation: -1 },
  { code: 'queue_jobs', kind: 'lifetime', category: 'industry', metric: 'queue_jobs_done', unit: 'count', thresholds: [5, 25, 100, 500, 2000, 6000], mode: '', hidden: false, rotation: -1 },
  { code: 'queue_hours', kind: 'lifetime', category: 'industry', metric: 'queue_busy_sec', unit: 'sec', thresholds: [3600, 36000, 180000, 720000, 1800000, 3600000], mode: '', hidden: false, rotation: -1 },
  { code: 'repairs_done', kind: 'lifetime', category: 'industry', metric: 'repairs_done', unit: 'count', thresholds: [5, 25, 100, 500, 2000, 6000], mode: '', hidden: false, rotation: -1 },
  { code: 'credit_rush', kind: 'lifetime', category: 'industry', metric: 'credit_rushes', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'ships_built', kind: 'lifetime', category: 'shipyard', metric: 'ships_built', unit: 'count', thresholds: [5, 25, 100, 500, 2000, 6000], mode: '', hidden: false, rotation: -1 },
  { code: 'ships_built_corsair', kind: 'lifetime', category: 'shipyard', metric: 'ships_built_corsair', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'ships_built_cutlass', kind: 'lifetime', category: 'shipyard', metric: 'ships_built_cutlass', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'ships_built_falconet', kind: 'lifetime', category: 'shipyard', metric: 'ships_built_falconet', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'ships_built_basilisk', kind: 'lifetime', category: 'shipyard', metric: 'ships_built_basilisk', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'ships_built_bombard', kind: 'lifetime', category: 'shipyard', metric: 'ships_built_bombard', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'ships_built_lancer', kind: 'lifetime', category: 'shipyard', metric: 'ships_built_lancer', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'ships_built_sentinel', kind: 'lifetime', category: 'shipyard', metric: 'ships_built_sentinel', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'ships_built_vedette', kind: 'lifetime', category: 'shipyard', metric: 'ships_built_vedette', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'ships_built_oracle', kind: 'lifetime', category: 'shipyard', metric: 'ships_built_oracle', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'ships_built_tender', kind: 'lifetime', category: 'shipyard', metric: 'ships_built_tender', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'ships_built_beacon', kind: 'lifetime', category: 'shipyard', metric: 'ships_built_beacon', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'ships_built_dredger', kind: 'lifetime', category: 'shipyard', metric: 'ships_built_dredger', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'every_hull', kind: 'lifetime', category: 'shipyard', metric: 'hull_built_mask', unit: 'mask', thresholds: [1, 2, 4, 6, 9, 12], mode: '', hidden: false, rotation: -1 },
  { code: 'fleets_launched', kind: 'lifetime', category: 'shipyard', metric: 'fleets_launched', unit: 'count', thresholds: [5, 25, 100, 500, 2000, 6000], mode: '', hidden: false, rotation: -1 },
  { code: 'fleet_hours', kind: 'lifetime', category: 'shipyard', metric: 'fleet_sea_sec', unit: 'sec', thresholds: [3600, 36000, 180000, 720000, 1800000, 3600000], mode: '', hidden: false, rotation: -1 },
  { code: 'auto_rebuilds', kind: 'lifetime', category: 'shipyard', metric: 'auto_rebuilds', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'prints_spent', kind: 'lifetime', category: 'shipyard', metric: 'print_runs_used', unit: 'count', thresholds: [5, 25, 100, 500, 2000, 6000], mode: '', hidden: false, rotation: -1 },
  { code: 'largest_fleet_count', kind: 'lifetime', category: 'shipyard', metric: 'fleets_at_sea_max', unit: 'count', thresholds: [3, 5, 7, 9, 11, 13], mode: '', hidden: false, rotation: -1 },
  { code: 'torpedoes_stowed', kind: 'lifetime', category: 'arsenal', metric: 'torpedoes_stowed', unit: 'count', thresholds: [5, 25, 100, 500, 2000, 6000], mode: '', hidden: false, rotation: -1 },
  { code: 'torpedoes_fired', kind: 'lifetime', category: 'arsenal', metric: 'torpedoes_fired', unit: 'count', thresholds: [5, 25, 100, 500, 2000, 6000], mode: '', hidden: false, rotation: -1 },
  { code: 'torpedo_hits', kind: 'lifetime', category: 'arsenal', metric: 'torpedo_hits', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'torpedo_kills', kind: 'lifetime', category: 'arsenal', metric: 'kills_by_torpedo', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'torpedo_kinds', kind: 'lifetime', category: 'arsenal', metric: 'torpedo_kind_fired_mask', unit: 'mask', thresholds: [1, 2, 3, 4, 5, 6], mode: '', hidden: false, rotation: -1 },
  { code: 'torpedoes_fired_light', kind: 'lifetime', category: 'arsenal', metric: 'torpedoes_fired_light', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'torpedoes_fired_seeker', kind: 'lifetime', category: 'arsenal', metric: 'torpedoes_fired_seeker', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'torpedoes_fired_disruptor', kind: 'lifetime', category: 'arsenal', metric: 'torpedoes_fired_disruptor', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'torpedoes_fired_heavy', kind: 'lifetime', category: 'arsenal', metric: 'torpedoes_fired_heavy', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'torpedoes_fired_interceptor', kind: 'lifetime', category: 'arsenal', metric: 'torpedoes_fired_interceptor', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'torpedoes_fired_bulwark', kind: 'lifetime', category: 'arsenal', metric: 'torpedoes_fired_bulwark', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'rounds_shot_down', kind: 'lifetime', category: 'arsenal', metric: 'rounds_shot_down', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'decoys_dropped', kind: 'lifetime', category: 'arsenal', metric: 'decoys_dropped', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'tender_rounds', kind: 'lifetime', category: 'arsenal', metric: 'tender_rounds', unit: 'count', thresholds: [5, 25, 100, 500, 2000, 6000], mode: '', hidden: false, rotation: -1 },
  { code: 'struck_survived', kind: 'lifetime', category: 'arsenal', metric: 'torpedo_struck_survived', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'tech_recovered', kind: 'lifetime', category: 'research', metric: 'tech_recovered', unit: 'count', thresholds: [5, 25, 100, 500, 2000, 6000], mode: '', hidden: false, rotation: -1 },
  { code: 'keystones', kind: 'lifetime', category: 'research', metric: 'keystones_recovered', unit: 'count', thresholds: [1, 2, 4, 7, 10, 13], mode: '', hidden: false, rotation: -1 },
  { code: 'branches_opened', kind: 'lifetime', category: 'research', metric: 'branch_first_mask', unit: 'mask', thresholds: [1, 2, 3, 4, 5], mode: '', hidden: false, rotation: -1 },
  { code: 'branch_complete', kind: 'lifetime', category: 'research', metric: 'branch_completed', unit: 'count', thresholds: [1, 2, 4, 7, 10, 13], mode: '', hidden: false, rotation: -1 },
  { code: 'data_cores_found', kind: 'lifetime', category: 'research', metric: 'cores_found', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'data_cores_used', kind: 'lifetime', category: 'research', metric: 'cores_used', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'research_hours', kind: 'lifetime', category: 'research', metric: 'research_busy_sec', unit: 'sec', thresholds: [3600, 36000, 180000, 720000, 1800000, 3600000], mode: '', hidden: false, rotation: -1 },
  { code: 'inventions', kind: 'lifetime', category: 'invention', metric: 'inventions', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'prints_installed', kind: 'lifetime', category: 'invention', metric: 'prints_installed', unit: 'count', thresholds: [5, 25, 100, 500, 2000, 6000], mode: '', hidden: false, rotation: -1 },
  { code: 'prints_adopted', kind: 'lifetime', category: 'invention', metric: 'prints_adopted', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'prints_sold', kind: 'lifetime', category: 'invention', metric: 'prints_sold', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'module_families', kind: 'lifetime', category: 'invention', metric: 'module_family_mask', unit: 'mask', thresholds: [1, 2, 3, 4, 5], mode: '', hidden: false, rotation: -1 },
  { code: 'three_slot_print', kind: 'lifetime', category: 'invention', metric: 'three_slot_prints', unit: 'count', thresholds: [1, 5, 25, 100, 250, 500], mode: '', hidden: false, rotation: -1 },
  { code: 't3_module_invented', kind: 'lifetime', category: 'invention', metric: 't3_modules_invented', unit: 'count', thresholds: [1, 5, 25, 100, 250, 500], mode: '', hidden: false, rotation: -1 },
  { code: 'blueprint_hulls', kind: 'lifetime', category: 'invention', metric: 'blueprint_hull_mask', unit: 'mask', thresholds: [1, 2, 4, 6, 9, 12], mode: '', hidden: false, rotation: -1 },
  { code: 'gathered_units', kind: 'lifetime', category: 'prospecting', metric: 'gathered_units', unit: 'units', thresholds: [1000, 10000, 50000, 200000, 750000, 2000000], mode: '', hidden: false, rotation: -1 },
  { code: 'gathered_alloy', kind: 'lifetime', category: 'prospecting', metric: 'gathered_alloy', unit: 'units', thresholds: [1000, 10000, 50000, 200000, 750000, 2000000], mode: '', hidden: false, rotation: -1 },
  { code: 'gathered_biomass', kind: 'lifetime', category: 'prospecting', metric: 'gathered_biomass', unit: 'units', thresholds: [1000, 10000, 50000, 200000, 750000, 2000000], mode: '', hidden: false, rotation: -1 },
  { code: 'gathered_volatiles', kind: 'lifetime', category: 'prospecting', metric: 'gathered_volatiles', unit: 'units', thresholds: [1000, 10000, 50000, 200000, 750000, 2000000], mode: '', hidden: false, rotation: -1 },
  { code: 'gathered_isotopes', kind: 'lifetime', category: 'prospecting', metric: 'gathered_isotopes', unit: 'units', thresholds: [1000, 10000, 50000, 200000, 750000, 2000000], mode: '', hidden: false, rotation: -1 },
  { code: 'cargo_landed', kind: 'lifetime', category: 'prospecting', metric: 'cargo_landed_units', unit: 'units', thresholds: [1000, 10000, 50000, 200000, 750000, 2000000], mode: '', hidden: false, rotation: -1 },
  { code: 'mined_units', kind: 'lifetime', category: 'prospecting', metric: 'mined_units', unit: 'units', thresholds: [1000, 10000, 50000, 200000, 750000, 2000000], mode: '', hidden: false, rotation: -1 },
  { code: 'idle_credits', kind: 'lifetime', category: 'prospecting', metric: 'idle_credits', unit: 'units', thresholds: [1000, 10000, 50000, 200000, 750000, 2000000], mode: '', hidden: false, rotation: -1 },
  { code: 'expeditions', kind: 'lifetime', category: 'prospecting', metric: 'expeditions', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'expeditions_deep', kind: 'lifetime', category: 'prospecting', metric: 'expeditions_depth_max', unit: 'level', thresholds: [1, 2, 3, 4, 5, 6], mode: '', hidden: false, rotation: -1 },
  { code: 'isotopes_found', kind: 'lifetime', category: 'prospecting', metric: 'isotopes_found', unit: 'units', thresholds: [1000, 10000, 50000, 200000, 750000, 2000000], mode: '', hidden: false, rotation: -1 },
  { code: 'deposits_emptied', kind: 'lifetime', category: 'prospecting', metric: 'deposits_emptied', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'salvaged', kind: 'lifetime', category: 'prospecting', metric: 'salvage_units', unit: 'units', thresholds: [1000, 10000, 50000, 200000, 750000, 2000000], mode: '', hidden: false, rotation: -1 },
  { code: 'wrecks_salvaged', kind: 'lifetime', category: 'prospecting', metric: 'wrecks_salvaged', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'cache_finders', kind: 'lifetime', category: 'prospecting', metric: 'cache_finders', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'full_holds', kind: 'lifetime', category: 'prospecting', metric: 'full_holds', unit: 'count', thresholds: [5, 25, 100, 500, 2000, 6000], mode: '', hidden: false, rotation: -1 },
  { code: 'gather_in_sov', kind: 'lifetime', category: 'prospecting', metric: 'gathered_in_sov_units', unit: 'units', thresholds: [1000, 10000, 50000, 200000, 750000, 2000000], mode: '', hidden: false, rotation: -1 },
  { code: 'credits_earned', kind: 'lifetime', category: 'treasury', metric: 'credits_earned', unit: 'units', thresholds: [1000, 10000, 50000, 200000, 750000, 2000000], mode: '', hidden: false, rotation: -1 },
  { code: 'credits_spent', kind: 'lifetime', category: 'treasury', metric: 'credits_spent', unit: 'units', thresholds: [1000, 10000, 50000, 200000, 750000, 2000000], mode: '', hidden: false, rotation: -1 },
  { code: 'spent_building', kind: 'lifetime', category: 'treasury', metric: 'spent_building', unit: 'units', thresholds: [1000, 10000, 50000, 200000, 750000, 2000000], mode: '', hidden: false, rotation: -1 },
  { code: 'spent_ship', kind: 'lifetime', category: 'treasury', metric: 'spent_ship', unit: 'units', thresholds: [1000, 10000, 50000, 200000, 750000, 2000000], mode: '', hidden: false, rotation: -1 },
  { code: 'spent_tech', kind: 'lifetime', category: 'treasury', metric: 'spent_tech', unit: 'units', thresholds: [1000, 10000, 50000, 200000, 750000, 2000000], mode: '', hidden: false, rotation: -1 },
  { code: 'spent_torpedo', kind: 'lifetime', category: 'treasury', metric: 'spent_torpedo', unit: 'units', thresholds: [1000, 10000, 50000, 200000, 750000, 2000000], mode: '', hidden: false, rotation: -1 },
  { code: 'spent_print', kind: 'lifetime', category: 'treasury', metric: 'spent_print', unit: 'units', thresholds: [1000, 10000, 50000, 200000, 750000, 2000000], mode: '', hidden: false, rotation: -1 },
  { code: 'spent_repair', kind: 'lifetime', category: 'treasury', metric: 'spent_repair', unit: 'units', thresholds: [1000, 10000, 50000, 200000, 750000, 2000000], mode: '', hidden: false, rotation: -1 },
  { code: 'spent_invent', kind: 'lifetime', category: 'treasury', metric: 'spent_invent', unit: 'units', thresholds: [1000, 10000, 50000, 200000, 750000, 2000000], mode: '', hidden: false, rotation: -1 },
  { code: 'spent_rush', kind: 'lifetime', category: 'treasury', metric: 'spent_rush', unit: 'units', thresholds: [1000, 10000, 50000, 200000, 750000, 2000000], mode: '', hidden: false, rotation: -1 },
  { code: 'spent_market', kind: 'lifetime', category: 'treasury', metric: 'spent_market', unit: 'units', thresholds: [1000, 10000, 50000, 200000, 750000, 2000000], mode: '', hidden: false, rotation: -1 },
  { code: 'spent_captain', kind: 'lifetime', category: 'treasury', metric: 'spent_captain', unit: 'units', thresholds: [1000, 10000, 50000, 200000, 750000, 2000000], mode: '', hidden: false, rotation: -1 },
  { code: 'spent_expedition', kind: 'lifetime', category: 'treasury', metric: 'spent_expedition', unit: 'units', thresholds: [1000, 10000, 50000, 200000, 750000, 2000000], mode: '', hidden: false, rotation: -1 },
  { code: 'market_sales', kind: 'lifetime', category: 'treasury', metric: 'market_sales', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'market_buys', kind: 'lifetime', category: 'treasury', metric: 'market_buys', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'market_volume', kind: 'lifetime', category: 'treasury', metric: 'market_volume', unit: 'units', thresholds: [1000, 10000, 50000, 200000, 750000, 2000000], mode: '', hidden: false, rotation: -1 },
  { code: 'compact_units', kind: 'lifetime', category: 'treasury', metric: 'compact_units', unit: 'units', thresholds: [1000, 10000, 50000, 200000, 750000, 2000000], mode: '', hidden: false, rotation: -1 },
  { code: 'fleets_killed', kind: 'lifetime', category: 'warfare', metric: 'fleets_killed', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'kills_corsair', kind: 'lifetime', category: 'warfare', metric: 'kills_corsair', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'kills_cutlass', kind: 'lifetime', category: 'warfare', metric: 'kills_cutlass', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'kills_falconet', kind: 'lifetime', category: 'warfare', metric: 'kills_falconet', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'kills_basilisk', kind: 'lifetime', category: 'warfare', metric: 'kills_basilisk', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'kills_bombard', kind: 'lifetime', category: 'warfare', metric: 'kills_bombard', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'kills_lancer', kind: 'lifetime', category: 'warfare', metric: 'kills_lancer', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'kills_sentinel', kind: 'lifetime', category: 'warfare', metric: 'kills_sentinel', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'kills_vedette', kind: 'lifetime', category: 'warfare', metric: 'kills_vedette', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'kills_oracle', kind: 'lifetime', category: 'warfare', metric: 'kills_oracle', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'kills_tender', kind: 'lifetime', category: 'warfare', metric: 'kills_tender', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'kills_beacon', kind: 'lifetime', category: 'warfare', metric: 'kills_beacon', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'kills_dredger', kind: 'lifetime', category: 'warfare', metric: 'kills_dredger', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'kills_with_corsair', kind: 'lifetime', category: 'warfare', metric: 'kills_with_corsair', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'kills_with_cutlass', kind: 'lifetime', category: 'warfare', metric: 'kills_with_cutlass', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'kills_with_falconet', kind: 'lifetime', category: 'warfare', metric: 'kills_with_falconet', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'kills_with_basilisk', kind: 'lifetime', category: 'warfare', metric: 'kills_with_basilisk', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'kills_with_bombard', kind: 'lifetime', category: 'warfare', metric: 'kills_with_bombard', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'kills_with_lancer', kind: 'lifetime', category: 'warfare', metric: 'kills_with_lancer', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'kills_with_sentinel', kind: 'lifetime', category: 'warfare', metric: 'kills_with_sentinel', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'kills_with_vedette', kind: 'lifetime', category: 'warfare', metric: 'kills_with_vedette', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'every_victim', kind: 'lifetime', category: 'warfare', metric: 'victim_class_mask', unit: 'mask', thresholds: [1, 2, 4, 6, 9, 12], mode: '', hidden: false, rotation: -1 },
  { code: 'first_strike_kills', kind: 'lifetime', category: 'warfare', metric: 'first_strike_kills', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'damage_dealt', kind: 'lifetime', category: 'warfare', metric: 'damage_dealt', unit: 'units', thresholds: [1000, 10000, 50000, 200000, 750000, 2000000], mode: '', hidden: false, rotation: -1 },
  { code: 'damage_taken_survived', kind: 'lifetime', category: 'warfare', metric: 'damage_taken', unit: 'units', thresholds: [1000, 10000, 50000, 200000, 750000, 2000000], mode: '', hidden: false, rotation: -1 },
  { code: 'fleets_lost', kind: 'lifetime', category: 'warfare', metric: 'fleets_lost', unit: 'count', thresholds: [5, 25, 100, 500, 2000, 6000], mode: '', hidden: false, rotation: -1 },
  { code: 'kill_streak', kind: 'lifetime', category: 'warfare', metric: 'kill_streak_max', unit: 'count', thresholds: [2, 3, 5, 8, 12, 20], mode: '', hidden: false, rotation: -1 },
  { code: 'captains_captured', kind: 'lifetime', category: 'warfare', metric: 'captains_captured', unit: 'count', thresholds: [1, 5, 25, 100, 250, 500], mode: '', hidden: false, rotation: -1 },
  { code: 'prisoners_ransomed', kind: 'lifetime', category: 'warfare', metric: 'ransoms_paid', unit: 'count', thresholds: [1, 5, 25, 100, 250, 500], mode: '', hidden: false, rotation: -1 },
  { code: 'prisoners_freed', kind: 'lifetime', category: 'warfare', metric: 'prisoners_freed', unit: 'count', thresholds: [1, 5, 25, 100, 250, 500], mode: '', hidden: false, rotation: -1 },
  { code: 'kills_in_own_sov', kind: 'lifetime', category: 'warfare', metric: 'kills_in_sov', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'kills_in_enemy_sov', kind: 'lifetime', category: 'warfare', metric: 'kills_in_enemy_sov', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'hold_under_fire_held', kind: 'lifetime', category: 'warfare', metric: 'hold_attacks_survived', unit: 'count', thresholds: [1, 5, 25, 100, 250, 500], mode: '', hidden: false, rotation: -1 },
  { code: 'battle_reports', kind: 'lifetime', category: 'warfare', metric: 'battle_reports', unit: 'count', thresholds: [5, 25, 100, 500, 2000, 6000], mode: '', hidden: false, rotation: -1 },
  { code: 'sieges_won', kind: 'lifetime', category: 'siegecraft', metric: 'sieges_won', unit: 'count', thresholds: [1, 5, 25, 100, 250, 500], mode: '', hidden: false, rotation: -1 },
  { code: 'sieges_lost', kind: 'lifetime', category: 'siegecraft', metric: 'sieges_lost', unit: 'count', thresholds: [1, 5, 25, 100, 250, 500], mode: '', hidden: false, rotation: -1 },
  { code: 'sieges_defended', kind: 'lifetime', category: 'siegecraft', metric: 'battles_defended', unit: 'count', thresholds: [1, 5, 25, 100, 250, 500], mode: '', hidden: false, rotation: -1 },
  { code: 'objects_taken_throne', kind: 'lifetime', category: 'siegecraft', metric: 'objects_taken_throne', unit: 'count', thresholds: [1, 5, 25, 100, 250, 500], mode: '', hidden: false, rotation: -1 },
  { code: 'objects_taken_spire', kind: 'lifetime', category: 'siegecraft', metric: 'objects_taken_spire', unit: 'count', thresholds: [1, 5, 25, 100, 250, 500], mode: '', hidden: false, rotation: -1 },
  { code: 'objects_taken_forge', kind: 'lifetime', category: 'siegecraft', metric: 'objects_taken_forge', unit: 'count', thresholds: [1, 5, 25, 100, 250, 500], mode: '', hidden: false, rotation: -1 },
  { code: 'objects_taken_kelp', kind: 'lifetime', category: 'siegecraft', metric: 'objects_taken_kelp', unit: 'count', thresholds: [1, 5, 25, 100, 250, 500], mode: '', hidden: false, rotation: -1 },
  { code: 'objects_taken_battery', kind: 'lifetime', category: 'siegecraft', metric: 'objects_taken_battery', unit: 'count', thresholds: [1, 5, 25, 100, 250, 500], mode: '', hidden: false, rotation: -1 },
  { code: 'objects_taken_drydock', kind: 'lifetime', category: 'siegecraft', metric: 'objects_taken_drydock', unit: 'count', thresholds: [1, 5, 25, 100, 250, 500], mode: '', hidden: false, rotation: -1 },
  { code: 'objects_taken_archive', kind: 'lifetime', category: 'siegecraft', metric: 'objects_taken_archive', unit: 'count', thresholds: [1, 5, 25, 100, 250, 500], mode: '', hidden: false, rotation: -1 },
  { code: 'objects_taken_marshal', kind: 'lifetime', category: 'siegecraft', metric: 'objects_taken_marshal', unit: 'count', thresholds: [1, 5, 25, 100, 250, 500], mode: '', hidden: false, rotation: -1 },
  { code: 'objects_taken_ward', kind: 'lifetime', category: 'siegecraft', metric: 'objects_taken_ward', unit: 'count', thresholds: [1, 5, 25, 100, 250, 500], mode: '', hidden: false, rotation: -1 },
  { code: 'objects_held_windows', kind: 'lifetime', category: 'siegecraft', metric: 'object_windows_held', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'pledges', kind: 'lifetime', category: 'siegecraft', metric: 'pledges', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'siege_kills', kind: 'lifetime', category: 'siegecraft', metric: 'kills_in_siege', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'throne_hours', kind: 'lifetime', category: 'siegecraft', metric: 'throne_sec', unit: 'sec', thresholds: [3600, 36000, 180000, 720000, 1800000, 3600000], mode: '', hidden: false, rotation: -1 },
  { code: 'beacon_anchors', kind: 'lifetime', category: 'siegecraft', metric: 'anchors_set', unit: 'count', thresholds: [5, 25, 100, 500, 2000, 6000], mode: '', hidden: false, rotation: -1 },
  { code: 'beacons_lost', kind: 'lifetime', category: 'siegecraft', metric: 'beacons_lost', unit: 'count', thresholds: [1, 5, 25, 100, 250, 500], mode: '', hidden: false, rotation: -1 },
  { code: 'cells_taken', kind: 'lifetime', category: 'territory', metric: 'cells_taken', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'cells_owned_max', kind: 'lifetime', category: 'territory', metric: 'cells_owned_max', unit: 'count', thresholds: [10, 25, 50, 100, 200, 400], mode: '', hidden: false, rotation: -1 },
  { code: 'cells_lost', kind: 'lifetime', category: 'territory', metric: 'cells_lost', unit: 'count', thresholds: [5, 25, 100, 500, 2000, 6000], mode: '', hidden: false, rotation: -1 },
  { code: 'flips_from_enemy', kind: 'lifetime', category: 'territory', metric: 'cells_taken_from_enemy', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'rim_saved', kind: 'lifetime', category: 'territory', metric: 'rim_cells_saved', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'pocket_connected', kind: 'lifetime', category: 'territory', metric: 'pockets_joined', unit: 'count', thresholds: [1, 5, 25, 100, 250, 500], mode: '', hidden: false, rotation: -1 },
  { code: 'frontier_days', kind: 'lifetime', category: 'territory', metric: 'frontier_sec', unit: 'sec', thresholds: [3600, 36000, 180000, 720000, 1800000, 3600000], mode: '', hidden: false, rotation: -1 },
  { code: 'trench_cells', kind: 'lifetime', category: 'territory', metric: 'trench_cells_taken', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'installations_held', kind: 'lifetime', category: 'territory', metric: 'installation_hold_sec', unit: 'sec', thresholds: [3600, 36000, 180000, 720000, 1800000, 3600000], mode: '', hidden: false, rotation: -1 },
  { code: 'captains_recruited', kind: 'lifetime', category: 'wardroom', metric: 'captains_recruited', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'captains_trained', kind: 'lifetime', category: 'wardroom', metric: 'talents_trained', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'captain_seasons_max', kind: 'lifetime', category: 'wardroom', metric: 'captain_seasons_max', unit: 'count', thresholds: [1, 2, 4, 6, 8, 12], mode: '', hidden: false, rotation: -1 },
  { code: 'captain_attr_max', kind: 'lifetime', category: 'wardroom', metric: 'captain_attr_max', unit: 'level', thresholds: [3, 5, 6, 8, 9, 10], mode: '', hidden: false, rotation: -1 },
  { code: 'wardroom_full', kind: 'lifetime', category: 'wardroom', metric: 'wardroom_size_max', unit: 'count', thresholds: [3, 4, 5, 6], mode: '', hidden: false, rotation: -1 },
  { code: 'captains_lost', kind: 'lifetime', category: 'wardroom', metric: 'captains_lost', unit: 'count', thresholds: [1, 5, 25, 100, 250, 500], mode: '', hidden: false, rotation: -1 },
  { code: 'captains_wounded', kind: 'lifetime', category: 'wardroom', metric: 'captains_wounded', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'captains_dismissed', kind: 'lifetime', category: 'wardroom', metric: 'captains_dismissed', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'captain_retired_legend', kind: 'recognition', category: 'wardroom', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'sabbatical_kept', kind: 'recognition', category: 'wardroom', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'captain_practice', kind: 'lifetime', category: 'wardroom', metric: 'practice_points', unit: 'count', thresholds: [1, 10, 30, 75, 150, 300], mode: '', hidden: false, rotation: -1 },
  { code: 'captain_practice_cap', kind: 'lifetime', category: 'wardroom', metric: 'practice_caps', unit: 'count', thresholds: [1, 5, 15, 40, 100, 200], mode: '', hidden: false, rotation: -1 },
  { code: 'captain_all_round', kind: 'lifetime', category: 'wardroom', metric: 'practice_attrs_max', unit: 'count', thresholds: [2, 3, 4, 5, 6], mode: '', hidden: false, rotation: -1 },
  { code: 'scan_pings', kind: 'lifetime', category: 'signals', metric: 'scan_pings', unit: 'count', thresholds: [5, 25, 100, 500, 2000, 6000], mode: '', hidden: false, rotation: -1 },
  { code: 'scan_reports', kind: 'lifetime', category: 'signals', metric: 'scan_reports_shared', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'intel_received', kind: 'lifetime', category: 'signals', metric: 'intel_received', unit: 'count', thresholds: [5, 25, 100, 500, 2000, 6000], mode: '', hidden: false, rotation: -1 },
  { code: 'oracle_shares', kind: 'lifetime', category: 'signals', metric: 'oracle_shares', unit: 'count', thresholds: [1, 5, 25, 100, 250, 500], mode: '', hidden: false, rotation: -1 },
  { code: 'comms_max', kind: 'lifetime', category: 'signals', metric: 'comms_level_max', unit: 'level', thresholds: [1, 2, 3, 4, 5], mode: '', hidden: false, rotation: -1 },
  { code: 'contacts_heard', kind: 'lifetime', category: 'signals', metric: 'contacts_first_heard', unit: 'count', thresholds: [5, 25, 100, 500, 2000, 6000], mode: '', hidden: false, rotation: -1 },
  { code: 'reveals', kind: 'lifetime', category: 'signals', metric: 'scan_reveals', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'deep_runs', kind: 'lifetime', category: 'signals', metric: 'deep_run_sec', unit: 'sec', thresholds: [3600, 36000, 180000, 720000, 1800000, 3600000], mode: '', hidden: false, rotation: -1 },
  { code: 'orders_given', kind: 'lifetime', category: 'seamanship', metric: 'orders', unit: 'count', thresholds: [5, 25, 100, 500, 2000, 6000], mode: '', hidden: false, rotation: -1 },
  { code: 'distance_travelled', kind: 'lifetime', category: 'seamanship', metric: 'distance_px', unit: 'px', thresholds: [1000, 10000, 50000, 200000, 750000, 2000000], mode: '', hidden: false, rotation: -1 },
  { code: 'missions_move', kind: 'lifetime', category: 'seamanship', metric: 'missions_move', unit: 'count', thresholds: [5, 25, 100, 500, 2000, 6000], mode: '', hidden: false, rotation: -1 },
  { code: 'missions_gather', kind: 'lifetime', category: 'seamanship', metric: 'missions_gather', unit: 'count', thresholds: [5, 25, 100, 500, 2000, 6000], mode: '', hidden: false, rotation: -1 },
  { code: 'missions_patrol', kind: 'lifetime', category: 'seamanship', metric: 'missions_patrol', unit: 'count', thresholds: [5, 25, 100, 500, 2000, 6000], mode: '', hidden: false, rotation: -1 },
  { code: 'missions_defend', kind: 'lifetime', category: 'seamanship', metric: 'missions_defend', unit: 'count', thresholds: [5, 25, 100, 500, 2000, 6000], mode: '', hidden: false, rotation: -1 },
  { code: 'missions_attack_move', kind: 'lifetime', category: 'seamanship', metric: 'missions_attack_move', unit: 'count', thresholds: [5, 25, 100, 500, 2000, 6000], mode: '', hidden: false, rotation: -1 },
  { code: 'missions_anchor', kind: 'lifetime', category: 'seamanship', metric: 'missions_anchor', unit: 'count', thresholds: [5, 25, 100, 500, 2000, 6000], mode: '', hidden: false, rotation: -1 },
  { code: 'docked', kind: 'lifetime', category: 'seamanship', metric: 'fleets_docked', unit: 'count', thresholds: [5, 25, 100, 500, 2000, 6000], mode: '', hidden: false, rotation: -1 },
  { code: 'groups_formed', kind: 'lifetime', category: 'seamanship', metric: 'groups_formed', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'withdrawals', kind: 'lifetime', category: 'seamanship', metric: 'withdrawals', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: '', hidden: false, rotation: -1 },
  { code: 'session_hours', kind: 'lifetime', category: 'seamanship', metric: 'session_sec', unit: 'sec', thresholds: [3600, 36000, 180000, 720000, 1800000, 3600000], mode: '', hidden: false, rotation: -1 },
  { code: 'days_active', kind: 'lifetime', category: 'seamanship', metric: 'days_active', unit: 'count', thresholds: [1, 7, 30, 90, 180, 300], mode: '', hidden: false, rotation: -1 },
  { code: 'nights_at_sea', kind: 'lifetime', category: 'seamanship', metric: 'night_session_sec', unit: 'sec', thresholds: [3600, 36000, 180000, 720000, 1800000, 3600000], mode: '', hidden: false, rotation: -1 },
  { code: 'quake_survived', kind: 'lifetime', category: 'seamanship', metric: 'quakes_survived', unit: 'count', thresholds: [1, 2, 4, 7, 10, 13], mode: '', hidden: false, rotation: -1 },
  { code: 'control_groups', kind: 'lifetime', category: 'seamanship', metric: 'control_group_recalls', unit: 'count', thresholds: [5, 25, 100, 500, 2000, 6000], mode: '', hidden: false, rotation: -1 },
  { code: 'clan_founded', kind: 'recognition', category: 'fellowship', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'clan_seasons', kind: 'lifetime', category: 'fellowship', metric: 'clan_seasons', unit: 'count', thresholds: [1, 2, 4, 7, 10, 13], mode: '', hidden: false, rotation: -1 },
  { code: 'squad_seasons', kind: 'lifetime', category: 'fellowship', metric: 'squad_seasons', unit: 'count', thresholds: [1, 2, 4, 7, 10, 13], mode: '', hidden: false, rotation: -1 },
  { code: 'chat_lines', kind: 'lifetime', category: 'fellowship', metric: 'chat_lines', unit: 'count', thresholds: [5, 25, 100, 500, 2000, 6000], mode: '', hidden: false, rotation: -1 },
  { code: 'clan_full', kind: 'recognition', category: 'fellowship', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'faction_seasons_abyssal_compact', kind: 'lifetime', category: 'fellowship', metric: 'seasons_under_abyssal_compact', unit: 'count', thresholds: [1, 2, 4, 7, 10, 13], mode: '', hidden: false, rotation: -1 },
  { code: 'faction_seasons_rust_fleet', kind: 'lifetime', category: 'fellowship', metric: 'seasons_under_rust_fleet', unit: 'count', thresholds: [1, 2, 4, 7, 10, 13], mode: '', hidden: false, rotation: -1 },
  { code: 'faction_seasons_mariana_sisters', kind: 'lifetime', category: 'fellowship', metric: 'seasons_under_mariana_sisters', unit: 'count', thresholds: [1, 2, 4, 7, 10, 13], mode: '', hidden: false, rotation: -1 },
  { code: 'faction_seasons_kelp_syndicate', kind: 'lifetime', category: 'fellowship', metric: 'seasons_under_kelp_syndicate', unit: 'count', thresholds: [1, 2, 4, 7, 10, 13], mode: '', hidden: false, rotation: -1 },
  { code: 'faction_seasons_void_choir', kind: 'lifetime', category: 'fellowship', metric: 'seasons_under_void_choir', unit: 'count', thresholds: [1, 2, 4, 7, 10, 13], mode: '', hidden: false, rotation: -1 },
  { code: 'every_faction', kind: 'lifetime', category: 'fellowship', metric: 'faction_mask', unit: 'mask', thresholds: [1, 2, 3, 4, 5], mode: '', hidden: false, rotation: -1 },
  { code: 'npc_clan_left', kind: 'recognition', category: 'fellowship', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'seasons_played', kind: 'lifetime', category: 'service', metric: 'seasons_played', unit: 'count', thresholds: [1, 2, 4, 7, 10, 13], mode: '', hidden: false, rotation: -1 },
  { code: 'seasons_finished', kind: 'lifetime', category: 'service', metric: 'seasons_to_the_end', unit: 'count', thresholds: [1, 2, 4, 7, 10, 13], mode: '', hidden: false, rotation: -1 },
  { code: 'honour_total', kind: 'lifetime', category: 'service', metric: 'honour_total', unit: 'units', thresholds: [100, 500, 2000, 8000, 25000, 60000], mode: '', hidden: false, rotation: -1 },
  { code: 'rank_titles', kind: 'lifetime', category: 'service', metric: 'honour_rank_max', unit: 'level', thresholds: [1, 5, 9, 13, 17, 19], mode: '', hidden: false, rotation: -1 },
  { code: 'best_score', kind: 'lifetime', category: 'service', metric: 'score_max', unit: 'units', thresholds: [1000, 5000, 20000, 60000, 150000, 400000], mode: '', hidden: false, rotation: -1 },
  { code: 'top_half', kind: 'lifetime', category: 'service', metric: 'top_half_seasons', unit: 'count', thresholds: [1, 2, 4, 7, 10, 13], mode: '', hidden: false, rotation: -1 },
  { code: 'top_ten_pct', kind: 'lifetime', category: 'service', metric: 'top_decile_seasons', unit: 'count', thresholds: [1, 2, 4, 7, 10, 13], mode: '', hidden: false, rotation: -1 },
  { code: 'journeys_completed', kind: 'lifetime', category: 'service', metric: 'journeys_completed', unit: 'count', thresholds: [1, 2, 4, 7, 10, 13], mode: '', hidden: false, rotation: -1 },
  { code: 'achievement_points', kind: 'lifetime', category: 'service', metric: 'points', unit: 'units', thresholds: [10, 50, 200, 800, 2500, 8000], mode: '', hidden: false, rotation: -1 },
  { code: 'challenger_count', kind: 'lifetime', category: 'service', metric: 'challenger_grades', unit: 'count', thresholds: [1, 3, 6, 10, 20, 30], mode: '', hidden: false, rotation: -1 },
  { code: 'registered', kind: 'recognition', category: 'service', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'theme_made', kind: 'recognition', category: 'service', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'effect_worn', kind: 'recognition', category: 'service', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'replay_shared', kind: 'recognition', category: 'service', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'arcade_matches', kind: 'lifetime', category: 'arcade', metric: 'arcade_matches', unit: 'count', thresholds: [5, 25, 100, 500, 2000, 6000], mode: 'arcade', hidden: false, rotation: -1 },
  { code: 'arcade_wins', kind: 'lifetime', category: 'arcade', metric: 'arcade_wins', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: 'arcade', hidden: false, rotation: -1 },
  { code: 'arcade_kills', kind: 'lifetime', category: 'arcade', metric: 'arcade_kills', unit: 'count', thresholds: [5, 25, 100, 500, 2000, 6000], mode: 'arcade', hidden: false, rotation: -1 },
  { code: 'arcade_torpedo_kills', kind: 'lifetime', category: 'arcade', metric: 'arcade_kills_torpedo', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: 'arcade', hidden: false, rotation: -1 },
  { code: 'arcade_cells', kind: 'lifetime', category: 'arcade', metric: 'arcade_cells_taken', unit: 'count', thresholds: [5, 25, 100, 500, 2000, 6000], mode: 'arcade', hidden: false, rotation: -1 },
  { code: 'arcade_mined', kind: 'lifetime', category: 'arcade', metric: 'arcade_units_mined', unit: 'units', thresholds: [1000, 10000, 50000, 200000, 750000, 2000000], mode: 'arcade', hidden: false, rotation: -1 },
  { code: 'arcade_scans', kind: 'lifetime', category: 'arcade', metric: 'arcade_scans', unit: 'count', thresholds: [5, 25, 100, 500, 2000, 6000], mode: 'arcade', hidden: false, rotation: -1 },
  { code: 'arcade_maps', kind: 'lifetime', category: 'arcade', metric: 'arcade_map_mask', unit: 'mask', thresholds: [1, 5, 15, 30, 45, 61], mode: 'arcade', hidden: false, rotation: -1 },
  { code: 'arcade_win_kinds', kind: 'lifetime', category: 'arcade', metric: 'arcade_win_kind_mask', unit: 'mask', thresholds: [1, 2, 3, 4, 5, 6], mode: 'arcade', hidden: false, rotation: -1 },
  { code: 'arcade_bots_beaten', kind: 'lifetime', category: 'arcade', metric: 'arcade_bot_wins', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: 'arcade', hidden: false, rotation: -1 },
  { code: 'arcade_humans_beaten', kind: 'lifetime', category: 'arcade', metric: 'arcade_human_wins', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: 'arcade', hidden: false, rotation: -1 },
  { code: 'arcade_hosted', kind: 'lifetime', category: 'arcade', metric: 'arcade_hostings', unit: 'count', thresholds: [1, 10, 50, 200, 750, 2000], mode: 'arcade', hidden: false, rotation: -1 },
  { code: 'arcade_spectated', kind: 'recognition', category: 'arcade', metric: '', unit: '', thresholds: [], mode: 'arcade', hidden: false, rotation: -1 },
  { code: 'arcade_daily_streak', kind: 'lifetime', category: 'arcade', metric: 'arcade_days', unit: 'count', thresholds: [1, 7, 30, 90, 180, 300], mode: 'arcade', hidden: false, rotation: -1 },
  { code: 'arcade_fastest_win', kind: 'lifetime', category: 'arcade', metric: 'arcade_win_time_min', unit: 'sec', thresholds: [900, 600, 420, 300, 210, 150], mode: 'arcade', hidden: false, rotation: -1 },
  { code: 'event_seasons', kind: 'lifetime', category: 'event', metric: 'event_seasons', unit: 'count', thresholds: [2, 4, 8, 14, 20, 26], mode: 'event', hidden: true, rotation: -1 },
  { code: 'event_finished', kind: 'lifetime', category: 'event', metric: 'event_seasons_to_the_end', unit: 'count', thresholds: [2, 4, 8, 14, 20, 26], mode: 'event', hidden: true, rotation: -1 },
  { code: 'event_honour', kind: 'lifetime', category: 'event', metric: 'event_honour', unit: 'units', thresholds: [100, 500, 2000, 8000, 25000, 60000], mode: 'event', hidden: true, rotation: -1 },
  { code: 'event_top_half', kind: 'lifetime', category: 'event', metric: 'event_top_half_seasons', unit: 'count', thresholds: [2, 4, 8, 14, 20, 26], mode: 'event', hidden: true, rotation: -1 },
  { code: 'event_top_decile', kind: 'lifetime', category: 'event', metric: 'event_top_decile_seasons', unit: 'count', thresholds: [2, 4, 8, 14, 20, 26], mode: 'event', hidden: true, rotation: -1 },
  { code: 'event_fleets_killed', kind: 'lifetime', category: 'event', metric: 'event_fleets_killed', unit: 'count', thresholds: [2, 20, 100, 400, 1500, 4000], mode: 'event', hidden: true, rotation: -1 },
  { code: 'event_cells_taken', kind: 'lifetime', category: 'event', metric: 'event_cells_taken', unit: 'count', thresholds: [2, 20, 100, 400, 1500, 4000], mode: 'event', hidden: true, rotation: -1 },
  { code: 'event_sieges_won', kind: 'lifetime', category: 'event', metric: 'event_sieges_won', unit: 'count', thresholds: [2, 10, 50, 200, 500, 1000], mode: 'event', hidden: true, rotation: -1 },
  { code: 'event_gathered', kind: 'lifetime', category: 'event', metric: 'event_gathered_units', unit: 'units', thresholds: [2000, 20000, 100000, 400000, 1500000, 4000000], mode: 'event', hidden: true, rotation: -1 },
  { code: 'event_ships', kind: 'lifetime', category: 'event', metric: 'event_ships_built', unit: 'count', thresholds: [10, 50, 200, 1000, 4000, 12000], mode: 'event', hidden: true, rotation: -1 },
  { code: 'event_tech', kind: 'lifetime', category: 'event', metric: 'event_tech_recovered', unit: 'count', thresholds: [10, 50, 200, 1000, 4000, 12000], mode: 'event', hidden: true, rotation: -1 },
  { code: 'event_captains_recruited', kind: 'lifetime', category: 'event', metric: 'event_captains_recruited', unit: 'count', thresholds: [2, 20, 100, 400, 1500, 4000], mode: 'event', hidden: true, rotation: -1 },
  { code: 'event_first', kind: 'recognition', category: 'event', metric: '', unit: '', thresholds: [], mode: 'event', hidden: true, rotation: -1 },
  { code: 'event_top_three', kind: 'recognition', category: 'event', metric: '', unit: '', thresholds: [], mode: 'event', hidden: true, rotation: -1 },
  { code: 'event_every_window', kind: 'recognition', category: 'event', metric: '', unit: '', thresholds: [], mode: 'event', hidden: true, rotation: -1 },
  { code: 'event_blitz_finished', kind: 'recognition', category: 'event', metric: '', unit: '', thresholds: [], mode: 'event', hidden: true, rotation: -1 },
  { code: 'event_roster_full', kind: 'lifetime', category: 'event', metric: 'event_roster_size_max', unit: 'count', thresholds: [3, 4, 5, 6], mode: 'event', hidden: true, rotation: -1 },
  { code: 'event_journey_complete', kind: 'recognition', category: 'event', metric: '', unit: '', thresholds: [], mode: 'event', hidden: true, rotation: -1 },
  { code: 'event_win_kinds', kind: 'lifetime', category: 'event', metric: 'event_world_kind_mask', unit: 'mask', thresholds: [1, 2, 3, 4, 5, 6], mode: 'event', hidden: true, rotation: -1 },
  { code: 'event_points', kind: 'lifetime', category: 'event', metric: 'event_points', unit: 'units', thresholds: [10, 50, 200, 800, 2500, 8000], mode: 'event', hidden: true, rotation: -1 },
  { code: 'clanwar_wars', kind: 'lifetime', category: 'clanwar', metric: 'clanwar_wars', unit: 'count', thresholds: [1, 4, 12, 26, 40, 52], mode: 'clanwar', hidden: false, rotation: -1 },
  { code: 'clanwar_wars_finished', kind: 'lifetime', category: 'clanwar', metric: 'clanwar_wars_finished', unit: 'count', thresholds: [1, 4, 12, 24, 36, 48], mode: 'clanwar', hidden: false, rotation: -1 },
  { code: 'clanwar_honour', kind: 'lifetime', category: 'clanwar', metric: 'clanwar_honour', unit: 'units', thresholds: [50, 250, 1000, 4000, 12000, 25000], mode: 'clanwar', hidden: false, rotation: -1 },
  { code: 'clanwar_banner_wins', kind: 'lifetime', category: 'clanwar', metric: 'clanwar_banner_wins', unit: 'count', thresholds: [1, 3, 6, 12, 20, 30], mode: 'clanwar', hidden: false, rotation: -1 },
  { code: 'clanwar_fleets_killed', kind: 'lifetime', category: 'clanwar', metric: 'clanwar_fleets_killed', unit: 'count', thresholds: [1, 10, 50, 250, 800, 2000], mode: 'clanwar', hidden: false, rotation: -1 },
  { code: 'clanwar_cells_taken', kind: 'lifetime', category: 'clanwar', metric: 'clanwar_cells_taken', unit: 'count', thresholds: [5, 25, 100, 400, 1200, 3000], mode: 'clanwar', hidden: false, rotation: -1 },
  { code: 'clanwar_sieges_won', kind: 'lifetime', category: 'clanwar', metric: 'clanwar_sieges_won', unit: 'count', thresholds: [1, 5, 15, 40, 80, 150], mode: 'clanwar', hidden: false, rotation: -1 },
  { code: 'clanwar_pledges', kind: 'lifetime', category: 'clanwar', metric: 'clanwar_pledges', unit: 'count', thresholds: [1, 10, 50, 150, 400, 800], mode: 'clanwar', hidden: false, rotation: -1 },
  { code: 'clanwar_battles_defended', kind: 'lifetime', category: 'clanwar', metric: 'clanwar_battles_defended', unit: 'count', thresholds: [1, 5, 20, 60, 130, 250], mode: 'clanwar', hidden: false, rotation: -1 },
  { code: 'clanwar_kills_in_siege', kind: 'lifetime', category: 'clanwar', metric: 'clanwar_kills_in_siege', unit: 'count', thresholds: [1, 10, 40, 120, 250, 500], mode: 'clanwar', hidden: false, rotation: -1 },
  { code: 'clanwar_scan_reports_shared', kind: 'lifetime', category: 'clanwar', metric: 'clanwar_scan_reports_shared', unit: 'count', thresholds: [1, 10, 50, 200, 500, 1000], mode: 'clanwar', hidden: false, rotation: -1 },
  { code: 'clanwar_sieges_won_together', kind: 'lifetime', category: 'clanwar', metric: 'clanwar_sieges_won_together', unit: 'count', thresholds: [1, 5, 15, 30, 60, 100], mode: 'clanwar', hidden: false, rotation: -1 },
  { code: 'clanwar_points', kind: 'lifetime', category: 'clanwar', metric: 'clanwar_points', unit: 'units', thresholds: [10, 50, 150, 350, 550, 700], mode: 'clanwar', hidden: false, rotation: -1 },
  { code: 'clanwar_first_war', kind: 'recognition', category: 'clanwar', metric: '', unit: '', thresholds: [], mode: 'clanwar', hidden: false, rotation: -1 },
  { code: 'clanwar_full_muster', kind: 'recognition', category: 'clanwar', metric: '', unit: '', thresholds: [], mode: 'clanwar', hidden: false, rotation: -1 },
  { code: 'clanwar_victor', kind: 'recognition', category: 'clanwar', metric: '', unit: '', thresholds: [], mode: 'clanwar', hidden: false, rotation: -1 },
  { code: 'clanwar_first', kind: 'recognition', category: 'clanwar', metric: '', unit: '', thresholds: [], mode: 'clanwar', hidden: false, rotation: -1 },
  { code: 'clanwar_division', kind: 'recognition', category: 'clanwar', metric: '', unit: '', thresholds: [], mode: 'clanwar', hidden: false, rotation: -1 },
  { code: 'j_first_ship', kind: 'journey', category: 'journey', metric: 'ships_built', unit: 'count', thresholds: [1, 5, 20], mode: '', hidden: false, rotation: -1 },
  { code: 'j_first_tech', kind: 'journey', category: 'journey', metric: 'tech_recovered', unit: 'count', thresholds: [1, 5, 15], mode: '', hidden: false, rotation: -1 },
  { code: 'j_cells', kind: 'journey', category: 'journey', metric: 'cells_taken', unit: 'count', thresholds: [5, 25, 100], mode: '', hidden: false, rotation: -1 },
  { code: 'j_kills', kind: 'journey', category: 'journey', metric: 'fleets_killed', unit: 'count', thresholds: [1, 10, 40], mode: '', hidden: false, rotation: -1 },
  { code: 'j_gathered', kind: 'journey', category: 'journey', metric: 'gathered_units', unit: 'units', thresholds: [2000, 20000, 100000], mode: '', hidden: false, rotation: -1 },
  { code: 'j_buildings', kind: 'journey', category: 'journey', metric: 'building_levels', unit: 'count', thresholds: [3, 12, 30], mode: '', hidden: false, rotation: -1 },
  { code: 'j_expedition', kind: 'journey', category: 'journey', metric: 'expeditions', unit: 'count', thresholds: [1, 3, 8], mode: '', hidden: false, rotation: -1 },
  { code: 'j_siege', kind: 'journey', category: 'journey', metric: 'sieges_settled', unit: 'count', thresholds: [1, 2, 4], mode: '', hidden: false, rotation: -1 },
  { code: 'j_captain', kind: 'journey', category: 'journey', metric: 'captains_recruited', unit: 'count', thresholds: [1, 2, 3], mode: '', hidden: false, rotation: -1 },
  { code: 'j_intel', kind: 'journey', category: 'journey', metric: 'scan_reports_shared', unit: 'count', thresholds: [1, 10, 40], mode: '', hidden: false, rotation: -1 },
  { code: 'j_days', kind: 'journey', category: 'journey', metric: 'days_active', unit: 'count', thresholds: [3, 10, 20], mode: '', hidden: false, rotation: -1 },
  { code: 'j_quake', kind: 'journey', category: 'journey', metric: 'quakes_survived', unit: 'count', thresholds: [1, 2, 3], mode: '', hidden: false, rotation: -1 },
  { code: 'j_torpedo_hits', kind: 'journey', category: 'journey', metric: 'torpedo_hits', unit: 'count', thresholds: [1, 10, 40], mode: '', hidden: false, rotation: 0 },
  { code: 'j_prints_installed', kind: 'journey', category: 'journey', metric: 'prints_installed', unit: 'count', thresholds: [1, 5, 15], mode: '', hidden: false, rotation: 0 },
  { code: 'j_market_sales', kind: 'journey', category: 'journey', metric: 'market_sales', unit: 'count', thresholds: [1, 5, 20], mode: '', hidden: false, rotation: 0 },
  { code: 'j_beacons', kind: 'journey', category: 'journey', metric: 'anchors_set', unit: 'count', thresholds: [1, 5, 20], mode: '', hidden: false, rotation: 0 },
  { code: 'j_repairs', kind: 'journey', category: 'journey', metric: 'repairs_done', unit: 'count', thresholds: [1, 10, 40], mode: '', hidden: false, rotation: 0 },
  { code: 'j_first_strike', kind: 'journey', category: 'journey', metric: 'first_strike_kills', unit: 'count', thresholds: [1, 5, 20], mode: '', hidden: false, rotation: 0 },
  { code: 'j_salvage', kind: 'journey', category: 'journey', metric: 'salvage_units', unit: 'units', thresholds: [1000, 10000, 50000], mode: '', hidden: false, rotation: 1 },
  { code: 'j_deep_run_hours', kind: 'journey', category: 'journey', metric: 'deep_run_sec', unit: 'sec', thresholds: [3600, 18000, 72000], mode: '', hidden: false, rotation: 1 },
  { code: 'j_objects_held', kind: 'journey', category: 'journey', metric: 'object_windows_held', unit: 'count', thresholds: [1, 5, 15], mode: '', hidden: false, rotation: 1 },
  { code: 'j_every_hull_class', kind: 'journey', category: 'journey', metric: 'hull_built_mask', unit: 'mask', thresholds: [3, 6, 9], mode: '', hidden: false, rotation: 1 },
  { code: 'j_ransom', kind: 'journey', category: 'journey', metric: 'ransoms_paid', unit: 'count', thresholds: [1, 2, 4], mode: '', hidden: false, rotation: 1 },
  { code: 'j_frontier_hours', kind: 'journey', category: 'journey', metric: 'frontier_sec', unit: 'sec', thresholds: [3600, 36000, 144000], mode: '', hidden: false, rotation: 1 },
  { code: 'j_compacts', kind: 'journey', category: 'journey', metric: 'compact_units', unit: 'units', thresholds: [1000, 10000, 50000], mode: '', hidden: false, rotation: 2 },
  { code: 'j_data_cores', kind: 'journey', category: 'journey', metric: 'cores_found', unit: 'count', thresholds: [1, 5, 15], mode: '', hidden: false, rotation: 2 },
  { code: 'j_kills_with_torpedo', kind: 'journey', category: 'journey', metric: 'kills_by_torpedo', unit: 'count', thresholds: [1, 10, 40], mode: '', hidden: false, rotation: 2 },
  { code: 'j_installations_held', kind: 'journey', category: 'journey', metric: 'installation_hold_sec', unit: 'sec', thresholds: [3600, 36000, 144000], mode: '', hidden: false, rotation: 2 },
  { code: 'j_groups_formed', kind: 'journey', category: 'journey', metric: 'groups_formed', unit: 'count', thresholds: [1, 5, 20], mode: '', hidden: false, rotation: 2 },
  { code: 'j_no_env_death', kind: 'recognition', category: 'journey', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: 2 },
  { code: 'j_night_watch', kind: 'journey', category: 'journey', metric: 'night_session_sec', unit: 'sec', thresholds: [3600, 18000, 72000], mode: '', hidden: false, rotation: 3 },
  { code: 'j_pledges', kind: 'journey', category: 'journey', metric: 'pledges', unit: 'count', thresholds: [1, 5, 15], mode: '', hidden: false, rotation: 3 },
  { code: 'j_inventions', kind: 'journey', category: 'journey', metric: 'inventions', unit: 'count', thresholds: [1, 5, 15], mode: '', hidden: false, rotation: 3 },
  { code: 'j_trench_cells', kind: 'journey', category: 'journey', metric: 'trench_cells_taken', unit: 'count', thresholds: [1, 10, 40], mode: '', hidden: false, rotation: 3 },
  { code: 'j_captain_trained', kind: 'journey', category: 'journey', metric: 'talents_trained', unit: 'count', thresholds: [1, 5, 15], mode: '', hidden: false, rotation: 3 },
  { code: 'j_captain_practised', kind: 'journey', category: 'journey', metric: 'practice_points', unit: 'count', thresholds: [1, 5, 15], mode: '', hidden: false, rotation: -1 },
  { code: 'j_everyone_home', kind: 'recognition', category: 'journey', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: 3 },
  { code: 'season_first', kind: 'recognition', category: 'recognition', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'season_podium', kind: 'recognition', category: 'recognition', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'season_top_decile', kind: 'recognition', category: 'recognition', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'winning_faction', kind: 'recognition', category: 'recognition', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'faction_champion', kind: 'recognition', category: 'recognition', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'first_blood_of_season', kind: 'recognition', category: 'recognition', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'last_hold_standing', kind: 'recognition', category: 'recognition', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'throne_at_close', kind: 'recognition', category: 'recognition', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'journey_complete', kind: 'recognition', category: 'recognition', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'undefeated', kind: 'recognition', category: 'recognition', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'pacifist', kind: 'recognition', category: 'recognition', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'comeback', kind: 'recognition', category: 'recognition', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'first_season', kind: 'recognition', category: 'recognition', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'dozen_seasons', kind: 'recognition', category: 'recognition', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'every_faction_won', kind: 'recognition', category: 'recognition', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'hall_of_fame', kind: 'recognition', category: 'recognition', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'world_founder', kind: 'recognition', category: 'recognition', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'mastery_industry', kind: 'recognition', category: 'industry', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'mastery_shipyard', kind: 'recognition', category: 'shipyard', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'mastery_arsenal', kind: 'recognition', category: 'arsenal', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'mastery_research', kind: 'recognition', category: 'research', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'mastery_invention', kind: 'recognition', category: 'invention', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'mastery_prospecting', kind: 'recognition', category: 'prospecting', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'mastery_treasury', kind: 'recognition', category: 'treasury', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'mastery_warfare', kind: 'recognition', category: 'warfare', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'mastery_siegecraft', kind: 'recognition', category: 'siegecraft', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'mastery_territory', kind: 'recognition', category: 'territory', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'mastery_wardroom', kind: 'recognition', category: 'wardroom', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'mastery_signals', kind: 'recognition', category: 'signals', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'mastery_seamanship', kind: 'recognition', category: 'seamanship', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'mastery_fellowship', kind: 'recognition', category: 'fellowship', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'mastery_service', kind: 'recognition', category: 'service', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'mastery_arcade', kind: 'recognition', category: 'arcade', metric: '', unit: '', thresholds: [], mode: 'arcade', hidden: false, rotation: -1 },
  { code: 'mastery_event', kind: 'recognition', category: 'event', metric: '', unit: '', thresholds: [], mode: 'event', hidden: true, rotation: -1 },
  { code: 'mastery_clanwar', kind: 'recognition', category: 'clanwar', metric: '', unit: '', thresholds: [], mode: 'clanwar', hidden: false, rotation: -1 },
  { code: 'bug_hunter', kind: 'recognition', category: 'recognition', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'cartographer_laureate', kind: 'recognition', category: 'recognition', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'community_pillar', kind: 'recognition', category: 'recognition', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'tournament_victor', kind: 'recognition', category: 'recognition', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'plank_owner', kind: 'recognition', category: 'recognition', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'test_pilot', kind: 'recognition', category: 'recognition', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'chronicler', kind: 'recognition', category: 'recognition', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'operator_thanks', kind: 'recognition', category: 'recognition', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'casino_hands', kind: 'lifetime', category: 'casino', metric: 'casino_hands', unit: 'count', thresholds: [5, 25, 100, 500, 2000, 6000], mode: '', hidden: false, rotation: -1 },
  { code: 'casino_wagered', kind: 'lifetime', category: 'casino', metric: 'casino_wagered', unit: 'units', thresholds: [1000, 10000, 100000, 500000, 2000000, 10000000], mode: '', hidden: false, rotation: -1 },
  { code: 'casino_pot_max', kind: 'lifetime', category: 'casino', metric: 'casino_pot_max', unit: 'units', thresholds: [200, 1000, 5000, 20000, 100000, 500000], mode: '', hidden: false, rotation: -1 },
  { code: 'casino_jackpots', kind: 'lifetime', category: 'casino', metric: 'casino_jackpots', unit: 'count', thresholds: [1, 3, 10, 25, 50, 100], mode: '', hidden: false, rotation: -1 },
  { code: 'first_hand', kind: 'recognition', category: 'casino', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'natural_blackjack', kind: 'recognition', category: 'casino', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'three_krakens', kind: 'recognition', category: 'casino', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'royal_flush', kind: 'recognition', category: 'casino', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
  { code: 'mastery_casino', kind: 'recognition', category: 'casino', metric: '', unit: '', thresholds: [], mode: '', hidden: false, rotation: -1 },
];

/** The six grade codes, shallow to deep (R927). The name a player
 *  reads is `achievements.grade_<code>` of gen/strings.ts. */
export const ACHIEVEMENT_GRADES: readonly string[] = ['littoral', 'shelf', 'bathyal', 'abyssal', 'hadal', 'challenger'];

/** What one grade is worth, Littoral first. A recognition carries
 *  no points. */
export const ACHIEVEMENT_POINTS: readonly number[] = [1, 2, 4, 8, 16, 32];

/** One badge silhouette per category, in the reading order of the
 *  catalog. The RECORD grid draws one card per entry. */
export const ACHIEVEMENT_CATEGORIES: readonly { id: string; silhouette: string }[] = [
  { id: 'industry', silhouette: 'dome' },
  { id: 'shipyard', silhouette: 'keel' },
  { id: 'arsenal', silhouette: 'torpedo' },
  { id: 'research', silhouette: 'lamp' },
  { id: 'invention', silhouette: 'gears' },
  { id: 'prospecting', silhouette: 'scoop' },
  { id: 'treasury', silhouette: 'coins' },
  { id: 'warfare', silhouette: 'darts' },
  { id: 'siegecraft', silhouette: 'bastion' },
  { id: 'territory', silhouette: 'hex' },
  { id: 'wardroom', silhouette: 'cap' },
  { id: 'signals', silhouette: 'sonar' },
  { id: 'seamanship', silhouette: 'helm' },
  { id: 'fellowship', silhouette: 'anchors' },
  { id: 'service', silhouette: 'ribbon' },
  { id: 'arcade', silhouette: 'buoy' },
  { id: 'event', silhouette: 'stormglass' },
  { id: 'clanwar', silhouette: 'pennants' },
  { id: 'journey', silhouette: 'compass' },
  { id: 'recognition', silhouette: 'laurel' },
  { id: 'casino', silhouette: 'chip' },
];

/** The badge look and the fly-in figures
 *  (data/presentation/achievements.toml). `gradeInk` is one ink per
 *  grade; Challenger takes the accent on purpose, because the deepest
 *  grade must be the badge a reader finds first. The four unlock
 *  figures are the stamp of R962, and the two ring figures its
 *  depth gauge. */
export const ACHIEVEMENT_LOOK = {
  gradeInk: ['#b9c7d2', '#a3cfe6', '#88a0b0', '#5e89a0', '#4c7b93', '#35e0d2'] as readonly string[],
  unlockMs: 6500,
  unlockGapMs: 600,
  unlockCollapseAt: 4,
  unlockLandMs: 320,
  unlockTravelMs: 420,
  unlockScale: 1.5,
  unlockDesktopSize: 2,
  badgePx: 64,
  ringStrokePx: 3.4,
  ringMinStrokePx: 2.3,
} as const;

/** How many rotation sets the season journey cycles through. Set N
 *  is active while `season % ACHIEVEMENT_ROTATION_COUNT === N`. */
export const ACHIEVEMENT_ROTATION_COUNT = 4;

/** The share of the active journey rows a player must hold at
 *  Littoral or better to complete the season journey. */
export const JOURNEY_COMPLETE_SHARE = 0.8;

/** The caps, the flight floor and the alpha ceilings of the gun shots
 *  and the hits (data/presentation/combat.toml, R1007,
 *  ui-map-interface.md §6.3.3). The reference distance, the flight
 *  ceiling and the salvo span are the FAMILY's own (R1013):
 *  `COMBAT_FAMILIES` below holds them. */
export const COMBAT_LIMITS = {
  maxRounds: 320,
  maxHits: 96,
  minRounds: 1,
  flightMinSec: 0.1,
  figureWaitMaxSec: 0.6,
  shooterSnapPx: 26,
  cullPadPx: 120,
  maxAlphaFill: 0.95,
  maxAlphaStroke: 1,
  followHitAlpha: 0.35,
} as const;

/** One shot family's footing (R1013): the separation its own mockup
 *  stage drew, the ceiling of one flight and the longest a whole salvo
 *  may take. `flight = flightSec * dist / refPx`, held between
 *  `COMBAT_LIMITS.flightMinSec` and the family's `flightMaxSec`. */
export interface CombatFamilyRow {
  readonly refPx: number;
  readonly flightMaxSec: number;
  readonly spanMaxSec: number;
}

/** The footing of each of the three shot families, by World body field. */
export const COMBAT_FAMILIES = {
  shotMelee: { refPx: 60, flightMaxSec: 0.5, spanMaxSec: 0.9 },
  shotArtillery: { refPx: 240, flightMaxSec: 1, spanMaxSec: 1.2 },
  shotSentinel: { refPx: 140, flightMaxSec: 1.2, spanMaxSec: 1.4 },
} as const satisfies Readonly<Record<string, CombatFamilyRow>>;

/** One shot look: how a salvo is paced, and the generic figures the
 *  recipe of that card spends. The TOML row's comment says what each
 *  figure means for that card. */
export interface CombatShotRow {
  readonly flightSec: number;
  readonly rounds: number;
  readonly stepSec: number;
  readonly jitterPx: number;
  readonly rPx: number;
  readonly r2Px: number;
  readonly widthPx: number;
  readonly width2Px: number;
  readonly lengthPx: number;
  readonly length2Px: number;
  readonly driftPx: number;
  readonly alpha: number;
  readonly alpha2: number;
  readonly speed: number;
  readonly count: number;
  readonly count2: number;
}

/** One hit look: how long the mark lives, and the same figures. */
export interface CombatHitRow {
  readonly lifeSec: number;
  readonly rPx: number;
  readonly r2Px: number;
  readonly widthPx: number;
  readonly width2Px: number;
  readonly lengthPx: number;
  readonly length2Px: number;
  readonly driftPx: number;
  readonly alpha: number;
  readonly alpha2: number;
  readonly speed: number;
  readonly count: number;
  readonly count2: number;
}

/**
 * The shot looks and the hit looks, by look id (R1007).
 *
 * One table per look list of data/identity/labels.toml. A list is NOT
 * covered whole: a look with no row resolves to the AUTO look of its
 * list, which is what `render/combat-styles.ts` does with its PENDING
 * table. The AUTO look always has a row.
 */
export const COMBAT_SHOTS = {
  shotMelee: {
    'point-blank-flash': { flightSec: 0.16, rounds: 3, stepSec: 0.22, jitterPx: 3, rPx: 1.8, r2Px: 0, widthPx: 5, width2Px: 2.2, lengthPx: 10, length2Px: 0, driftPx: 0, alpha: 0.5, alpha2: 0.85, speed: 0, count: 0, count2: 0 },
    'stitch': { flightSec: 0.22, rounds: 3, stepSec: 0.09, jitterPx: 4, rPx: 4, r2Px: 0, widthPx: 1.5, width2Px: 1, lengthPx: 7, length2Px: 15, driftPx: 0, alpha: 0.9, alpha2: 0.25, speed: 0, count: 0, count2: 0 },
    'burst-fire': { flightSec: 0.25, rounds: 10, stepSec: 0.06, jitterPx: 6, rPx: 1.2, r2Px: 0, widthPx: 1, width2Px: 1, lengthPx: 5, length2Px: 3, driftPx: 0, alpha: 0.4, alpha2: 0.7, speed: 0, count: 0, count2: 0 },
    'broadside': { flightSec: 0.45, rounds: 5, stepSec: 0, jitterPx: 8, rPx: 1.7, r2Px: 6, widthPx: 1.5, width2Px: 5, lengthPx: 12, length2Px: 9, driftPx: 0, alpha: 0.35, alpha2: 0.5, speed: 0, count: 2, count2: 0 },
    'spread-cone': { flightSec: 0.3, rounds: 7, stepSec: 0, jitterPx: 16, rPx: 1.4, r2Px: 0, widthPx: 1, width2Px: 0, lengthPx: 10, length2Px: 0, driftPx: 0, alpha: 0.3, alpha2: 0.85, speed: 0, count: 0, count2: 0 },
    'spear-and-case': { flightSec: 0.35, rounds: 2, stepSec: 0.4, jitterPx: 3, rPx: 1.2, r2Px: 6, widthPx: 1.6, width2Px: 1.8, lengthPx: 16, length2Px: 14, driftPx: 0, alpha: 0.95, alpha2: 0.8, speed: 7, count: 0, count2: 0 },
    'lunge': { flightSec: 0.35, rounds: 1, stepSec: 0, jitterPx: 4, rPx: 2.4, r2Px: 6, widthPx: 5, width2Px: 1, lengthPx: 9, length2Px: 14, driftPx: 0, alpha: 0.35, alpha2: 0.5, speed: 0, count: 0, count2: 0 },
    'piston': { flightSec: 0.32, rounds: 1, stepSec: 0, jitterPx: 3, rPx: 2.2, r2Px: 3, widthPx: 3, width2Px: 0.8, lengthPx: 5, length2Px: 3.5, driftPx: 0, alpha: 0.95, alpha2: 0.25, speed: 0, count: 0, count2: 0 },
    'arc-discharge': { flightSec: 0.22, rounds: 2, stepSec: 0.35, jitterPx: 7, rPx: 1.8, r2Px: 0, widthPx: 2.2, width2Px: 0.8, lengthPx: 9, length2Px: 0, driftPx: 0, alpha: 0.7, alpha2: 0.85, speed: 30, count: 6, count2: 0 },
    'sweep': { flightSec: 0.25, rounds: 5, stepSec: 0.07, jitterPx: 9, rPx: 1.3, r2Px: 0, widthPx: 1, width2Px: 1, lengthPx: 6, length2Px: 0, driftPx: 0, alpha: 0.4, alpha2: 0.6, speed: 0, count: 0, count2: 0 },
  } as Readonly<Record<string, CombatShotRow>>,
  shotArtillery: {
    'siege-salvo': { flightSec: 1.2, rounds: 3, stepSec: 0.3, jitterPx: 12, rPx: 2, r2Px: 0.8, widthPx: 1, width2Px: 0, lengthPx: 24, length2Px: 0, driftPx: 0, alpha: 0.9, alpha2: 0.3, speed: 0, count: 0, count2: 0 },
    'shell-lob': { flightSec: 1.4, rounds: 2, stepSec: 0.5, jitterPx: 10, rPx: 2.6, r2Px: 1.6, widthPx: 1, width2Px: 0, lengthPx: 40, length2Px: 0, driftPx: 0, alpha: 0.95, alpha2: 0.35, speed: 0, count: 0, count2: 0 },
    'track-arc': { flightSec: 1.5, rounds: 1, stepSec: 0, jitterPx: 8, rPx: 2.2, r2Px: 0.9, widthPx: 1, width2Px: 0, lengthPx: 36, length2Px: 0, driftPx: 0, alpha: 0.95, alpha2: 0.4, speed: 0, count: 24, count2: 0 },
    'star-shell': { flightSec: 2, rounds: 1, stepSec: 0, jitterPx: 6, rPx: 2, r2Px: 14, widthPx: 1, width2Px: 18, lengthPx: 44, length2Px: 34, driftPx: 0, alpha: 0.8, alpha2: 0.22, speed: 20, count: 3, count2: 0 },
    'rail-dart': { flightSec: 0.22, rounds: 2, stepSec: 0.6, jitterPx: 2, rPx: 1.5, r2Px: 0, widthPx: 3, width2Px: 1, lengthPx: 6, length2Px: 0, driftPx: 0, alpha: 0.3, alpha2: 0.8, speed: 0, count: 0, count2: 0 },
    'sabot': { flightSec: 0.4, rounds: 2, stepSec: 0.55, jitterPx: 3, rPx: 1.8, r2Px: 3, widthPx: 1, width2Px: 8, lengthPx: 10, length2Px: 14, driftPx: 0, alpha: 0.95, alpha2: 0.85, speed: 0, count: 4, count2: 0 },
    'heavy-round': { flightSec: 1.8, rounds: 1, stepSec: 0, jitterPx: 5, rPx: 4, r2Px: 8, widthPx: 1, width2Px: 1.2, lengthPx: 6, length2Px: 4, driftPx: 0, alpha: 0.95, alpha2: 0.5, speed: 9, count: 0, count2: 0 },
    'fuse-spark': { flightSec: 1.6, rounds: 1, stepSec: 0, jitterPx: 8, rPx: 2.6, r2Px: 2.4, widthPx: 1, width2Px: 3.5, lengthPx: 36, length2Px: 3.7, driftPx: 0, alpha: 0.95, alpha2: 0.7, speed: 4, count: 4, count2: 24 },
    'muzzle-bloom': { flightSec: 0.4, rounds: 2, stepSec: 0.6, jitterPx: 4, rPx: 1.3, r2Px: 6, widthPx: 1, width2Px: 1, lengthPx: 14, length2Px: 19, driftPx: 26, alpha: 0.8, alpha2: 0.5, speed: 0, count: 0, count2: 0 },
    'beam-pulse': { flightSec: 0.6, rounds: 3, stepSec: 0.3, jitterPx: 3, rPx: 1.5, r2Px: 0, widthPx: 1, width2Px: 2, lengthPx: 7, length2Px: 0, driftPx: 0, alpha: 0.8, alpha2: 0.1, speed: 0, count: 4, count2: 0 },
  } as Readonly<Record<string, CombatShotRow>>,
  shotSentinel: {
    'charge-and-snap': { flightSec: 1, rounds: 1, stepSec: 0, jitterPx: 0, rPx: 2.5, r2Px: 14, widthPx: 5, width2Px: 1.5, lengthPx: 10, length2Px: 1.2, driftPx: 0, alpha: 0.95, alpha2: 0.6, speed: 1.1, count: 3, count2: 0 },
    'sentry-pulses': { flightSec: 0.55, rounds: 4, stepSec: 0.14, jitterPx: 5, rPx: 2, r2Px: 0.8, widthPx: 1.2, width2Px: 0, lengthPx: 2.5, length2Px: 0, driftPx: 0, alpha: 0.8, alpha2: 0.9, speed: 0, count: 0, count2: 0 },
    'bulwark-lattice': { flightSec: 1.2, rounds: 1, stepSec: 0, jitterPx: 5, rPx: 3, r2Px: 6.5, widthPx: 1, width2Px: 0, lengthPx: 8, length2Px: 0, driftPx: 0, alpha: 0.9, alpha2: 0.6, speed: 1.2, count: 0, count2: 0 },
    'interceptor-thread': { flightSec: 0.45, rounds: 2, stepSec: 0.5, jitterPx: 4, rPx: 0, r2Px: 0, widthPx: 1, width2Px: 1.4, lengthPx: 6, length2Px: 0, driftPx: 40, alpha: 0.95, alpha2: 0.5, speed: 0, count: 12, count2: 0 },
    'wind-up': { flightSec: 1.1, rounds: 1, stepSec: 0, jitterPx: 2, rPx: 2.2, r2Px: 19, widthPx: 2.5, width2Px: 1, lengthPx: 6, length2Px: 14, driftPx: 0, alpha: 0.95, alpha2: 0.85, speed: 0, count: 0, count2: 0 },
    'tripwire': { flightSec: 1.2, rounds: 1, stepSec: 0, jitterPx: 2, rPx: 1.8, r2Px: 1.2, widthPx: 1, width2Px: 0, lengthPx: 6, length2Px: 0, driftPx: 0, alpha: 0.95, alpha2: 0.6, speed: 0, count: 0, count2: 0 },
    'drum-fire': { flightSec: 0.45, rounds: 3, stepSec: 0.35, jitterPx: 3, rPx: 1.4, r2Px: 3.5, widthPx: 1.5, width2Px: 2, lengthPx: 8, length2Px: 6, driftPx: 0, alpha: 0.95, alpha2: 0.6, speed: 0, count: 2, count2: 0 },
    'stepped-bolt': { flightSec: 0.9, rounds: 1, stepSec: 0, jitterPx: 3, rPx: 2, r2Px: 1.6, widthPx: 1, width2Px: 0, lengthPx: 5, length2Px: 0, driftPx: 0, alpha: 0.95, alpha2: 0.6, speed: 0, count: 8, count2: 3 },
    'mine-drift': { flightSec: 2.4, rounds: 1, stepSec: 0, jitterPx: 8, rPx: 3, r2Px: 2.5, widthPx: 1.2, width2Px: 1, lengthPx: 5.5, length2Px: 4, driftPx: 0, alpha: 0.95, alpha2: 0.9, speed: 0.8, count: 6, count2: 0 },
    'sea-bed-kick': { flightSec: 0.8, rounds: 1, stepSec: 0, jitterPx: 5, rPx: 2.6, r2Px: 1, widthPx: 2.5, width2Px: 6, lengthPx: 9, length2Px: 8, driftPx: 0, alpha: 0.95, alpha2: 0.35, speed: 0, count: 5, count2: 0 },
  } as Readonly<Record<string, CombatShotRow>>,
} as const;

export const COMBAT_HITS = {
  hitShield: {
    'ring-flare': { lifeSec: 0.6, rPx: 19, r2Px: 9, widthPx: 2.5, width2Px: 1, lengthPx: 0, length2Px: 0, driftPx: 0, alpha: 0.9, alpha2: 0.3, speed: 0, count: 0, count2: 0 },
    'ring-ripple': { lifeSec: 0.7, rPx: 19, r2Px: 6, widthPx: 2, width2Px: 1, lengthPx: 5, length2Px: 0, driftPx: 0, alpha: 0.9, alpha2: 0.2, speed: 0, count: 0, count2: 0 },
    'plate-lattice': { lifeSec: 0.8, rPx: 19, r2Px: 5.2, widthPx: 0.8, width2Px: 0, lengthPx: 6, length2Px: 0, driftPx: 0, alpha: 0.55, alpha2: 0.12, speed: 0, count: 3, count2: 3 },
    'growing-crack': { lifeSec: 1.1, rPx: 19, r2Px: 5, widthPx: 1, width2Px: 1, lengthPx: 3.5, length2Px: 2.5, driftPx: 0, alpha: 0.85, alpha2: 0.25, speed: 16, count: 5, count2: 6 },
    'low-flicker': { lifeSec: 0.7, rPx: 19, r2Px: 7, widthPx: 2, width2Px: 1.5, lengthPx: 0, length2Px: 0, driftPx: 0, alpha: 0.9, alpha2: 0.7, speed: 24, count: 0, count2: 35 },
    'drain-shift': { lifeSec: 0.6, rPx: 19, r2Px: 9, widthPx: 2.5, width2Px: 1, lengthPx: 0, length2Px: 0, driftPx: 0, alpha: 0.9, alpha2: 0.3, speed: 0, count: 0, count2: 0 },
    'dome-sheen': { lifeSec: 0.8, rPx: 19, r2Px: 16.5, widthPx: 3, width2Px: 1.5, lengthPx: 7, length2Px: 0, driftPx: 0, alpha: 0.6, alpha2: 0.3, speed: 0, count: 0, count2: 0 },
    'rim-sparks': { lifeSec: 0.7, rPx: 19, r2Px: 5, widthPx: 1, width2Px: 2, lengthPx: 2, length2Px: 10, driftPx: 6, alpha: 0.85, alpha2: 0.8, speed: 0, count: 12, count2: 0 },
    'interference': { lifeSec: 0.8, rPx: 19, r2Px: 5, widthPx: 1.2, width2Px: 1, lengthPx: 38, length2Px: 7, driftPx: 0, alpha: 0.7, alpha2: 0.35, speed: 0, count: 4, count2: 0 },
    'rim-arcs': { lifeSec: 0.4, rPx: 19, r2Px: 2.2, widthPx: 1.2, width2Px: 0, lengthPx: 6, length2Px: 0, driftPx: 0, alpha: 0.85, alpha2: 0.95, speed: 30, count: 8, count2: 0 },
  } as Readonly<Record<string, CombatHitRow>>,
  hitHull: {
    'fragment-fan': { lifeSec: 1.5, rPx: 5, r2Px: 0, widthPx: 0, width2Px: 0, lengthPx: 8, length2Px: 30, driftPx: 11, alpha: 0.85, alpha2: 0.7, speed: 0, count: 9, count2: 0 },
    'spark-shower': { lifeSec: 0.8, rPx: 6, r2Px: 1.8, widthPx: 1, width2Px: 3, lengthPx: 26, length2Px: 46, driftPx: 24, alpha: 0.9, alpha2: 0.8, speed: 0, count: 16, count2: 0 },
    'smoke-puffs': { lifeSec: 2.8, rPx: 1.7, r2Px: 0.8, widthPx: 3, width2Px: 2.5, lengthPx: 34, length2Px: 16, driftPx: 0, alpha: 0.5, alpha2: 0.85, speed: 17, count: 6, count2: 0 },
    'vent-jet': { lifeSec: 1.2, rPx: 0.6, r2Px: 1.2, widthPx: 5, width2Px: 3, lengthPx: 6, length2Px: 28, driftPx: 7, alpha: 0.85, alpha2: 0.7, speed: 0, count: 14, count2: 2 },
    'list': { lifeSec: 1.6, rPx: 5, r2Px: 0, widthPx: 3, width2Px: 1.5, lengthPx: 1.5, length2Px: 0, driftPx: 0, alpha: 0.95, alpha2: 0.55, speed: 0.12, count: 0, count2: 0 },
    'outline-flicker': { lifeSec: 0.9, rPx: 4, r2Px: 0, widthPx: 0, width2Px: 0, lengthPx: 0, length2Px: 0, driftPx: 0, alpha: 0.95, alpha2: 0.6, speed: 24, count: 0, count2: 0 },
    'bubble-fire': { lifeSec: 2.4, rPx: 5, r2Px: 1.3, widthPx: 0.7, width2Px: 1.1, lengthPx: 5, length2Px: 30, driftPx: 0, alpha: 0.9, alpha2: 0.7, speed: 23, count: 20, count2: 0 },
    'inner-fire': { lifeSec: 1.8, rPx: 4, r2Px: 0, widthPx: 0, width2Px: 1.6, lengthPx: 6, length2Px: 20, driftPx: 0, alpha: 0.45, alpha2: 0.5, speed: 1.6, count: 3, count2: 0 },
    'short-circuit': { lifeSec: 0.8, rPx: 1.8, r2Px: 0, widthPx: 1.1, width2Px: 0, lengthPx: 3, length2Px: 2.5, driftPx: 0, alpha: 0.9, alpha2: 0.35, speed: 30, count: 3, count2: 6 },
    'through-and-through': { lifeSec: 0.8, rPx: 4, r2Px: 6, widthPx: 1, width2Px: 3, lengthPx: 9, length2Px: 30, driftPx: 8, alpha: 0.9, alpha2: 0.6, speed: 0, count: 9, count2: 0 },
  } as Readonly<Record<string, CombatHitRow>>,
  hitSink: {
    'spiral-descent': { lifeSec: 5.5, rPx: 10, r2Px: 0, widthPx: 1, width2Px: 0, lengthPx: 6, length2Px: 26, driftPx: 0, alpha: 0.95, alpha2: 0.3, speed: 2, count: 5, count2: 0 },
    'bubble-collapse': { lifeSec: 4, rPx: 28, r2Px: 6, widthPx: 1.5, width2Px: 1, lengthPx: 20, length2Px: 34, driftPx: 60, alpha: 0.9, alpha2: 0.3, speed: 0, count: 9, count2: 0 },
    'break-in-two': { lifeSec: 4.5, rPx: 6, r2Px: 9, widthPx: 1.5, width2Px: 0, lengthPx: 8, length2Px: 36, driftPx: 7, alpha: 0.9, alpha2: 0.7, speed: 0, count: 10, count2: 0 },
    'stern-first': { lifeSec: 5, rPx: 6, r2Px: 0, widthPx: 0, width2Px: 0, lengthPx: 6, length2Px: 40, driftPx: 0, alpha: 0, alpha2: 0.35, speed: 0, count: 12, count2: 0 },
    'silt-burst': { lifeSec: 5, rPx: 6, r2Px: 38, widthPx: 0, width2Px: 0, lengthPx: 30, length2Px: 18, driftPx: 0, alpha: 0.4, alpha2: 0.3, speed: 0, count: 8, count2: 0 },
    'wreck-print': { lifeSec: 4, rPx: 0, r2Px: 0, widthPx: 0, width2Px: 0, lengthPx: 10, length2Px: 28, driftPx: 0, alpha: 0.5, alpha2: 0, speed: 0, count: 6, count2: 0 },
    'last-light': { lifeSec: 5, rPx: 6, r2Px: 1.4, widthPx: 0, width2Px: 0, lengthPx: 0, length2Px: 0, driftPx: 0, alpha: 0.8, alpha2: 0.95, speed: 5.5, count: 3, count2: 0 },
    'implosion': { lifeSec: 3.5, rPx: 44, r2Px: 10, widthPx: 1.5, width2Px: 1, lengthPx: 12, length2Px: 34, driftPx: 30, alpha: 0.9, alpha2: 0.5, speed: 0, count: 6, count2: 0 },
    'ink-ghost': { lifeSec: 5, rPx: 2, r2Px: 0, widthPx: 0, width2Px: 0, lengthPx: 16, length2Px: 10, driftPx: 0, alpha: 0.7, alpha2: 0.12, speed: 0.15, count: 0, count2: 0 },
    'steam-shroud': { lifeSec: 4.5, rPx: 14, r2Px: 0, widthPx: 0, width2Px: 0, lengthPx: 24, length2Px: 56, driftPx: 0, alpha: 0.35, alpha2: 0.8, speed: 3, count: 30, count2: 0 },
  } as Readonly<Record<string, CombatHitRow>>,
} as const;

/** The beats of a Dredger cut, the reach that binds a hull to a field,
 *  the caps of the layer and the alpha ceilings
 *  (data/presentation/gather.toml, R1120, R1121,
 *  ui-map-interface.md §6.2.1).
 *
 *  `lotSec` is WALL time: the map clock differs per world, and a chain
 *  paid in map seconds would smear on one world and crawl on another. */
export const GATHER_LIMITS = {
  lotSec: 1.2,
  shaftRate: 0.25,
  rampInSec: 0.6,
  rampOutSec: 0.4,
  fullSec: 0.8,
  stepSec: 0.6,
  bloomSec: 0.5,
  currentDeg: -20,
  fieldSnapPx: 12,
  maxCuts: 64,
  cullPadPx: 48,
  maxAlphaFill: 0.95,
  maxAlphaStroke: 1,
} as const;

/** Card 14, the LIVE LANE (R1122, ui-map-interface.md §6.1.1): what the
 *  cargo lane of an OWN hull draws while the cut runs. Every length is a
 *  world length in map px, and the lane itself is `FLEET_BARS`. */
export const GATHER_LIVE_LANE = {
  liftPx: 1,
  groundAlpha: 0.8,
  dashGapPx: 4,
  dashSpeedPxPerSec: 5,
  dashWidthPx: 1.1,
  dashAlpha: 0.75,
  shaftGapK: 2,
  dashLighten: 0.6,
  edgeWidthPx: 1.5,
  edgeOverPx: 1,
  edgeMinPx: 2.4,
  edgeAlpha: 0.65,
  edgePulse: 0.35,
  shaftBoxWPx: 2.6,
  shaftBoxOverPx: 0.6,
  shaftBoxStrokePx: 0.8,
  shaftBoxInsetPx: 0.4,
  flashAlpha: 0.8,
  flashOverPx: 0.5,
  bright: 0xffffff,
} as const;

/** Card 09, the GATHER FIGURE (R1123, ui-map-interface.md §6.1.4): the
 *  number that states the units one WALL second put into the hold of the
 *  own Dredgers that cut one field. `xPx` and `yPx` are world lengths
 *  against the hull; every other length is a SCREEN px, the way the
 *  damage figure measures (R538). */
export const GATHER_FIGURE = {
  everySec: 1,
  xPx: 17,
  yPx: -12,
  risePx: 14,
  lifeSec: 1.5,
  shaftLifeSec: 0.7,
  fadeIn: 0.06,
  fadeOut: 0.45,
  sizePx: 8,
  shaftSizePx: 7,
  chipPx: 4.2,
  textGap: 3.5,
  alpha: 0.95,
  shaftAlpha: 0.6,
  chipAlpha: 0.9,
  fullLifeSec: 1.6,
  fullFadeOut: 0.4,
  fullDxPx: -1.5,
  maxFigures: 32,
} as const;

/** One harvesting look: the generic figures the recipe of that card
 *  spends. The TOML row's comment says what each figure means for that
 *  card. */
export interface GatherRow {
  readonly rPx: number;
  readonly r2Px: number;
  readonly widthPx: number;
  readonly width2Px: number;
  readonly lengthPx: number;
  readonly length2Px: number;
  readonly driftPx: number;
  readonly alpha: number;
  readonly alpha2: number;
  readonly alpha3: number;
  readonly alpha4: number;
  readonly speed: number;
  readonly count: number;
  readonly count2: number;
}

/**
 * The harvesting looks, by look id (R1120).
 *
 * The list of data/identity/labels.toml is NOT covered whole: a look
 * with no row resolves to the AUTO look, which is what
 * `render/gather-styles.ts` does with the PENDING tables of the four
 * recipe files. The AUTO look always has a row.
 */
export const GATHER_LOOKS = {
  'drag-loop': { rPx: 3.6, r2Px: 11, widthPx: 0.8, width2Px: 0.6, lengthPx: 2.8, length2Px: 2.4, driftPx: 0, alpha: 0.95, alpha2: 0.6, alpha3: 0.9, alpha4: 0.75, speed: 0, count: 6, count2: 2 },
  'cutter-head': { rPx: 10.4, r2Px: 12.9, widthPx: 1, width2Px: 0.9, lengthPx: 13.4, length2Px: 1.1, driftPx: 2.2, alpha: 0.5, alpha2: 0.7, alpha3: 0.2, alpha4: 0.8, speed: 1.0472, count: 12, count2: 6 },
  'silt-bloom': { rPx: 4, r2Px: 11, widthPx: 2.6, width2Px: 6, lengthPx: 20, length2Px: 17, driftPx: 9, alpha: 0.85, alpha2: 0.3, alpha3: 0, alpha4: 0, speed: 2, count: 6, count2: 4 },
  'keel-glow': { rPx: 19, r2Px: 24, widthPx: 11.5, width2Px: 0, lengthPx: 10.5, length2Px: 12, driftPx: 4, alpha: 0.3, alpha2: 0.85, alpha3: 0.2, alpha4: 0.75, speed: 0, count: 0, count2: 0 },
  'chips-lift': { rPx: 17, r2Px: 8, widthPx: 0.9, width2Px: 0, lengthPx: 4.2, length2Px: 4.83, driftPx: 0, alpha: 0.95, alpha2: 0.5, alpha3: 0.25, alpha4: 0.9, speed: 2.8, count: 3, count2: 1 },
  'grab-beats': { rPx: 13.5, r2Px: 8, widthPx: 1, width2Px: 0, lengthPx: 5, length2Px: 0, driftPx: 0, alpha: 0.95, alpha2: 0.55, alpha3: 0.8, alpha4: 0.85, speed: 0.42, count: 4, count2: 2 },
  'hold-ring': { rPx: 16, r2Px: 1.5, widthPx: 1.5, width2Px: 1, lengthPx: 1.3, length2Px: 1.6, driftPx: 2, alpha: 0.9, alpha2: 0.26, alpha3: 0.7, alpha4: 0.75, speed: 0, count: 0, count2: 0 },
  'work-lights': { rPx: 1.4, r2Px: 1.5, widthPx: 0.8, width2Px: 0, lengthPx: 5.5, length2Px: 6, driftPx: 1.5, alpha: 0.55, alpha2: 0.55, alpha3: 0.95, alpha4: 0, speed: 0, count: 2, count2: 1 },
  'drain-pulse': { rPx: 4.19, r2Px: 0, widthPx: 1.2, width2Px: 1.6, lengthPx: 0.9, length2Px: 3, driftPx: 1.6, alpha: 0.55, alpha2: 0.6, alpha3: 0.85, alpha4: 0.3, speed: 7, count: 25, count2: 0 },
  'spiral-bit': { rPx: 4, r2Px: 15, widthPx: 1, width2Px: 1.5, lengthPx: 3, length2Px: 9, driftPx: 2.3, alpha: 0.42, alpha2: 0.55, alpha3: 0.9, alpha4: 0.25, speed: 2.2, count: 22, count2: 2 },
} as Readonly<Record<string, GatherRow>>;

/** The canvas of the sea objects of v2 phase 6 (R2652, R2657,
 *  ui-map-interface.md §6.1.14): the render figures of
 *  [presentation.seaobjects], in wall seconds and world px. The pack
 *  figures ride the hello catalog (R2659). */
export const SEA_OBJECTS = {
  layNearPx: 40,
  collectSlackPx: 12,
  sirenReachMul: 2,
  targetBracketR: 14,
  targetBracketArm: 5,
  targetBracketWidth: 1.6,
  targetBracketAlpha: 0.45,
  genericMineR: 2.6,
  genericMineSpike: 1.4,
  genericMineSpikes: 6,
  genericMineWidth: 0.8,
  genericMineAlpha: 0.6,
  sheetMaxPx: 2048,
  sheetMargin: 0.5,
  sheetStep: 0.5,
  armHoldSec: 1.3,
  anchorLookMinSec: 1.2,
  layLookMaxSec: 12,
  armSpinTurns: 3,
  collectLeadSec: 0.6,
  collectWindowSec: 4,
  stowAftPx: 1.5,
  sweepWidthPx: 1,
  sweepAlpha: 0.45,
  sweepDashPx: 3,
  collectRingWidth: 1.2,
  collectRingAlpha: 0.28,
  cacheWorkRounds: 5,
  cacheWorkPieces: 4,
  cacheWorkPx: 30,
  cacheWorkCap: 100,
  targetBracketColor: 0xff4a3d,
  burstPx: [11, 9, 15, 20],
  burstWeight: [0.55, 0.25, 0.65, 1],
} as const;

/** The alpha of a hull of another faction, the cull pad and the alpha
 *  ceilings of the anchoring looks (data/presentation/anchor.toml,
 *  R1125, ui-map-interface.md §6.1). */
export const ANCHOR_LIMITS = {
  otherAlpha: 0.67,
  cullPadPx: 40,
  maxAlphaFill: 1,
  maxAlphaStroke: 1,
  heavyFromPx: 1.2,
  heavyKeep: 0.4,
} as const;

/** One anchoring look: the generic figures the recipe of that card
 *  spends. The TOML row's comment says what each figure means for that
 *  card. */
export interface AnchorRow {
  readonly rPx: number;
  readonly r2Px: number;
  readonly widthPx: number;
  readonly width2Px: number;
  readonly width3Px: number;
  readonly lengthPx: number;
  readonly length2Px: number;
  readonly length3Px: number;
  readonly xPx: number;
  readonly yPx: number;
  readonly alpha: number;
  readonly alpha2: number;
  readonly alpha3: number;
  readonly alpha4: number;
  readonly speed: number;
  readonly flashSec: number;
  readonly grow: number;
  readonly textPx: number;
  readonly count: number;
  readonly count2: number;
}

/** The anchoring looks, by look id (R1125). Every id of the list has a
 *  row; `render/anchor-styles.ts` resolves a look with no recipe yet to
 *  the AUTO look. */
export const ANCHOR_LOOKS = {
  'buoy-countdown': { rPx: 4, r2Px: 8, widthPx: 1.3, width2Px: 1.8, width3Px: 1.4, lengthPx: 3, length2Px: 15, length3Px: 4.5, xPx: 14, yPx: 3.33, alpha: 0.9, alpha2: 0.95, alpha3: 0.7, alpha4: 0.4, speed: 0, flashSec: 0.7, grow: 0.75, textPx: 9, count: 0, count2: 0 },
  'anchor-ring': { rPx: 19, r2Px: 0, widthPx: 2.5, width2Px: 2, width3Px: 1, lengthPx: 0, length2Px: 0, length3Px: 0, xPx: 0, yPx: 0, alpha: 0.25, alpha2: 0.18, alpha3: 0.9, alpha4: 0.6, speed: 0, flashSec: 0, grow: 0, textPx: 0, count: 0, count2: 0 },
  'cable-fluke': { rPx: 29, r2Px: 9, widthPx: 2.2, width2Px: 1.5, width3Px: 1.8, lengthPx: 7, length2Px: 3, length3Px: 4, xPx: 0, yPx: 0, alpha: 0.95, alpha2: 0.9, alpha3: 0.45, alpha4: 0.3, speed: 9, flashSec: 0.7, grow: 0.5, textPx: 0, count: 0, count2: 0 },
  'four-legs': { rPx: 26, r2Px: 11, widthPx: 2.2, width2Px: 1.4, width3Px: 1.6, lengthPx: 4.5, length2Px: 2, length3Px: 3.6, xPx: 0, yPx: 0, alpha: 0.95, alpha2: 0.9, alpha3: 0.45, alpha4: 0.4, speed: 1.2, flashSec: 0.6, grow: 0.5, textPx: 0, count: 4, count2: 0 },
  'tick-dial': { rPx: 21.5, r2Px: 17, widthPx: 2.4, width2Px: 2.6, width3Px: 1, lengthPx: 15, length2Px: 25, length3Px: 5, xPx: 0, yPx: 0, alpha: 0.95, alpha2: 0.3, alpha3: 0.55, alpha4: 0.4, speed: 3.2, flashSec: 0.7, grow: 0, textPx: 0, count: 12, count2: 0 },
  'corner-brackets': { rPx: 27, r2Px: 14, widthPx: 2.2, width2Px: 1.7, width3Px: 1, lengthPx: 6, length2Px: 4.5, length3Px: 2.6, xPx: 0, yPx: 0, alpha: 0.95, alpha2: 0.85, alpha3: 0.38, alpha4: 0.2, speed: 0.8, flashSec: 0.35, grow: 0.5, textPx: 0, count: 4, count2: 0 },
  'hex-pin': { rPx: 20.5, r2Px: 3, widthPx: 2.2, width2Px: 2, width3Px: 1.6, lengthPx: 4.6, length2Px: 2.7, length3Px: 2.6, xPx: 0, yPx: 0, alpha: 0.95, alpha2: 0.9, alpha3: 0.18, alpha4: 0.22, speed: 0.9, flashSec: 0.4, grow: 0.5, textPx: 0, count: 6, count2: 0 },
  'chart-anchor': { rPx: 10.5, r2Px: 2.1, widthPx: 1.8, width2Px: 1.7, width3Px: 1.2, lengthPx: 4.5, length2Px: 13.6, length3Px: 0, xPx: 12.67, yPx: 12, alpha: 0.98, alpha2: 0.95, alpha3: 0.2, alpha4: 0.55, speed: 0.8, flashSec: 0.4, grow: 0.6, textPx: 0, count: 0, count2: 0 },
  'ground-line': { rPx: 13, r2Px: 0, widthPx: 2.2, width2Px: 2, width3Px: 1.2, lengthPx: 5, length2Px: 3.4, length3Px: 4.4, xPx: 0, yPx: 14, alpha: 0.95, alpha2: 0.28, alpha3: 0.5, alpha4: 0.9, speed: 0, flashSec: 0.6, grow: 1.4, textPx: 0, count: 6, count2: 0 },
  'bubble-column': { rPx: 7.5, r2Px: 1.4, widthPx: 1.4, width2Px: 1.1, width3Px: 1, lengthPx: 34, length2Px: 8, length3Px: 30, xPx: 0, yPx: 13, alpha: 1, alpha2: 0.95, alpha3: 0.8, alpha4: 0.75, speed: 0.22, flashSec: 0.5, grow: 1.4, textPx: 0, count: 36, count2: 5 },
  'ring-teeth': { rPx: 19, r2Px: 3.2, widthPx: 2.5, width2Px: 2, width3Px: 3.4, lengthPx: 6, length2Px: 2.5, length3Px: 5.5, xPx: 0, yPx: 0, alpha: 0.25, alpha2: 0.18, alpha3: 0.9, alpha4: 0.6, speed: 0, flashSec: 0.7, grow: 0, textPx: 0, count: 4, count2: 0 },
} as Readonly<Record<string, AnchorRow>>;

/** The ink, the stroke floor, the cull pad and the alpha ceilings of the
 *  hold-fire looks (data/presentation/holdfire.toml, R1439,
 *  ui-map-interface.md §6.1.7). */
export const HOLD_FIRE_LIMITS = {
  ink: 0xa3cfe6,
  minScreenPx: 0.9,
  cullPadPx: 40,
  maxAlphaFill: 1,
  maxAlphaStroke: 1,
} as const;

/** One hold-fire look: the generic figures the recipe of that card
 *  spends. The TOML row's comment says what each figure means for that
 *  card. */
export interface HoldFireRow {
  readonly rPx: number;
  readonly r2Px: number;
  readonly widthPx: number;
  readonly width2Px: number;
  readonly lengthPx: number;
  readonly length2Px: number;
  readonly xPx: number;
  readonly yPx: number;
  readonly alpha: number;
  readonly alpha2: number;
  readonly alpha3: number;
  readonly periodSec: number;
  readonly period2Sec: number;
  readonly textPx: number;
  readonly count: number;
}

/** The hold-fire looks, by look id (R1439). Every id of the list has a
 *  row; `render/holdfire-styles.ts` resolves a look with no recipe yet
 *  to the AUTO look. */
export const HOLD_FIRE_LOOKS = {
  'safety-lock': { rPx: 24, r2Px: 20.5, widthPx: 1.5, width2Px: 1.2, lengthPx: 0, length2Px: 0, xPx: 0, yPx: 0, alpha: 0.55, alpha2: 0.55, alpha3: 0, periodSec: 20, period2Sec: 0, textPx: 0, count: 4 },
  'safed-guns': { rPx: 22, r2Px: 0, widthPx: 1.3, width2Px: 1.1, lengthPx: 4, length2Px: 3.2, xPx: 0, yPx: 0, alpha: 0.65, alpha2: 0.65, alpha3: 0, periodSec: 24, period2Sec: 0, textPx: 0, count: 2 },
  'restricted-line': { rPx: 23, r2Px: 19.8, widthPx: 1.2, width2Px: 1, lengthPx: 0, length2Px: 0, xPx: 4, yPx: 33, alpha: 0.3, alpha2: 0.25, alpha3: 0.8, periodSec: 40, period2Sec: 10, textPx: 9, count: 14 },
  'clamp': { rPx: 19, r2Px: 0, widthPx: 1.4, width2Px: 0, lengthPx: 4, length2Px: 3.5, xPx: 0, yPx: 0, alpha: 0.6, alpha2: 0, alpha3: 0, periodSec: 5, period2Sec: 0, textPx: 0, count: 0 },
  'hatch-shimmer': { rPx: 20, r2Px: 45, widthPx: 0.8, width2Px: 0, lengthPx: 4, length2Px: 6, xPx: 0, yPx: 0, alpha: 0.1, alpha2: 0.3, alpha3: 0.1, periodSec: 6, period2Sec: 0, textPx: 0, count: 11 },
} as Readonly<Record<string, HoldFireRow>>;

/** The inks, the stroke floor, the cull pad and the alpha ceilings of the
 *  tube reload looks (data/presentation/reload.toml, R1474,
 *  ui-map-interface.md §6.3). */
export const RELOAD_LIMITS = {
  ink: 0xa3cfe6,
  flash: 0xffffff,
  faint: 0x4c7b93,
  deep: 0x020b12,
  ground: 0x0a1620,
  minScreenPx: 0.9,
  cullPadPx: 80,
  maxAlphaFill: 1,
  maxAlphaStroke: 1,
} as const;

/** One tube reload look: where it draws against the hull, and every
 *  figure of its card by name. */
export interface ReloadRow {
  readonly under: boolean;
  readonly fig: Readonly<Record<string, number>>;
}

/** The tube reload looks, by look id (R1474). Every id of the list has a
 *  row; `render/reload-styles.ts` resolves a look with no recipe yet to
 *  the AUTO look. */
export const RELOAD_LOOKS = {
  'tube-gauge': {
    under: false,
    fig: {
      divider_alpha: 0.9,
      divider_width_px: 0.7,
      empty_letter_alpha: 0.7,
      empty_rim_alpha: 0.6,
      flash_sec: 0.7,
      frame_px: 1.5,
      frame_width_px: 1.2,
      gauge_px: 4,
      ground_alpha: 0.85,
      letter_alpha: 0.85,
      letter_px: 5,
      mag_alpha: 0.7,
      mag_px: 16,
      mag_y_px: -5,
      ready_alpha: 0.55,
      ready_flash_alpha: 0.45,
      rim_alpha: 0.7,
      rim_width_px: 0.8,
      slash_alpha: 0.8,
      slash_width_px: 0.9,
      split_count: 4,
      step_count: 3,
      text_px: 6.5,
      tube_alpha: 0.85,
      tube_px: 6,
      tube_y_px: -13,
      x_px: 17,
    },
  },
  'sweep-segments': {
    under: true,
    fig: {
      click_alpha: 0.55,
      click_px: 2,
      click_width_px: 1.2,
      flash_sec: 0.3,
      fresh_alpha: 1,
      fresh_share: 0.18,
      gap_rad: 0.16,
      lit_alpha: 0.8,
      lit_width_px: 1.8,
      r_px: 17.5,
      ready_alpha: 0.45,
      segment_count: 10,
      stub_alpha: 0.6,
      stub_rad: 0.12,
      stub_width_px: 1.2,
      unlit_alpha: 0.14,
      unlit_width_px: 1.6,
    },
  },
  'loading-slide': {
    under: false,
    fig: {
      band_px: 2,
      band_width_px: 0.9,
      dash_px: 1.5,
      door_alpha: 0.7,
      door_flash_alpha: 0.3,
      door_flash_px: 1,
      door_gap_px: 0.5,
      door_px: 2.6,
      door_width_px: 1.4,
      empty_alpha: 0.6,
      fade_in_ratio: 6,
      fired_sec: 0.6,
      flash_sec: 0.7,
      muzzle_alpha: 0.8,
      muzzle_grow_px: 3,
      muzzle_px: 3,
      muzzle_r_px: 1.5,
      muzzle_travel_px: 6,
      muzzle_width_px: 1,
      nose_px: 0.4,
      nose_r_px: 1.3,
      nose_width_px: 0.8,
      open_dx_px: 2.4,
      open_dy_px: 3.8,
      open_width_px: 1,
      round_alpha: 0.9,
      round_length_px: 7,
      round_r_px: 1.3,
      round_start_px: -17,
      slide_px: 15,
      tube_alpha: 0.75,
      tube_length_px: 11,
      tube_r_px: 2.1,
      tube_width_px: 0.9,
      tube_x_px: -3,
      tube_y_px: 14,
    },
  },
  'clock-digit': {
    under: false,
    fig: {
      bar_alpha: 0.8,
      bar_px: 1.6,
      bar_width_px: 1.2,
      empty_alpha: 0.7,
      empty_dash_px: 1.5,
      empty_width_px: 1,
      face_alpha: 0.75,
      fill_flash_alpha: 0.4,
      flash_sec: 0.7,
      hand_alpha: 0.95,
      hand_r_px: 2.6,
      hand_width_px: 1.2,
      r_px: 4.5,
      ready_fill_alpha: 0.28,
      ready_rim_alpha: 0.6,
      ready_rim_px: 2,
      ready_rim_width_px: 1.2,
      rim_alpha: 0.6,
      rim_flash_alpha: 0.4,
      rim_width_px: 1,
      sector_alpha: 0.22,
      text_alpha: 0.95,
      text_dy_px: 0.5,
      text_px: 5.5,
      tick_alpha: 0.95,
      tick_width_px: 1.2,
      tick_x0_px: -1.7,
      tick_x1_px: -0.4,
      tick_x2_px: 1.8,
      tick_y0_px: 0.1,
      tick_y1_px: 1.4,
      tick_y2_px: -1.3,
      x_px: 22,
      y_px: -10,
    },
  },
  'countdown-tag': {
    under: false,
    fig: {
      empty_alpha: 0.9,
      fired_sec: 0.5,
      flash_sec: 1.5,
      pad_px: 6,
      plate_alpha: 0.6,
      plate_px: 11,
      ready_alpha: 1,
      ready_plate_alpha: 0.75,
      reload_alpha: 0.95,
      rest_alpha: 0.55,
      rest_plate_alpha: 0.45,
      text_dy_px: 0.5,
      text_px: 7.5,
      y_px: 23,
    },
  },
  'round-label': {
    under: false,
    fig: {
      empty_alpha: 0.9,
      flash_sec: 0.8,
      ready_alpha: 0.95,
      reload_alpha: 0.45,
      strike_px: 1,
      strike_width_px: 0.9,
      text_px: 7.5,
      x_px: 17,
      y_px: 1,
    },
  },
  'pip-row': {
    under: false,
    fig: {
      diamond_ratio: 1.3,
      disc_ratio: 1.1,
      empty_alpha: 0.6,
      fill_ratio: 1.4,
      flash_sec: 0.7,
      hollow_alpha: 0.55,
      lit_alpha: 0.8,
      pitch_px: 4.8,
      r_px: 1.7,
      rim_floor_alpha: 0.45,
      rim_share: 0.6,
      rim_width_px: 0.8,
      ring_alpha: 0.8,
      ring_gap_px: 1,
      ring_travel_px: 4,
      ring_width_px: 1,
      row_count: 6,
      tube_alpha: 0.95,
      y_px: 19,
    },
  },
  'arc-bar': {
    under: true,
    fig: {
      bead_alpha: 0.95,
      bead_r_px: 1.7,
      empty_alpha: 0.55,
      empty_dash_px: 2.5,
      empty_gap_px: 3,
      empty_width_px: 1.4,
      flash_alpha: 0.6,
      flash_sec: 0.7,
      flash_width_px: 1.4,
      gap_rad: 0.66,
      progress_alpha: 0.8,
      r_px: 21,
      rest_alpha: 0.35,
      tick_alpha: 0.85,
      tick_dim_alpha: 0.4,
      tick_r2_px: 27,
      tick_r_px: 24,
      tick_width_px: 1.2,
      track_alpha: 0.14,
      width_px: 1.8,
    },
  },
} as const;

/** The inks, the mark ring, the damage of full weight, the life, the
 *  gradient cell and the alpha ceilings of the detonation looks
 *  (data/presentation/detonation.toml, R2079, ui-map-interface.md §6.3). */
export const DETONATION_LIMITS = {
  white: 0xffffff,
  fire: 0xffa864,
  amber: 0xffb454,
  hot: 0xff4030,
  plume: 0xffd9a0,
  foam: 0xcfe8f2,
  steel: 0xdff6ff,
  water: 0x0a2739,
  markRingPx: 6,
  powerDamage: 300,
  lifeSec: 3.6,
  glowCellPx: 128,
  seedBase: 1000,
  maxAlphaFill: 1,
  maxAlphaStroke: 1,
} as const;

/** The layout seed of each round, by its pack id (R2079): the card's own
 *  seed for the three rounds the card shows. */
export const DETONATION_SEEDS = {
  bulwark: 1693,
  countermine: 1847,
  disruptor: 1154,
  heavy: 1000,
  interceptor: 1616,
  light: 1077,
  pod: 1770,
  sailfish: 2155,
  seeker: 1539,
  sepia: 2078,
  stonefish: 1924,
  wrasse: 2001,
} as const;

/** One detonation look: every figure of its card that sets the time
 *  or the weight, by name. */
export interface DetonationRow {
  readonly fig: Readonly<Record<string, number>>;
}

/** The detonation looks, by look id (R2079). Every id of the list has a
 *  row; `render/detonation-styles.ts` resolves a look with no recipe yet
 *  to the AUTO look. */
export const DETONATION_LOOKS = {
  'tide-front': {
    fig: {
      amber_wake_alpha: 0.35,
      blast_front_sec: 0.1,
      blast_glow_power_screen_px: 2,
      blast_glow_screen_px: 3,
      blast_hold_sec: 0.6,
      blast_px_per_sec: 420,
      blast_rim_alpha: 0.9,
      blast_wake_sec: 0.25,
      cool_front_sec: 0.3,
      cool_px_per_sec: 105,
      cool_rim_alpha: 0.75,
      cool_wake_alpha: 0.06,
      cool_wake_power_alpha: 0.3,
      cool_wake_sec: 0.35,
      flash_from_sec: 0.02,
      flash_share: 0.75,
      flash_to_sec: 0.3,
      front_fade_sec: 0.25,
      hot_wake_alpha: 0.45,
      point_front_sec: 0.18,
      repair_hold_sec: 1.6,
      screen_calm_sec: 1,
      screen_curtain_alpha: 0.8,
      screen_end_sec: 3.5,
      screen_fill_alpha: 0.05,
      screen_front_alpha: 0.4,
      screen_front_fade_sec: 0.8,
      screen_front_sec: 0.3,
      screen_in_sec: 0.05,
      screen_out_sec: 2.8,
      screen_px_per_sec: 90,
      screen_wake_alpha: 0.16,
      slow_hold_sec: 2.1,
      slow_lag_sec: 0.1,
      slow_wake_alpha: 0.03,
      surge_echo_ratio: 1.4,
      surge_end_sec: 2.4,
      surge_fast_whisker_sec: 0.3,
      surge_front_fade_sec: 0.2,
      surge_front_sec: 0.06,
      surge_in_sec: 0.01,
      surge_out_sec: 1.7,
      surge_push_sec: 0.6,
      surge_px_per_sec: 400,
      surge_slow_whisker_sec: 0.6,
      surge_whisker_ratio: 2.4,
      sweep_hold_sec: 1.3,
      wake_fade_sec: 0.45,
    },
  },
  'fireball-rim': {
    fig: {
      bubble_alpha: 0.75,
      bubble_cold_life_sec: 1.6,
      bubble_count: 3,
      bubble_life_sec: 1,
      bubble_per_px: 0.3,
      bubble_rise_px_per_sec: 10,
      cool_from_sec: 0.05,
      cool_power_ratio: 0.3,
      cool_ratio: 1.3,
      cool_to_sec: 0.5,
      fireball_end_sec: 0.75,
      fireball_fade_sec: 0.16,
      fireball_power_sec: 0.3,
      fireball_share: 0.6,
      flash_cold_share: 0.5,
      flash_grow_sec: 0.06,
      flash_grow_share: 0.25,
      flash_light_sec: 0.12,
      flash_sec: 0.1,
      flash_share: 0.2,
      foam_alpha: 0.5,
      foam_count: 6,
      foam_end_sec: 1.5,
      foam_fade_sec: 0.3,
      foam_per_px: 0.16,
      front_per_px: 0.0028,
      front_sec: 0.16,
      ring_alpha: 0.95,
      ring_fade_sec: 0.3,
      ring_heavy_px: 3.2,
      ring_light_px: 1,
      ring_light_sec: 0.5,
      ring_max_share: 0.12,
      ring_screen_px: 1.2,
      screen_bubble_alpha: 0.5,
      screen_bubble_count: 3,
      screen_bubble_per_px: 0.25,
      screen_calm_sec: 0.8,
      screen_curtain_alpha: 0.75,
      screen_end_sec: 3.5,
      screen_flash_alpha: 0.3,
      screen_flash_sec: 0.25,
      screen_front_sec: 0.9,
      screen_in_sec: 0.15,
      screen_out_sec: 2.8,
      screen_veil_core_alpha: 0.07,
      screen_veil_hem_alpha: 0.2,
      screen_veil_ink_alpha: 0.09,
      slow_rim_alpha: 0.4,
      slow_rim_end_sec: 2.6,
      slow_rim_fade_sec: 1.4,
      surge_bubble_alpha: 0.85,
      surge_echo_share: 0.6,
      surge_end_sec: 2.6,
      surge_fast_ray_sec: 0.4,
      surge_flash_alpha: 0.45,
      surge_flash_sec: 0.12,
      surge_front_sec: 0.22,
      surge_in_sec: 0.02,
      surge_out_sec: 1.9,
      surge_pulse_sec: 0.65,
      surge_ray_count: 10,
      surge_ray_per_px: 0.35,
      surge_ring_alpha: 0.9,
      surge_ring_fade_sec: 0.25,
      surge_ring_screen_px: 1.6,
      surge_slow_ray_sec: 0.8,
      surge_streak_alpha: 0.55,
    },
  },
  'pressure-shell': {
    fig: {
      blast_end_sec: 0.6,
      blast_light_sec: 0.35,
      cool_end_sec: 2,
      cool_light_sec: 0.9,
      drag_rad: 0.35,
      flash_light_sec: 0.06,
      flash_sec: 0.08,
      front_per_px: 0.0011,
      front_sec: 0.05,
      ping_sec: 0.4,
      screen_end_sec: 3.5,
      screen_fill_alpha: 0.035,
      screen_front_sec: 0.6,
      screen_hem_alpha: 0.34,
      screen_hem_px: 4,
      screen_hem_wide_px: 12,
      screen_in_sec: 0.2,
      screen_ink_alpha: 0.2,
      screen_out_sec: 2.6,
      screen_widen_from_sec: 0.3,
      screen_widen_to_sec: 1.6,
      surge_echo_alpha: 0.6,
      surge_echo_run_sec: 0.35,
      surge_echo_sec: 0.15,
      surge_end_sec: 2.1,
      surge_in_sec: 0.01,
      surge_out_sec: 1.3,
      surge_saw_alpha: 0.9,
      surge_thrust_sec: 0.25,
      width_heavy_px: 5,
      width_light_px: 1.8,
    },
  },
  'cavitation-collapse': {
    fig: {
      flash_light_sec: 0.4,
      flash_sec: 0.12,
      front_per_px: 0.0022,
      front_sec: 0.12,
      jet_power_share: 0.3,
      jet_sec: 0.22,
      light_ratio: 2.2,
      rebound_alpha: 0.65,
      rebound_heavy_share: 0.5,
      rebound_light_share: 0.3,
      rebound_share: 0.55,
      screen_end_sec: 3.5,
      screen_front_ratio: 1.3,
      screen_glint_alpha: 0.45,
      screen_in_sec: 0.05,
      screen_out_sec: 2.8,
      screen_sheen_alpha: 0.25,
      screen_thin_sec: 1.5,
      screen_wall_alpha: 0.6,
      screen_wall_glow_alpha: 0.24,
      shock_sec: 0.35,
      surge_bubble_sec: 0.14,
      surge_collapse_sec: 0.28,
      surge_echo_share: 0.5,
      surge_end_sec: 2.3,
      surge_flash_alpha: 0.6,
      surge_flash_sec: 0.18,
      surge_in_sec: 0.01,
      surge_jet_alpha: 0.9,
      surge_jet_glow_alpha: 0.35,
      surge_jet_sec: 0.22,
      surge_out_sec: 1.6,
      surge_rebound_sec: 0.55,
      surge_wall_alpha: 0.85,
      surge_wall_glow_alpha: 0.4,
      wall_glow_alpha: 0.35,
      wall_heavy_px: 2.6,
      wall_light_px: 0.8,
      water_alpha: 0.5,
    },
  },
  'shattered-disc': {
    fig: {
      blast_life_sec: 0.9,
      blast_light_sec: 0.3,
      cold_flash_alpha: 0.3,
      cool_life_sec: 2.8,
      crack_light_sec: 0.1,
      crack_sec: 0.04,
      flash_alpha: 0.85,
      front_per_px: 0.0012,
      front_sec: 0.04,
      screen_end_sec: 3.5,
      screen_fill_alpha: 0.04,
      screen_front_sec: 0.8,
      screen_in_sec: 0.1,
      screen_out_sec: 2.8,
      screen_settle_from_sec: 0.1,
      screen_settle_sec: 0.8,
      screen_settle_spread_sec: 0.8,
      screen_shard_alpha: 0.09,
      screen_shard_spread_alpha: 0.06,
      surge_crack_sec: 0.08,
      surge_edge_alpha: 0.75,
      surge_end_sec: 2.1,
      surge_fast_fly_sec: 0.75,
      surge_flash_alpha: 0.3,
      surge_in_sec: 0.01,
      surge_out_sec: 1.4,
      surge_shard_alpha: 0.2,
      surge_slow_fly_sec: 1.5,
      surge_streak_alpha: 0.4,
      sweep_life_sec: 2.2,
    },
  },
  'sonar-return': {
    fig: {
      blast_end_sec: 0.9,
      blast_hold_sec: 0.12,
      blast_light_sec: 0.5,
      cool_end_sec: 2.8,
      cool_hold_sec: 0.35,
      front_per_px: 0.004,
      front_sec: 0.1,
      screen_band_alpha: 0.3,
      screen_band_hold_sec: 0.45,
      screen_dot_alpha: 0.4,
      screen_end_sec: 3.5,
      screen_hush_sec: 0.625,
      screen_in_sec: 0.02,
      screen_out_sec: 2.8,
      screen_rim_alpha: 0.2,
      screen_scan_alpha: 0.6,
      screen_trace_alpha: 0.45,
      screen_trace_fade_sec: 0.8,
      screen_trace_flash_alpha: 0.4,
      surge_chevron_alpha: 0.7,
      surge_dash_alpha: 0.95,
      surge_dash_count: 5,
      surge_dash_gap_sec: 0.18,
      surge_end_sec: 2.3,
      surge_fast_dash_ratio: 2.2,
      surge_front_ratio: 0.5,
      surge_in_sec: 0.01,
      surge_out_sec: 1.6,
      surge_scan_alpha: 0.9,
      surge_slow_dash_ratio: 0.9,
    },
  },
  'depth-charge-boil': {
    fig: {
      blast_boil_sec: 0.45,
      blast_fleck_sec: 1.4,
      blast_power_sec: 0.25,
      body_alpha: 0.8,
      body_fade_sec: 0.25,
      cold_body_alpha: 0.35,
      cool_boil_sec: 0.9,
      cool_fleck_sec: 2.9,
      flash_sec: 0.15,
      front_per_px: 0.0025,
      front_sec: 0.12,
      screen_calm_sec: 1.4,
      screen_core_alpha: 0.07,
      screen_edge_alpha: 0.55,
      screen_end_sec: 3.5,
      screen_fill_alpha: 0.13,
      screen_fleck_alpha: 0.6,
      screen_fleck_from_sec: 0.2,
      screen_fleck_spread_sec: 0.6,
      screen_front_ratio: 1.6,
      screen_in_sec: 0.1,
      screen_out_sec: 2.8,
      slick_end_sec: 1.4,
      slick_fade_sec: 0.5,
      slick_power_share: 0.5,
      slow_boil_sec: 1.8,
      surge_bow_alpha: 0.7,
      surge_bow_from_sec: 0.1,
      surge_bow_sec: 0.8,
      surge_end_sec: 2.4,
      surge_fast_fleck_sec: 0.45,
      surge_fill_alpha: 0.06,
      surge_fleck_alpha: 0.85,
      surge_fleck_from_sec: 0.03,
      surge_fleck_spread_sec: 0.9,
      surge_front_ratio: 0.5,
      surge_in_sec: 0.01,
      surge_out_sec: 1.6,
      surge_ring_alpha: 0.8,
      surge_ring_fade_sec: 0.4,
      surge_slow_fleck_sec: 0.9,
    },
  },
  'hex-stamp': {
    fig: {
      blast_hold_sec: 0.35,
      blast_light_sec: 0.4,
      flash_sec: 0.1,
      front_per_px: 0.0035,
      front_sec: 0.08,
      repair_hold_sec: 1.6,
      screen_end_sec: 3.5,
      screen_front_ratio: 2,
      screen_hex_alpha: 0.11,
      screen_in_sec: 0.05,
      screen_out_sec: 2.8,
      screen_rim_alpha: 0.2,
      screen_settle_sec: 0.6,
      slow_hold_sec: 2.2,
      surge_end_sec: 2.3,
      surge_fill_alpha: 0.12,
      surge_front_ratio: 0.6,
      surge_in_sec: 0.01,
      surge_lit_sec: 0.55,
      surge_out_sec: 1.6,
      surge_wave_gap_sec: 0.45,
      sweep_hold_sec: 1.2,
    },
  },
  'spore-drift': {
    fig: {
      blast_end_sec: 1.35,
      blast_front_sec: 0.18,
      blast_px_per_sec: 350,
      cool_front_sec: 0.3,
      cool_px_per_sec: 200,
      ember_power_sec: 0.2,
      ember_sec: 0.45,
      ember_spread_sec: 0.6,
      flash_sec: 0.22,
      flash_share: 0.6,
      halo_alpha: 0.18,
      mote_alpha: 0.35,
      mote_weight_alpha: 0.6,
      point_front_sec: 0.2,
      screen_end_sec: 3.5,
      screen_front_sec: 0.4,
      screen_halo_alpha: 0.13,
      screen_in_sec: 0.05,
      screen_out_sec: 2.8,
      screen_px_per_sec: 150,
      screen_swell_sec: 1.6,
      sink_px_per_sec: 3,
      sink_spread_px_per_sec: 4,
      surge_end_sec: 2.6,
      surge_fast_accel_ratio: 3.6,
      surge_front_sec: 0.12,
      surge_in_sec: 0.01,
      surge_out_sec: 1.9,
      surge_px_per_sec: 400,
      surge_slow_accel_ratio: 1.4,
      surge_streak_alpha: 0.6,
      surge_wait_sec: 0.1,
      surge_wait_spread_sec: 0.5,
      sweep_end_sec: 2.9,
    },
  },
  'drag-particles': {
    fig: {
      base_count: 10,
      blast_drag_sec: 0.05,
      blast_light_drag_sec: 0.07,
      blast_power_sec: 0.25,
      blast_px_per_sec: 400,
      blast_sec: 0.8,
      cool_fade_sec: 2.5,
      cool_sec: 3.4,
      count_per_px: 0.5,
      flash_sec: 0.25,
      point_count: 7,
      repair_drag_sec: 0.3,
      screen_core_alpha: 0.7,
      screen_drag_sec: 0.7,
      screen_end_sec: 3.5,
      screen_halo_alpha: 0.22,
      screen_in_sec: 0.05,
      screen_out_sec: 2.8,
      screen_particle_count: 12,
      screen_particle_per_px: 0.6,
      screen_veil_alpha: 0.05,
      slow_drag_sec: 0.38,
      surge_end_sec: 2.5,
      surge_fast_sec: 0.22,
      surge_head_alpha: 0.9,
      surge_in_sec: 0.01,
      surge_out_sec: 1.8,
      surge_particle_count: 14,
      surge_particle_per_px: 0.55,
      surge_slow_sec: 0.55,
      surge_trail_alpha: 0.55,
      surge_wave_gap_sec: 0.45,
      sweep_drag_sec: 0.2,
      trail_alpha: 0.55,
      turn_rad: 0.4,
    },
  },
} as const;

/** The faction marks (data/presentation/factionmarks.toml, R1568,
 *  ui-map-interface.md §11): the badge, the charge beside a hold
 *  (card 01), the pip astern of a hull (card 02) and the
 *  dash of the territory edge (card 04 row a). Every `Px` figure is a
 *  WORLD length. `dash` is keyed by faction id; an empty pattern is a
 *  solid line. */
export const FACTION_MARKS = {
  groundAlphaModern: 0.9,
  groundAlphaHistorical: 0.92,
  rimAlpha: 0.9,
  rimWidth: 1,
  chargeAlpha: 0.95,
  chargeWidth: 0.9,
  chargeShareModern: 0.6,
  chargeShareHistorical: 0.64,
  shieldAspect: 1.18,
  shieldChargeLift: 0.06,
  site: {
    sizePx: 11,
    holdModern: [12, 5],
    holdHistorical: [14, -3],
  },
  hull: { sizePx: 9, asternPx: 18 },
  edge: {
    dash: {
      1: [],
      2: [12, 5],
      3: [9, 4, 0.1, 4],
      4: [0.1, 4.6],
      5: [7, 4, 0.1, 3.6, 0.1, 4],
    } as Readonly<Record<number, readonly number[]>>,
  },
} as const;

// The livery of the Fleet Designer (R1252, ui-map-interface.md §6.1.6).
// One row per option of data/product/meta.toml [meta.fleet_designer.livery],
// joined onto its look of [presentation.livery]. `wire` is what a fleet
// carries on the wire, and 0 is NONE. The name is `livery_name_<code>` of
// the hubWardroom strings.
export const LIVERIES = [
  { code: 'centre_stripe', wire: 1, family: 'pattern', step: 'dark', inside: true, card: '060-01' },
  { code: 'twin_stripes', wire: 2, family: 'pattern', step: 'dark', inside: true, card: '060-02' },
  { code: 'bow_band', wire: 3, family: 'pattern', step: 'dark', inside: true, card: '060-03' },
  { code: 'stern_band', wire: 4, family: 'pattern', step: 'dark', inside: true, card: '060-04' },
  { code: 'inner_silhouette', wire: 5, family: 'pattern', step: 'dark', inside: true, card: '060-06' },
  { code: 'chevron', wire: 6, family: 'pattern', step: 'dark', inside: true, card: '060-07' },
  { code: 'dazzle', wire: 7, family: 'pattern', step: 'dark', inside: true, card: '060-08' },
  { code: 'rivets', wire: 8, family: 'pattern', step: 'dark', inside: true, card: '060-09' },
  { code: 'hatching', wire: 9, family: 'pattern', step: 'dark', inside: true, card: '060-10' },
  { code: 'tips', wire: 10, family: 'pattern', step: 'light', inside: true, card: '060-12' },
  { code: 'cockpit_diamond', wire: 11, family: 'decal', step: 'dark', inside: true, card: '061-01' },
  { code: 'cockpit_square', wire: 12, family: 'decal', step: 'dark', inside: true, card: '061-01' },
  { code: 'cockpit_triangle', wire: 13, family: 'decal', step: 'dark', inside: true, card: '061-01' },
  { code: 'cockpit_ring', wire: 14, family: 'decal', step: 'dark', inside: true, card: '061-01' },
  { code: 'cockpit_bar', wire: 15, family: 'decal', step: 'dark', inside: true, card: '061-01' },
  { code: 'tally_one', wire: 16, family: 'decal', step: 'dark', inside: true, card: '061-02' },
  { code: 'tally_two', wire: 17, family: 'decal', step: 'dark', inside: true, card: '061-02' },
  { code: 'tally_three', wire: 18, family: 'decal', step: 'dark', inside: true, card: '061-02' },
  { code: 'deck_ring', wire: 19, family: 'decal', step: 'dark', inside: true, card: '061-05' },
  { code: 'wing_band', wire: 20, family: 'decal', step: 'dark', inside: true, card: '061-11' },
] as const;

/** Every livery code. */
export type LiveryCode = (typeof LIVERIES)[number]['code'];

/** The inks of the three hull masters (060 and 061 notes). */
export const LIVERY_INK = {
  darkCut: 0.62,
  lightLift: 0.5,
  ownDarkAlpha: 0.92,
  ownLightAlpha: 0.6,
  hollowPatternAlpha: 0.55,
  hollowDecalAlpha: 0.7,
} as const;

/** The muted cues: an effect id whose row in data/presentation/sfx.toml
 *  is `false`. The audio director drops one of these before any fetch
 *  (audio.md §4.6). An empty set means every cue plays. */
export const SFX_MUTED: ReadonlySet<string> = new Set<string>([
  'sfx-beacon-pulse',
  'sfx-contact-lost',
  'sfx-contact-new',
  'sfx-deposit-depleted',
  'sfx-reload-complete',
  'sfx-ship-launched',
  'sfx-we-are-detected',
]);
/** The quick wheel (R1607, ui-map-interface.md §8 "Quick chat"), in chrome
 * px: the radii on a desktop and in the sheet form factor, the ring
 * between the hub and the sectors, the angle of the middle of line 1,
 * the type, the long press of the CHAT chip and where the wheel of a
 * telephone stands, as a share of the height. */
export const QUICK_WHEEL = {
  outerPx: 128, innerPx: 48, sheetOuterPx: 152, sheetInnerPx: 52,
  gapPx: 4, sectorGapRad: 0.012, startDeg: 135,
  wordPx: 9, keyPx: 8.5, hubPx: 9.5, linePx: 10.5, lineDy: 18, edgePx: 8,
  holdMs: 450, sheetCentreY: 0.475,
} as const;

/** The buzz (R1612, R1615): at most one buzz in BUZZ_GAP_MS, a hit once
 * in BUZZ_HIT_GAP_MS for each fleet, and the span and the box the
 * ALERTS card draws a pattern in. */
export const BUZZ_GAP_MS = 2000;
export const BUZZ_HIT_GAP_MS = 10000;
export const BUZZ_PATTERN_SPAN_MS = 1400;
export const BUZZ_PATTERN_W = 54;
export const BUZZ_PATTERN_H = 14;
/** One row a buzz event, in the order of the ALERTS card. `push` is the
 * push class, '' for the hit; `events` the event ids of that class
 * (data/product/events.toml); `pattern` is on, off, on in ms;
 * `feature` is the flag of a class behind one, '' for none: the ALERTS
 * card shows the row while the world latches the flag (R2637). */
export const BUZZ_EVENTS = [
  { id: 'siege', push: 'siege', pattern: [320, 120, 320, 120, 320], events: ['siege_attack', 'siege_defend', 'siege_window_soon', 'squad_rally'], feature: '' },
  { id: 'hold', push: 'hold', pattern: [180, 100, 180], events: ['hold_under_fire'], feature: '' },
  { id: 'hit', push: '', pattern: [60], events: [], feature: '' },
  { id: 'lost', push: 'fleet', pattern: [520], events: ['fleet_lost', 'fleet_lost_cargo'], feature: '' },
  { id: 'economy', push: 'economy', pattern: [40, 90, 40], events: ['queue_done', 'research_done'], feature: '' },
  { id: 'pirates', push: 'pirates', pattern: [120, 80, 120, 80, 120], events: ['boarding_started', 'hull_taken', 'monster_heard', 'pirate_contact'], feature: 'pirates' },
  { id: 'sea_mines', push: 'sea_mines', pattern: [60, 60, 60, 120, 260], events: ['sea_mine_struck', 'sea_mine_tripped', 'sea_object_lost'], feature: 'sapper' },
] as const;
/** One buzz event id. */
export type BuzzEventId = (typeof BUZZ_EVENTS)[number]['id'];
/** The calm events (R3085): events of a push class that name no threat.
 * They buzz BUZZ_CALM_PATTERN under the switch of their row, and the tab
 * icon draws no siege dot for them. */
export const BUZZ_CALM_EVENTS: readonly string[] = ['siege_attack', 'siege_window_soon'];
export const BUZZ_CALM_PATTERN: readonly number[] = [120];

/** The alert weight of a notice by event id (round 088 card 17, R1753,
 * R2637): 1 a line with no GO TO word, 2 a GO TO in the dark face. An
 * event the table leaves out keeps the line of today. */
export const ALERT_WEIGHTS: Readonly<Record<string, 1 | 2>> = {
  boarding_started: 2,
  boarding_stopped: 1,
  fragment_found: 1,
  hull_taken: 2,
  monster_heard: 2,
  pirate_contact: 2,
};

/** The two live regions of the game page (R2052): the polite region
 * speaks at most once in LIVE_GAP_MS and at most LIVE_LINES lines at
 * once, and no words twice inside LIVE_REPEAT_MS. */
export const LIVE_GAP_MS = 1500;
export const LIVE_LINES = 3;
export const LIVE_REPEAT_MS = 4000;
/** The event ids that speak in the assertive region: the events of the
 * push classes `urgent_push` (data/product/events.toml). */
export const LIVE_URGENT_EVENTS: readonly string[] = ['fleet_lost', 'fleet_lost_cargo', 'hold_under_fire', 'siege_attack', 'siege_defend', 'siege_window_soon', 'squad_rally'];

/** The network check page (fault-reports.md §9, R1707): the bounds of
 * each measurement, and the game host the page derives from its own. */
export const NETTEST = {
  timeoutMs: 5000, slowMs: 1000, idleSec: 40, recoverTimeoutMs: 15000,
  wsTimeoutMs: 8000, latencySamples: 5,
  playHostPrefix: "g1.play.", gameWssPort: 8443, arcadeWssPort: 8444,
  gameInstance: "i1", devGamePort: 8090,
} as const;

/** The lab shell (lab-shell.md, round 094 cards 01 and 02): the figures
 * the three labs share. `labkit/labkit.css` reads the same figures. */
export const LAB = {
  barPx: 44, columnPx: 340, foldHeadPx: 32, valuePx: 56, sliderPx: 68, sliderFingerPx: 96, noteLines: 2,
  trackPx: 4, thumbPx: 12, thumbFingerPx: 20, legendPx: 232, legendRowPx: 24,
  menuPx: 236, tabMinPx: 62, sheetLinePx: 52, sheetRaisedVh: 55, choiceSegMax: 4, zoomStep: 1.25,
  presetNameMax: 60,
} as const;

/** The count thresholds of a choice control (ui-map-interface.md §18,
 * R2011): `ui/choice/choice.ts` picks the form of a value or a filter
 * from them. */
export const CHOICE = { segMax: 4, segMaxShort: 10, listMax: 6 } as const;

/** The chrome of the map designer (arcade.md §10.3, round 094 cards 07
 * and 08). `designer/designer.css` reads the same lengths. */
export const DESIGNER_CHROME = {
  railPx: 48, rowPx: 44, pinPx: 18,
  zoomMax: 4, focusZoom: 2, zoomOutStops: 2,
  wheelZoomRate: 0.01, wheelLinePx: 16,
  loadThumbWPx: 120, loadThumbHPx: 76,
  guardReachStepPx: 10,
  currentScaleStep: 0.25,
  laidHeadingStepDeg: 15,
  denWaveStepSec: 30, lairRespawnStepSec: 30, lairBountyStep: 50,
  pillCharsMax: 32,
  sovRockDash: [2.5, 2] as readonly [number, number],
} as const;

/** The ☸ OPTIONS menu (ui-map-interface.md §13, R1731, R1754, R1757): the
 * heights of the telephone menu at which its root packs its parts tighter,
 * and the faction badge of the commander row and of the ACCOUNT card. */
export const OPTIONS_MENU = {
  phoneFullH: 740, phoneMidH: 600, commanderBadgePx: 22, accountBadgePx: 36,
} as const;

/** The frame caps of the map (ui-map-interface.md §10.5, R1755): the open cap,
 * and the cap under the full telephone sheet. */
export const FRAME_LOOP = {
  maxFps: 60, sheetFps: 20,
} as const;

/** The idle sea view of the map (ui-map-interface.md §13, R2865): the five
 * defaults of the SEA VIEW section (R2881), the range of its bar in minutes, the
 * countdown bands (the least idle time in minutes, the span in seconds,
 * R2893) and the blend in ms with its CSS curve. */
export const SEAVIEW_IDLE = {
  defaultOn: true, defaultMin: 10, minMin: 1, maxMin: 60, stepMin: 1,
  veilOn: false, lifeOn: true, powerOn: false,
  warn: [{ fromMin: 1, s: 10 }, { fromMin: 2, s: 30 }, { fromMin: 5, s: 60 }],
  fadeInMs: 2400, fadeOutMs: 500,
  fadeEase: 'cubic-bezier(0.65, 0, 0.35, 1)',
} as const;

/** The lead within which the tile of a held seat states the next
 * window, in wall seconds (ui-map-interface.md §16.6, R1752). */
export const HUB_SEAT_WARN_SEC = 3600;

/** The queue work, in wall seconds, at or under which the QUEUE row of
 * a seat card takes the warning ink (ui-map-interface.md §16.6). */
export const HUB_QUEUE_WARN_SEC = 10800;

/** The faction badge before the name in the hub header, in chrome
 * px (ui-map-interface.md §16.3, R1781). */
export const HUB_HEADER_BADGE_PX = 16;

/** The founding form of CLAN › START ONE (ui-map-interface.md §16.11,
 * R2155): the badge of a faction card shown and drawn in chrome px,
 * the border sample in world px, and the founding chart. */
export const HUB_FOUND = {
  badgePx: 56,
  badgeDrawPx: 24,
  dashPx: 96,
  chartCols: 9,
  chartRows: 7,
  chartRing: 2,
  chartZoom: 0.9,
} as const;


/**
 * Every key the client answers (data/presentation/keybindings.toml,
 * R853). The client-only lane (R312): the handlers, the ⌨ KEYS panel
 * and the arcade key sheet read these rows, and the rendered key
 * tables of ui-map-interface.md §9 and arcade.md read the same ones.
 *
 * A ranged row is already written out: `1` to the control-group slot
 * count, and `{max}` in a label replaced by that count. `hidden`
 * drops the row from the in-game panel, and `altgr` says the claims
 * are AltGr characters a handler must read before its chord bail
 * (R456).
 */
/** One binding of data/presentation/keybindings.toml. */
export interface KeyBinding {
  readonly group: string;
  readonly label: string;
  readonly claims: readonly string[];
  readonly hidden: boolean;
  readonly altgr: boolean;
}
export const KEYS = {
  map: {
    heat: { group: 'view', label: 'alt-1…0', claims: ['alt-Digit1', 'alt-Digit2', 'alt-Digit3', 'alt-Digit4', 'alt-Digit5', 'alt-Digit6', 'alt-Digit7', 'alt-Digit8', 'alt-Digit9', 'alt-Digit0'], hidden: false, altgr: false },
    depth_look: { group: 'map', label: '\\', claims: ['\\'], hidden: false, altgr: true },
    escape: { group: 'map', label: 'esc', claims: ['Escape'], hidden: false, altgr: false },
    marker: { group: 'map', label: 'alt-click', claims: ['alt-Click'], hidden: false, altgr: false },
    quick: { group: 'map', label: 'hold ,', claims: ['Comma'], hidden: false, altgr: false },
    home: { group: 'map', label: 'space', claims: ['Space'], hidden: false, altgr: false },
    photo: { group: 'map', label: 'shift-p', claims: ['P'], hidden: false, altgr: false },
    help: { group: 'map', label: '?', claims: ['?'], hidden: false, altgr: false },
    fire: { group: 'orders', label: 'f', claims: ['f'], hidden: false, altgr: false },
    hunt: { group: 'orders', label: 'a', claims: ['a'], hidden: false, altgr: false },
    patrol: { group: 'orders', label: 'w', claims: ['w'], hidden: false, altgr: false },
    escort: { group: 'orders', label: 'e', claims: ['e'], hidden: false, altgr: false },
    defend: { group: 'orders', label: 'h', claims: ['h'], hidden: false, altgr: false },
    return: { group: 'orders', label: 'r', claims: ['r'], hidden: false, altgr: false },
    anchor: { group: 'orders', label: 'q', claims: ['q'], hidden: false, altgr: false },
    scan: { group: 'orders', label: 's', claims: ['s'], hidden: false, altgr: false },
    gather: { group: 'orders', label: 'g', claims: ['g'], hidden: false, altgr: false },
    move: { group: 'orders', label: 'v', claims: ['v'], hidden: false, altgr: false },
    lane: { group: 'orders', label: 'shift-v', claims: ['V'], hidden: false, altgr: false },
    hold_fire: { group: 'orders', label: 'b', claims: ['b'], hidden: false, altgr: false },
    group_recall: { group: 'groups', label: '1–6', claims: ['Digit1', 'Digit2', 'Digit3', 'Digit4', 'Digit5', 'Digit6'], hidden: false, altgr: false },
    group_assign: { group: 'groups', label: 'ctrl/shift-1…6', claims: ['ctrl-Digit1', 'ctrl-Digit2', 'ctrl-Digit3', 'ctrl-Digit4', 'ctrl-Digit5', 'ctrl-Digit6', 'shift-Digit1', 'shift-Digit2', 'shift-Digit3', 'shift-Digit4', 'shift-Digit5', 'shift-Digit6'], hidden: false, altgr: false },
    menu_next: { group: 'menus', label: 'tab', claims: ['Tab'], hidden: false, altgr: false },
    menu_prev: { group: 'menus', label: 'shift-tab', claims: ['shift-Tab'], hidden: false, altgr: false },
    menu_focus: { group: 'menus', label: 'enter', claims: ['Enter'], hidden: false, altgr: false },
    row_step: { group: 'menus', label: '↑ ↓', claims: ['ArrowUp', 'ArrowDown'], hidden: false, altgr: false },
    row_ends: { group: 'menus', label: 'home end', claims: ['Home', 'End'], hidden: false, altgr: false },
    section_next: { group: 'menus', label: 'ctrl-tab', claims: ['ctrl-Tab'], hidden: false, altgr: false },
    section_prev: { group: 'menus', label: 'ctrl-shift-tab', claims: ['ctrl-shift-Tab'], hidden: false, altgr: false },
    sections: { group: 'menus', label: 'shift-alt-1…n', claims: ['shift-alt-Digit1', 'shift-alt-Digit2', 'shift-alt-Digit3', 'shift-alt-Digit4', 'shift-alt-Digit5', 'shift-alt-Digit6', 'shift-alt-Digit7', 'shift-alt-Digit8', 'shift-alt-Digit9'], hidden: false, altgr: false },
    music: { group: 'menus', label: 'm', claims: ['m'], hidden: false, altgr: false },
    inbox: { group: 'menus', label: 'shift-i', claims: ['I'], hidden: false, altgr: false },
    base_tubes: { group: 'base', label: 'd', claims: ['d'], hidden: false, altgr: false },
    casino_hit: { group: 'casino', label: 'y', claims: ['y'], hidden: false, altgr: false },
    casino_stand: { group: 'casino', label: 'n', claims: ['n'], hidden: false, altgr: false },
    casino_double: { group: 'casino', label: 'z', claims: ['z'], hidden: false, altgr: false },
    casino_fold: { group: 'casino', label: 'x', claims: ['x'], hidden: false, altgr: false },
    casino_call: { group: 'casino', label: 'c', claims: ['c'], hidden: false, altgr: false },
    casino_bet: { group: 'casino', label: 'p', claims: ['p'], hidden: false, altgr: false },
    casino_spin: { group: 'casino', label: 't', claims: ['t'], hidden: false, altgr: false },
    casino_rebet: { group: 'casino', label: '=', claims: ['Equal'], hidden: false, altgr: false },
    casino_take_back: { group: 'casino', label: '⌫', claims: ['Backspace'], hidden: false, altgr: false },
    casino_clear: { group: 'casino', label: 'shift-⌫', claims: ['shift-Backspace'], hidden: false, altgr: false },
    kraken: { group: 'debug', label: '.', claims: ['.'], hidden: false, altgr: false },
    admin: { group: 'debug', label: '`', claims: ['`'], hidden: false, altgr: false },
    fluff: { group: 'layers', label: 'u', claims: ['u'], hidden: true, altgr: false },
    sonar_visuals: { group: 'layers', label: 'i', claims: ['i'], hidden: true, altgr: false },
    screenshake: { group: 'layers', label: 'o', claims: ['o'], hidden: true, altgr: false },
    sov_fills: { group: 'layers', label: 'j', claims: ['j'], hidden: true, altgr: true },
    sov_borders: { group: 'layers', label: 'k', claims: ['k'], hidden: true, altgr: true },
    terrain: { group: 'layers', label: 'l', claims: ['l'], hidden: true, altgr: true },
    hex_fills: { group: 'layers', label: '[', claims: ['['], hidden: true, altgr: true },
    hex_borders: { group: 'layers', label: ']', claims: [']'], hidden: true, altgr: true },
  },
  quick: {
    help: { group: 'calls', label: '1', claims: ['Digit1'], hidden: false, altgr: false },
    attack: { group: 'calls', label: '2', claims: ['Digit2'], hidden: false, altgr: false },
    defend: { group: 'calls', label: '3', claims: ['Digit3'], hidden: false, altgr: false },
    enemy: { group: 'calls', label: '4', claims: ['Digit4'], hidden: false, altgr: false },
    siege: { group: 'plans', label: '5', claims: ['Digit5'], hidden: false, altgr: false },
    coming: { group: 'plans', label: '6', claims: ['Digit6'], hidden: false, altgr: false },
    withdraw: { group: 'plans', label: '7', claims: ['Digit7'], hidden: false, altgr: false },
    wait: { group: 'plans', label: '8', claims: ['Digit8'], hidden: false, altgr: false },
    regroup: { group: 'plans', label: '9', claims: ['Digit9'], hidden: false, altgr: false },
    yes: { group: 'answers', label: '0', claims: ['Digit0'], hidden: false, altgr: false },
    no: { group: 'answers', label: '-', claims: ['Minus'], hidden: false, altgr: false },
    well_done: { group: 'answers', label: '=', claims: ['Equal'], hidden: false, altgr: false },
  },
  card: {
    deploy: { group: 'docked', label: 'd', claims: ['d'], hidden: false, altgr: false },
    repair: { group: 'docked', label: 'r', claims: ['r'], hidden: false, altgr: false },
    steer_port: { group: 'helm', label: '←', claims: ['ArrowLeft'], hidden: false, altgr: false },
    steer_starboard: { group: 'helm', label: '→', claims: ['ArrowRight'], hidden: false, altgr: false },
    telegraph_up: { group: 'helm', label: '↑', claims: ['ArrowUp'], hidden: false, altgr: false },
    telegraph_down: { group: 'helm', label: '↓', claims: ['ArrowDown'], hidden: false, altgr: false },
  },
  arcade: {
    fire: { group: 'orders', label: 'f', claims: ['f'], hidden: false, altgr: false },
    hunt: { group: 'orders', label: 'a', claims: ['a'], hidden: false, altgr: false },
    patrol: { group: 'orders', label: 'w', claims: ['w'], hidden: false, altgr: false },
    escort: { group: 'orders', label: 'e', claims: ['e'], hidden: false, altgr: false },
    move: { group: 'orders', label: 'v', claims: ['v'], hidden: false, altgr: false },
    gather: { group: 'orders', label: 'g', claims: ['g'], hidden: false, altgr: false },
    hold: { group: 'orders', label: 'h', claims: ['h'], hidden: false, altgr: false },
    return: { group: 'orders', label: 'r', claims: ['r'], hidden: false, altgr: false },
    anchor: { group: 'orders', label: 'q', claims: ['q'], hidden: false, altgr: false },
    scan: { group: 'orders', label: 's', claims: ['s'], hidden: false, altgr: false },
    next_round: { group: 'map', label: 'n', claims: ['n'], hidden: false, altgr: false },
    hold_fire: { group: 'orders', label: 'b', claims: ['b'], hidden: false, altgr: false },
    group_assign: { group: 'map', label: 'ctrl/shift-1…6', claims: ['ctrl-Digit1', 'ctrl-Digit2', 'ctrl-Digit3', 'ctrl-Digit4', 'ctrl-Digit5', 'ctrl-Digit6', 'shift-Digit1', 'shift-Digit2', 'shift-Digit3', 'shift-Digit4', 'shift-Digit5', 'shift-Digit6'], hidden: false, altgr: false },
    group_recall: { group: 'map', label: '1…6', claims: ['Digit1', 'Digit2', 'Digit3', 'Digit4', 'Digit5', 'Digit6'], hidden: false, altgr: false },
    base: { group: 'map', label: 'space', claims: ['Space'], hidden: false, altgr: false },
    row_step: { group: 'map', label: '↑ ↓', claims: ['ArrowUp', 'ArrowDown'], hidden: false, altgr: false },
    row_ends: { group: 'map', label: 'home end', claims: ['Home', 'End'], hidden: false, altgr: false },
    base_fire: { group: 'map', label: 'd', claims: ['d'], hidden: false, altgr: false },
    drill_next: { group: 'map', label: 'enter', claims: ['Enter'], hidden: false, altgr: false },
    escape: { group: 'map', label: 'esc', claims: ['Escape'], hidden: false, altgr: false },
    help: { group: 'map', label: '?', claims: ['?'], hidden: false, altgr: false },
  },
  designer: {
    water: { group: 'tools', label: '1', claims: ['Digit1'], hidden: false, altgr: false },
    ridge: { group: 'tools', label: '2', claims: ['Digit2'], hidden: false, altgr: false },
    trench: { group: 'tools', label: '3', claims: ['Digit3'], hidden: false, altgr: false },
    base: { group: 'tools', label: '4', claims: ['Digit4'], hidden: false, altgr: false },
    fbase: { group: 'tools', label: '5', claims: ['Digit5'], hidden: false, altgr: false },
    field: { group: 'tools', label: '6', claims: ['Digit6'], hidden: false, altgr: false },
    throne: { group: 'tools', label: 't', claims: ['t'], hidden: false, altgr: false },
    ward: { group: 'tools', label: 'w', claims: ['w'], hidden: false, altgr: false },
    battery: { group: 'tools', label: 'b', claims: ['b'], hidden: false, altgr: false },
    spire: { group: 'tools', label: 's', claims: ['s'], hidden: false, altgr: false },
    breakwater: { group: 'tools', label: 'r', claims: ['r'], hidden: false, altgr: false },
    den: { group: 'tools', label: 'p', claims: ['p'], hidden: false, altgr: false },
    lair: { group: 'tools', label: 'l', claims: ['l'], hidden: false, altgr: false },
    seamine: { group: 'tools', label: 'm', claims: ['m'], hidden: false, altgr: false },
    deployable: { group: 'tools', label: 'd', claims: ['d'], hidden: false, altgr: false },
    fleet: { group: 'tools', label: '7', claims: ['Digit7'], hidden: false, altgr: false },
    sov: { group: 'tools', label: '8', claims: ['Digit8'], hidden: false, altgr: false },
    marker: { group: 'tools', label: '9', claims: ['Digit9'], hidden: false, altgr: false },
    fairway: { group: 'tools', label: 'f', claims: ['f'], hidden: false, altgr: false },
    erase: { group: 'tools', label: '0', claims: ['Digit0'], hidden: false, altgr: false },
    inspect: { group: 'tools', label: 'i', claims: ['i'], hidden: false, altgr: false },
    undo: { group: 'edit', label: 'ctrl-z', claims: ['ctrl-z', 'meta-z'], hidden: false, altgr: false },
    redo: { group: 'edit', label: 'ctrl-shift-z', claims: ['ctrl-shift-z', 'meta-shift-z', 'ctrl-y'], hidden: false, altgr: false },
    escape: { group: 'edit', label: 'esc', claims: ['Escape'], hidden: false, altgr: false },
    pan: { group: 'view', label: 'space', claims: ['Space'], hidden: false, altgr: false },
  },
  film: {
    close: { group: 'film', label: 'esc', claims: ['Escape'], hidden: false, altgr: false },
    play: { group: 'film', label: 'space', claims: ['Space'], hidden: false, altgr: false },
    restart: { group: 'film', label: 'home', claims: ['Home'], hidden: false, altgr: false },
  },
  viewer: {
    play: { group: 'transport', label: 'space', claims: ['Space'], hidden: false, altgr: false },
    exit: { group: 'transport', label: 'esc', claims: ['Escape'], hidden: false, altgr: false },
    restart: { group: 'transport', label: 'home', claims: ['Home'], hidden: false, altgr: false },
    back: { group: 'transport', label: 'j', claims: ['j'], hidden: false, altgr: false },
    forward: { group: 'transport', label: 'l', claims: ['l'], hidden: false, altgr: false },
    step_back: { group: 'transport', label: '←', claims: ['ArrowLeft'], hidden: false, altgr: false },
    step_forward: { group: 'transport', label: '→', claims: ['ArrowRight'], hidden: false, altgr: false },
    last: { group: 'transport', label: 'end', claims: ['End'], hidden: false, altgr: false },
    prev_keyframe: { group: 'transport', label: ',', claims: [','], hidden: false, altgr: false },
    next_keyframe: { group: 'transport', label: '.', claims: ['.'], hidden: false, altgr: false },
    slower: { group: 'transport', label: '-', claims: ['-'], hidden: false, altgr: false },
    faster: { group: 'transport', label: '+', claims: ['+'], hidden: false, altgr: false },
    live: { group: 'transport', label: 'e', claims: ['e'], hidden: false, altgr: false },
    inputs: { group: 'transport', label: 'i', claims: ['i'], hidden: false, altgr: false },
    keys: { group: 'transport', label: '?', claims: ['?'], hidden: false, altgr: false },
    omniscient: { group: 'channels', label: '0', claims: ['Digit0'], hidden: false, altgr: false },
    seat: { group: 'channels', label: '1…9', claims: ['Digit1', 'Digit2', 'Digit3', 'Digit4', 'Digit5', 'Digit6', 'Digit7', 'Digit8', 'Digit9'], hidden: false, altgr: false },
  },
  terrainlab: {
    swap: { group: 'compare', label: 'b', claims: ['b'], hidden: false, altgr: false },
    split: { group: 'compare', label: 's', claims: ['s'], hidden: false, altgr: false },
    dice: { group: 'seed', label: 'r', claims: ['r'], hidden: false, altgr: false },
    prev: { group: 'seed', label: ',', claims: [','], hidden: false, altgr: false },
    next: { group: 'seed', label: '.', claims: ['.'], hidden: false, altgr: false },
    fit: { group: 'view', label: 'f', claims: ['f'], hidden: false, altgr: false },
    panel: { group: 'view', label: 'p', claims: ['p'], hidden: false, altgr: false },
  },
  battlelab: {
    fight: { group: 'run', label: 'f', claims: ['f'], hidden: false, altgr: false },
    many: { group: 'run', label: 'm', claims: ['m'], hidden: false, altgr: false },
    watch: { group: 'view', label: 'w', claims: ['w'], hidden: false, altgr: false },
    column: { group: 'view', label: 'p', claims: ['p'], hidden: false, altgr: false },
  },
  sonarlab: {
    motion: { group: 'run', label: 'm', claims: ['m'], hidden: false, altgr: false },
    remove: { group: 'run', label: 'x', claims: ['x'], hidden: false, altgr: false },
    slower: { group: 'run', label: ',', claims: [','], hidden: false, altgr: false },
    faster: { group: 'run', label: '.', claims: ['.'], hidden: false, altgr: false },
    fit: { group: 'view', label: 'f', claims: ['f'], hidden: false, altgr: false },
    column: { group: 'view', label: 'p', claims: ['p'], hidden: false, altgr: false },
  },
  workshop: {
    prev: { group: 'walk', label: '←', claims: ['ArrowLeft'], hidden: false, altgr: false },
    next: { group: 'walk', label: '→', claims: ['ArrowRight'], hidden: false, altgr: false },
    first: { group: 'walk', label: 'home', claims: ['Home'], hidden: false, altgr: false },
    last: { group: 'walk', label: 'end', claims: ['End'], hidden: false, altgr: false },
  },
  hub: {
    prev: { group: 'walk', label: '← ↑', claims: ['ArrowLeft', 'ArrowUp'], hidden: false, altgr: false },
    next: { group: 'walk', label: '→ ↓', claims: ['ArrowRight', 'ArrowDown'], hidden: false, altgr: false },
    first: { group: 'walk', label: 'home', claims: ['Home'], hidden: false, altgr: false },
    last: { group: 'walk', label: 'end', claims: ['End'], hidden: false, altgr: false },
  },
  seaidle: {
    free: { group: 'tour', label: 'space', claims: ['Space'], hidden: false, altgr: false },
  },
} as const;

/** One binding id of the map surface. */
export type MapKeyId = keyof typeof KEYS.map;
/** One binding id of the quick surface. */
export type QuickKeyId = keyof typeof KEYS.quick;
/** One binding id of the card surface. */
export type CardKeyId = keyof typeof KEYS.card;
/** One binding id of the arcade surface. */
export type ArcadeKeyId = keyof typeof KEYS.arcade;
/** One binding id of the designer surface. */
export type DesignerKeyId = keyof typeof KEYS.designer;
/** One binding id of the film surface. */
export type FilmKeyId = keyof typeof KEYS.film;
/** One binding id of the viewer surface. */
export type ViewerKeyId = keyof typeof KEYS.viewer;
/** One binding id of the terrainlab surface. */
export type TerrainlabKeyId = keyof typeof KEYS.terrainlab;
/** One binding id of the battlelab surface. */
export type BattlelabKeyId = keyof typeof KEYS.battlelab;
/** One binding id of the sonarlab surface. */
export type SonarlabKeyId = keyof typeof KEYS.sonarlab;
/** One binding id of the workshop surface. */
export type WorkshopKeyId = keyof typeof KEYS.workshop;
/** One binding id of the hub surface. */
export type HubKeyId = keyof typeof KEYS.hub;
/** One binding id of the seaidle surface. */
export type SeaidleKeyId = keyof typeof KEYS.seaidle;

/** The group ids of each surface, in the order the reference prints them. */
export const KEY_GROUPS = {
  map: ['orders', 'map', 'groups', 'menus', 'view', 'base', 'casino', 'debug', 'layers'],
  quick: ['calls', 'plans', 'answers'],
  card: ['docked', 'helm'],
  arcade: ['orders', 'map'],
  designer: ['tools', 'edit', 'view'],
  film: ['film'],
  viewer: ['transport', 'channels'],
  terrainlab: ['compare', 'seed', 'view'],
  battlelab: ['run', 'view'],
  sonarlab: ['run', 'view'],
  workshop: ['walk'],
  hub: ['walk'],
  seaidle: ['tour'],
} as const;
